//js code packages
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

//generic components and js functions
import * as JSFUNC from "../../Library/JSFUNC.js";
import * as LibraryReact from "../../Library/LibraryReact.js";
import * as CEGeneralReact from "../../CaptureExecGeneral/CEGeneralReact.js";
import * as CEComplexReact from "../../CaptureExecGeneral/CEComplexReact.js";
import * as CEIconsReact from "../../CaptureExecGeneral/CEIconsReact.js";

import * as CapturesReact from "../Captures/CapturesReact.js";

import DivexecMobx from './DivexecMobx.js';


//=============================================================================================================================================================================
//=============================================================================================================================================================================

//Sales Performance
export function SalesPerformance() {
  return(
    <PerformanceDivisionsAndUsersListAndGoalsAndGraphsPage
      p_divexecPerformanceTrueUserMyPerformanceFalse={true}
    />
  );
}


export const PerformanceDivisionsAndUsersListAndGoalsAndGraphsPage = inject("CaptureExecMobx", "DivexecMobx", "UserMobx")(observer(
class PerformanceDivisionsAndUsersListAndGoalsAndGraphsPage extends Component { //props: p_divexecPerformanceTrueUserMyPerformanceFalse
  componentDidMount() {
    const p_divexecPerformanceTrueUserMyPerformanceFalse = this.props.p_divexecPerformanceTrueUserMyPerformanceFalse;

    const o_userID = this.props.UserMobx.o_userID;
    const c_userDivisionID = this.props.UserMobx.c_userDivisionID;
    
    var userTrueDivisionFalse = false;
    var preselectedUserOrDivisionID = -1;
    if(p_divexecPerformanceTrueUserMyPerformanceFalse) { //divexec performance
      userTrueDivisionFalse = false;
      preselectedUserOrDivisionID = c_userDivisionID; //preselect logged in user's division when divexec subtab is selected
    }
    else { //user my performance
      userTrueDivisionFalse = true;
      preselectedUserOrDivisionID = o_userID;
    }
    this.props.DivexecMobx.a_performance_set_selected_user_or_division_id(userTrueDivisionFalse, preselectedUserOrDivisionID);
  }

  render() {
    const p_divexecPerformanceTrueUserMyPerformanceFalse = this.props.p_divexecPerformanceTrueUserMyPerformanceFalse;

    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const o_performanceMobileScreen = this.props.DivexecMobx.o_performanceMobileScreen;
    const o_performanceSelectedUserTrueDivisionFalse = this.props.DivexecMobx.o_performanceSelectedUserTrueDivisionFalse;
    const o_performanceSelectedUserOrDivisionID = this.props.DivexecMobx.o_performanceSelectedUserOrDivisionID;
    const customPerformanceTabSelectedTF = this.props.UserMobx.c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF;
    const o_performanceSelectedCustomPerformanceOptionID = this.props.DivexecMobx.o_performanceSelectedCustomPerformanceOptionID;
    const c_userDivisionFirewalledDivisionIDsCommaOrAllm1 = this.props.UserMobx.c_userDivisionFirewalledDivisionIDsCommaOrAllm1;
    const c_userDivisionFirewalledDivisionIDsArray = this.props.UserMobx.c_userDivisionFirewalledDivisionIDsArray;

    var performanceGoalsAndGraphsComponent = null;
    if((customPerformanceTabSelectedTF && (o_performanceSelectedCustomPerformanceOptionID === undefined)) || (!customPerformanceTabSelectedTF && ((o_performanceSelectedUserTrueDivisionFalse === undefined) || (o_performanceSelectedUserOrDivisionID === undefined)))) {
      performanceGoalsAndGraphsComponent = (
        <CEGeneralReact.EmptyScreenGray>
          {((customPerformanceTabSelectedTF) ? ("Select a Custom Performance option from the listing on the left to view its performance and quotas") : ("Select a User or Division from the green listing on the left ('Divisions/Users') to view their performance and quotas"))}
        </CEGeneralReact.EmptyScreenGray>
      );
    }
    else if(!customPerformanceTabSelectedTF && !o_performanceSelectedUserTrueDivisionFalse && (c_userDivisionFirewalledDivisionIDsCommaOrAllm1 !== "-1") && !JSFUNC.in_array(o_performanceSelectedUserOrDivisionID, c_userDivisionFirewalledDivisionIDsArray)) {
      performanceGoalsAndGraphsComponent = (
        <CEGeneralReact.EmptyScreenGray>
          {"Your admin has not given you firewall permissions to view Captures in this Division"}
        </CEGeneralReact.EmptyScreenGray>
      );
    }
    else {
      performanceGoalsAndGraphsComponent = (
        <div className="flex11a displayFlexColumn yScroll yScrollBottomPad">
          <div className="flex00a" style={{borderBottom:"solid 2px #bbb"}}>
            <PerformanceQuotaGraphAndControls
              p_divexecPerformanceTrueUserMyPerformanceFalse={p_divexecPerformanceTrueUserMyPerformanceFalse}
            />
          </div>
          <div className="flex00a displayFlexColumn">
            <PerformanceTiledGraphs />
          </div>
        </div>
      );
    }

    //My Performance - do not show Divisions/Users tree panel
    if(!p_divexecPerformanceTrueUserMyPerformanceFalse) {
      return(performanceGoalsAndGraphsComponent);
    }

    //Divexec Performance - mobile switch between panel and graphs page
    if(c_isMobileOrTabletTF) {
      if(o_performanceMobileScreen === "graphs") {
        return(performanceGoalsAndGraphsComponent);
      }
      else {
        return(<PerformanceDivisionsAndUsersList />);
      }
    }

    //Divexec Performance - both panel and graphs page
    return(
      <div className="flex11a displayFlexRow">
        <div className="flex00a displayFlexColumn" style={{flexBasis:"25em", borderRight:"solid 1px #9b9"}}>
          <PerformanceDivisionsAndUsersList />
        </div>
        {performanceGoalsAndGraphsComponent}
      </div>
    );
  }
}));

const PerformanceDivisionsAndUsersList = inject("DivexecMobx", "UserMobx")(observer(
class PerformanceDivisionsAndUsersList extends Component { //props: 
  onclick_select_divisions_users_tab = () => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_performance_tree_selected_tab_du0_cp1", 0, "i");
  }

  onclick_select_custom_performances_tab = () => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_performance_tree_selected_tab_du0_cp1", 1, "i");
  }

  render() {
    const c_performanceDivisionsWithUsersArrayOfObjs = this.props.DivexecMobx.c_performanceDivisionsWithUsersArrayOfObjs;
    const divisionsUsersTabSelectedTF = this.props.UserMobx.c_userDivexecPerformanceTreeSelectedTabIsDivisionsUsersTF;
    const customPerformanceTabSelectedTF = this.props.UserMobx.c_userDivexecPerformanceTreeSelectedTabIsCustomPerformancesTF;

    return(
      <div className={"flex11a displayFlexColumn " + ((customPerformanceTabSelectedTF) ? ("bgDarkTeal") : ("bgDarkGreen"))} style={{flexBasis:"100em"}}>
        <div className="flex00a displayFlexColumnHcVc bgDarkGray tbPad">
          <div className="flex00a displayFlexRow">
            <PerformanceTreeTab
              p_tabName={"Divisions/Users"}
              p_selectedTF={divisionsUsersTabSelectedTF}
              p_selectedBgClass="bgDarkGreenGradient"
              p_unselectedHoverBgClass="bgLightGrayGradient hoverLighterBlueGradient"
              f_onClick={this.onclick_select_divisions_users_tab}
            />
            <div className="flex00a" style={{flexBasis:"0.5em"}} />
            <PerformanceTreeTab
              p_tabName={"Custom Performances"}
              p_selectedTF={customPerformanceTabSelectedTF}
              p_selectedBgClass="bgDarkTealGradient"
              p_unselectedHoverBgClass="bgLightGrayGradient hoverLighterBlueGradient"
              f_onClick={this.onclick_select_custom_performances_tab}
            />
          </div>
        </div>
        {(customPerformanceTabSelectedTF) ? (
          <PerformanceCustomPerformancesList />
        ) : (
          <>
            <div className="flex00a borderB1ddd bgDarkGreenGradient smallFullPad">
              <LibraryReact.NowrapEllipsis p_fontClass="font13 fontItalic fontWhite">
                {"Divisions/Users"}
              </LibraryReact.NowrapEllipsis>
            </div>
            <div className="flex11a yScroll yScrollBottomPad">
              {c_performanceDivisionsWithUsersArrayOfObjs.map((m_divisionObj) =>
                <PerformanceDivisionRow
                  key={m_divisionObj.id}
                  p_divisionObj={m_divisionObj}
                />
              )}
            </div>
          </>
        )}
      </div>
    );
  }
}));

function PerformanceTreeTab(props) { //props: p_tabName, p_selectedTF, p_selectedBgClass, p_unselectedHoverBgClass, f_onClick
  const p_tabName = props.p_tabName;
  const p_selectedTF = props.p_selectedTF;
  const p_selectedBgClass = props.p_selectedBgClass;
  const p_unselectedHoverBgClass = props.p_unselectedHoverBgClass;
  const f_onClick = props.f_onClick;

  return(
    <div
      className={"flex00a displayFlexColumnHcVc border bevelBorderColors " + ((p_selectedTF) ? (p_selectedBgClass) : (p_unselectedHoverBgClass + " cursorPointer")) + " textCenter"}
      style={{width:"11.5em", height:"2em"}}
      onClick={f_onClick}>
      <LibraryReact.NowrapEllipsis p_fontClass={"fontBold " + ((p_selectedTF) ? ("fontWhite") : ("fontTextLight"))}>
        {p_tabName}
      </LibraryReact.NowrapEllipsis>
    </div>
  );
}


const PerformanceCustomPerformancesList = inject("DivexecMobx", "UserMobx")(observer(
class PerformanceCustomPerformancesList extends Component {
  onselect_capture_field = (i_captureFieldID) => {
    this.props.DivexecMobx.a_performance_set_selected_custom_performance_option_id(-1);
    this.props.UserMobx.a_update_logged_in_user_field(
      ["divexec_performance_custom_performance_selected_capture_field_id", "divexec_performance_cp_scf_selected_option_ids_comma_or_all"],
      [i_captureFieldID, "all"],
      ["i", "s"]
    );
  }

  onselect_capture_field_options = (i_selectedOptionIDsCommaOrAll) => {
    this.props.DivexecMobx.a_performance_set_selected_custom_performance_option_id(-1);
    this.props.UserMobx.a_update_logged_in_user_field("divexec_performance_cp_scf_selected_option_ids_comma_or_all", i_selectedOptionIDsCommaOrAll, "s");
  }

  render() {
    const c_performanceCustomPerformanceCaptureFieldFieldTypeObj = this.props.DivexecMobx.c_performanceCustomPerformanceCaptureFieldFieldTypeObj;
    const c_performanceSelectedCustomPerformanceExpandedCaptureFieldMapOrUndefined = this.props.DivexecMobx.c_performanceSelectedCustomPerformanceExpandedCaptureFieldMapOrUndefined;
    const c_performanceCustomPerformanceCaptureFieldOptionsFieldTypeObj = this.props.DivexecMobx.c_performanceCustomPerformanceCaptureFieldOptionsFieldTypeObj;
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;

    var customPerformanceOptionsComponent = null;
    if(c_performanceSelectedCustomPerformanceExpandedCaptureFieldMapOrUndefined !== undefined) {
      const selectedFieldDisplayName = c_performanceSelectedCustomPerformanceExpandedCaptureFieldMapOrUndefined.get("display_name");
      const selectedFieldTypeObj = c_performanceSelectedCustomPerformanceExpandedCaptureFieldMapOrUndefined.get("fieldTypeObj");
      const selectWithSearchDataObj = selectedFieldTypeObj.selectWithSearchDataObj;
      if((selectWithSearchDataObj !== undefined) && JSFUNC.is_array(selectWithSearchDataObj.valueArray)) {
        const selectedOptionsRaw = c_combinedUserObj.divexec_performance_cp_scf_selected_option_ids_comma_or_all;
        const selectedOptionIDsArray = (selectedOptionsRaw === "all") ?
          selectWithSearchDataObj.valueArray :
          ((selectWithSearchDataObj.valuesAreStringsTF) ?
            JSFUNC.convert_comma_list_to_array(selectedOptionsRaw) :
            JSFUNC.convert_comma_list_to_int_array(selectedOptionsRaw));
        customPerformanceOptionsComponent = (
          <>
            <PerformanceCustomPerformanceOptionRow
              p_optionID={-1}
              p_optionName={"All Values from " + selectedFieldDisplayName}
              p_optionColor={undefined}
              p_indentedTF={false}
            />
            {selectWithSearchDataObj.valueArray.map((m_optionID, m_optionIndex) => ((selectedOptionIDsArray.indexOf(m_optionID) !== -1) ? (
              <PerformanceCustomPerformanceOptionRow
                key={m_optionID}
                p_optionID={m_optionID}
                p_optionName={selectWithSearchDataObj.displayArray[m_optionIndex]}
                p_optionColor={((JSFUNC.is_array(selectWithSearchDataObj.colorArray)) ? (selectWithSearchDataObj.colorArray[m_optionIndex]) : (undefined))}
                p_indentedTF={true}
              />
            ) : (null)))}
          </>
        );
      }
    }

    return(
      <div className="flex11a displayFlexColumn bgDarkTeal">
        <div className="flex00a borderB1ddd bgDarkTealGradient smallFullPad">
          <LibraryReact.NowrapEllipsis p_fontClass="font13 fontItalic fontWhite">
            {"Custom Performances"}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="flex00a smallFullPad bgLighterTeal">
          <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="fontItalic fontTextLight">
            {"Select a Capture Field below to set custom performance goals against"}
          </LibraryReact.DivFont>
          <CEGeneralReact.GenericInputOrSelectFromInputType
            p_fieldTypeObj={c_performanceCustomPerformanceCaptureFieldFieldTypeObj}
            p_valueRaw={c_combinedUserObj.divexec_performance_custom_performance_selected_capture_field_id}
            f_onChangeOrOnSelect={this.onselect_capture_field}
          />
          {(c_performanceCustomPerformanceCaptureFieldOptionsFieldTypeObj !== undefined) &&
            <>
              <LibraryReact.DivFont p_class="medTopMargin microBottomMargin" p_fontClass="fontItalic fontTextLight">
                {"Capture Field Options"}
              </LibraryReact.DivFont>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={c_performanceCustomPerformanceCaptureFieldOptionsFieldTypeObj}
                p_valueRaw={c_combinedUserObj.divexec_performance_cp_scf_selected_option_ids_comma_or_all}
                f_onChangeOrOnSelect={this.onselect_capture_field_options}
              />
            </>
          }
        </div>
        <div className="flex11a yScroll yScrollBottomPad">
          {customPerformanceOptionsComponent}
        </div>
      </div>
    );
  }
}));


const PerformanceCustomPerformanceOptionRow = inject("DivexecMobx")(observer(
class PerformanceCustomPerformanceOptionRow extends Component { //props: p_optionID, p_optionName, p_optionColor, p_indentedTF
  onclick_option = () => {
    this.props.DivexecMobx.a_performance_set_selected_custom_performance_option_id(this.props.p_optionID);
  }

  render() {
    const isSelectedTF = (this.props.DivexecMobx.o_performanceSelectedCustomPerformanceOptionID === this.props.p_optionID);
    const optionColorBlockComponent = ((JSFUNC.string_is_filled_out_tf(this.props.p_optionColor)) ? (
      <div className="flex00a smallFullMargin border bevelBorderColors" style={{flexBasis:"1em", background:"#" + this.props.p_optionColor}} />
    ) : (null));

    return(
      <div className="displayFlexRow">
        {(this.props.p_indentedTF) &&
          <div className="flex00a borderL1ddd" style={{flexBasis:"1em", marginLeft:"1em"}} />
        }
        <div className="flex11a bgLightGray tbMicroPad lrPad">
          <div
            className={"displayFlexRow border bevelBorderColors " + ((isSelectedTF) ? ("bgBlueGradient") : ("bgGrayGradient hoverLightBlueGradient cursorPointer"))}
            style={{height:"2.5em", borderRadius:"0.5em"}}
            onClick={this.onclick_option}>
            {optionColorBlockComponent}
            <div className="flex11a displayFlexRowVc lrPad">
              <LibraryReact.NowrapEllipsis p_fontClass={((isSelectedTF) ? ("fontWhite") : (""))}>
                {this.props.p_optionName}
              </LibraryReact.NowrapEllipsis>
            </div>
          </div>
        </div>
      </div>
    );
  }
}));

const PerformanceDivisionRow = inject("DivexecMobx")(observer(
class PerformanceDivisionRow extends Component { //props: p_divisionObj
  onclick_division = () => {
    this.props.DivexecMobx.a_performance_set_selected_user_or_division_id(false, this.props.p_divisionObj.id);
  }

  render() {
    const p_divisionObj = this.props.p_divisionObj;

    const selectedUserTrueDivisionFalse = this.props.DivexecMobx.o_performanceSelectedUserTrueDivisionFalse;
    const selectedUserOrDivisionID = this.props.DivexecMobx.o_performanceSelectedUserOrDivisionID;

    const isSelectedTF = (!selectedUserTrueDivisionFalse && (p_divisionObj.id === selectedUserOrDivisionID));

    return(
      <div className="displayFlexRow">
        {p_divisionObj.indentsArray.map((m_indent) =>
          <div key={m_indent} className="flex00a borderL1ddd" style={{flexBasis:"1em", marginLeft:"1em"}} />
        )}
        <div className="flex11a bgLightGray tbMicroPad lrPad border bevelBorderColors">
          <div
            className={"flex11a displayFlexRow border bevelBorderColors " + ((isSelectedTF) ? ("bgBlueGradient") : ("bgGrayGradient hoverLightBlueGradient cursorPointer"))}
            style={{height:"2.5em", borderRadius:"0.5em"}}
            onClick={this.onclick_division}>
            <div className="flex00a smallFullMargin border bevelBorderColors" style={{flexBasis:"1em", background:"#" + p_divisionObj.color}} />
            <div className="flex11a displayFlexRowVc lrPad">
              <LibraryReact.NowrapEllipsis p_fontClass={((isSelectedTF) ? ("fontWhite") : (""))}>
                {p_divisionObj.name}
              </LibraryReact.NowrapEllipsis>
            </div>
          </div>
          <div style={{marginLeft:"1.5em", marginRight:"0.5em"}}>
            {p_divisionObj.usersArrayOfObjs.map((m_userObj) =>
              <PerformanceUserRow
                key={m_userObj.id}
                p_userObj={m_userObj}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}));

const PerformanceUserRow = inject("DivexecMobx")(observer(
class PerformanceUserRow extends Component { //props: p_userObj
  onclick_user = () => {
    this.props.DivexecMobx.a_performance_set_selected_user_or_division_id(true, this.props.p_userObj.user_id);
  }

  render() {
    const userObj = this.props.p_userObj;

    const selectedUserTrueDivisionFalse = this.props.DivexecMobx.o_performanceSelectedUserTrueDivisionFalse;
    const selectedUserOrDivisionID = this.props.DivexecMobx.o_performanceSelectedUserOrDivisionID;

    const isSelectedTF = (selectedUserTrueDivisionFalse && (userObj.user_id === selectedUserOrDivisionID));

    return(
      <div
        className={"displayFlexRow border bevelBorderColors " + ((isSelectedTF) ? ("bgBlueGradient") : ("bgUserTan hoverLightBlueGradient cursorPointer"))}
        style={{height:"1.6em", borderRadius:"0.8em"}}
        onClick={this.onclick_user}>
        <div className="flex11a displayFlexRowVc lrPad">
          <LibraryReact.NowrapEllipsis p_fontClass={((isSelectedTF) ? ("fontWhite") : ("fontTextLight"))}>
            {userObj.fullName}
          </LibraryReact.NowrapEllipsis>
        </div>
      </div>
    );
  }
}));


const PerformanceQuotaGraphAndControls = inject("CaptureExecMobx", "DivexecMobx", "UserMobx")(observer(
class PerformanceQuotaGraphAndControls extends Component { //props: p_divexecPerformanceTrueUserMyPerformanceFalse
  constructor(props) {
    super(props);
    this.state = {
      s_exportAllGoalsToCsvFloatingBoxIsOpenTF: false
    }
  }

  onclick_mobile_go_to_user_division_screen = () => {
    this.props.DivexecMobx.a_performance_set_mobile_screen("selectUserOrDivision");
  }

  onclick_add_edit_goal_select_year = () => {
    this.props.DivexecMobx.a_performance_set_selected_fyr_to_view_edit(-1); //-1 flag to first open a floating box to pick which year to edit the goals for
  }

  onclick_export_all_goals_to_csv = () => {
    this.setState({s_exportAllGoalsToCsvFloatingBoxIsOpenTF:true});
  }

  onclick_close_export_all_goals_to_csv_floating_box = () => {
    this.setState({s_exportAllGoalsToCsvFloatingBoxIsOpenTF:false});
  }

  render() {
    const s_exportAllGoalsToCsvFloatingBoxIsOpenTF = this.state.s_exportAllGoalsToCsvFloatingBoxIsOpenTF;

    const p_divexecPerformanceTrueUserMyPerformanceFalse = this.props.p_divexecPerformanceTrueUserMyPerformanceFalse;

    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const c_performanceSelectedUserOrDivisionString = this.props.DivexecMobx.c_performanceSelectedUserOrDivisionString;
    const c_performanceSelectedUserOrDivisionName = this.props.DivexecMobx.c_performanceSelectedUserOrDivisionName;
    const c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined = this.props.DivexecMobx.c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined;
    const c_performanceLowestHighestNumFyrToDisplayInGraphsObj = this.props.DivexecMobx.c_performanceLowestHighestNumFyrToDisplayInGraphsObj;
    const c_myPerformanceMoneyFieldIDsToNotIncludeArray = this.props.DivexecMobx.c_myPerformanceMoneyFieldIDsToNotIncludeArray;
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;
    const c_userCanEditDivexecPerformanceGoalsTF = this.props.UserMobx.c_userCanEditDivexecPerformanceGoalsTF;

    const graphHeightPx = (30 * c_userFontSizePx);

    var performanceGoalsViewEditBarGraphComponent = null;
    if(c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined === undefined) {
      performanceGoalsViewEditBarGraphComponent = (
        <div className="displayFlexColumn" style={{height:graphHeightPx + "px"}}>
          <CEGeneralReact.EmptyScreenGray>
            {"You must select a Capture $ Value Field to use for setting and measuring goals"}
          </CEGeneralReact.EmptyScreenGray>
        </div>
      );
    }
    else if(c_performanceLowestHighestNumFyrToDisplayInGraphsObj.numYears === 0) {
      performanceGoalsViewEditBarGraphComponent = (
        <div className="displayFlexColumn" style={{height:graphHeightPx + "px"}}>
          <CEGeneralReact.EmptyScreenGray>
            {"For " + c_performanceSelectedUserOrDivisionString + " '" + c_performanceSelectedUserOrDivisionName + "', no goals have been created and no captures have been submitted, won, or lost"}
          </CEGeneralReact.EmptyScreenGray>
        </div>
      );
    }
    else {
      performanceGoalsViewEditBarGraphComponent = (
        <PerformanceGoalsBarGraph />
      );
    }

    return(
      <>
        {(c_isMobileOrTabletTF && p_divexecPerformanceTrueUserMyPerformanceFalse) &&
          <div className="displayFlexColumnHcVc smallTopPad bgLightestGray">
            <LibraryReact.ButtonFlexibleWidthFitsSingleLineText
              p_text="Select Different Division/User"
              p_class="tbMicroPad lrMedPad border1 bevelBorderColors borderRadius05 bgDarkGreenGradient hoverGreenGradient cursorPointer"
              p_fontClass="fontWhite"
              f_onClick={this.onclick_mobile_go_to_user_division_screen}
            />
          </div>
        }
        <div className="displayFlexRow borderB1bbb tbPad bgLightestGray">
          <LibraryReact.DivFont p_class="flex11a displayFlexRowVc lrMedPad" p_fontClass="font13 fontBold fontItalic fontTextLighter">
            {"Annual Goals for " + c_performanceSelectedUserOrDivisionString + " '" + c_performanceSelectedUserOrDivisionName + "'"}
          </LibraryReact.DivFont>
          <div className="flex00a" style={{flexBasis:"25em"}}>
            <DivexecEditUserMoneyField
              p_userFieldDbName="divexec_performance_money_field_id"
              p_valuesToNotIncludeArray={((p_divexecPerformanceTrueUserMyPerformanceFalse) ? ([]) : (c_myPerformanceMoneyFieldIDsToNotIncludeArray))}
            />
          </div>
          {(c_userCanEditDivexecPerformanceGoalsTF && p_divexecPerformanceTrueUserMyPerformanceFalse) &&
            <>
              <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"12em"}}>
                {(c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined !== undefined) &&
                  <CEGeneralReact.CEButton
                    p_type="blue"
                    p_text="Add/Edit a Goal"
                    f_onClick={this.onclick_add_edit_goal_select_year}
                  />
                }
              </div>
              <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2em"}}>
                <CEGeneralReact.VerticalDotsMenu
                  p_menuItemsArrayOfObjs={[{
                    displayName: "Export All Goals to .csv",
                    functionOnClickMenuItem: this.onclick_export_all_goals_to_csv
                  }]}
                />
              </div>
            </>
          }
        </div>
        <DivexecGoalsControlsRow />
        {performanceGoalsViewEditBarGraphComponent}
        <PerformanceQuotaChooseFyrOrEditingFyrFloatingBox
          p_divexecPerformanceTrueUserMyPerformanceFalse={p_divexecPerformanceTrueUserMyPerformanceFalse}
        />
        {(s_exportAllGoalsToCsvFloatingBoxIsOpenTF) &&
          <ExportAllGoalsToCsvFloatingBox
            f_onClickClose={this.onclick_close_export_all_goals_to_csv_floating_box}
          />
        }
      </>
    );
  }
}));


const ExportAllGoalsToCsvFloatingBox = inject("DivexecMobx", "DatabaseMobx")(observer(
class ExportAllGoalsToCsvFloatingBox extends Component { //props: f_onClickClose
  constructor(props) {
    super(props);
    this.state = {
      s_goalsCsvIsGeneratingTF: false
    }
  }

  onclick_generate_goals_csv_file = () => {
    this.setState({s_goalsCsvIsGeneratingTF:true});

    const allVisibleDivisionAndUserGoalsArrayOfArrays = this.props.DivexecMobx.a_performance_generate_all_quotas_csv_arrayOfArrays();
    const csvString = JSFUNC.convert_data_table_to_csv_string(allVisibleDivisionAndUserGoalsArrayOfArrays);
    const downloadFileNameAndExt = JSFUNC.now_dateYmd() + " Performance Goals Divisions and Users.csv";
    JSFUNC.browser_offer_file_download_from_file_data_string(csvString, downloadFileNameAndExt);

    this.setState({s_goalsCsvIsGeneratingTF:false});
  }

  render() {
    const s_goalsCsvIsGeneratingTF = this.state.s_goalsCsvIsGeneratingTF;

    const f_onClickClose = this.props.f_onClickClose;

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="smallVertical"
        p_title="Export All Goals to .csv File"
        f_onClickCancel={f_onClickClose}>
        <div className="flex11a medFullPad yScroll">
          <LibraryReact.DivFont p_class="microBottomMargin">
            {"This will generate a .csv file of all Performance Goals (visible within your Division tree), that can be loaded into excel as a table with the following 18 data columns:"}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_fontClass="fontItalic fontTextLight">
            <div>{"A) 'Division', 'User', or 'Custom Performance' Goal Category"}</div>
            <div>{"B) Division, User, or Custom Performance Name"}</div>
            <div>{"C) Selected Money Field Name"}</div>
            <div>{"D) Fiscal Year (FYR)"}</div>
            <div>{"E) 'Submitted' or 'Won' (or Financial Projections 'Waterfall') Goal Type"}</div>
            <div>{"F) Annual Goal Value (in $)"}</div>
            <div>{"G-R) Goal Values (in $) for the 12 Months of the Fiscal Year"}</div>
          </LibraryReact.DivFont>
        </div>
        <div className="flex00a displayFlexRowHcVc borderT1bbb" style={{flexBasis:"4em"}}>
          {(s_goalsCsvIsGeneratingTF) ? (
            <div className="flex00a displayFlexColumnHcVc">
              <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="fontItalic fontLightGray">
                {"Generating Goals .csv..."}
              </LibraryReact.DivFont>
              <CEGeneralReact.LoadingAnimation />
            </div>
          ) : (
            <>
              <div className="flex00a">
                <CEGeneralReact.CEButton
                  p_type="blue"
                  p_text="Generate Goals .csv File"
                  f_onClick={this.onclick_generate_goals_csv_file}
                />
              </div>
              <div className="flex00a" style={{flexBasis:"2em"}} />
              <div className="flex00a">
                <CEGeneralReact.CEButton
                  p_type="gray"
                  p_text="Cancel"
                  f_onClick={f_onClickClose}
                />
              </div>
            </>
          )}
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));


const DivexecGoalsControlsRow = inject("DivexecMobx", "DatabaseMobx", "UserMobx")(observer(
class DivexecGoalsControlsRow extends Component { //props: 
  onclick_performance_expand_collapse_graph_options_button = () => {
    const o_performanceGoalsGraphOptionsExpandedTF = this.props.DivexecMobx.o_performanceGoalsGraphOptionsExpandedTF;
    this.props.DivexecMobx.a_performance_set_goals_graph_options_expanded_tf(!o_performanceGoalsGraphOptionsExpandedTF);
  }

  onclick_yearly_quarterly_monthly_view_tab = (i_performanceViewY0Q1M2) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_performance_view_y0q1m2", i_performanceViewY0Q1M2, "i");
  }

  onswitch_performance_view_direction = () => {
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;
    const updatedValue01 = ((c_combinedUserObj.divexec_performance_view_dec0inc1 === 1) ? (0) : (1));
    this.props.UserMobx.a_update_logged_in_user_field("divexec_performance_view_dec0inc1", updatedValue01, "i");
  }

  onswitch_specify_years = () => {
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;

    var updatedGoalsLatestYear = 0;
    if(!JSFUNC.is_number_not_nan_gt_0(c_combinedUserObj.divexec_goals_latest_year)) {
      updatedGoalsLatestYear = (JSFUNC.now_year_int() + 1);
    }
    this.props.UserMobx.a_update_logged_in_user_field("divexec_goals_latest_year", updatedGoalsLatestYear, "i");
  }

  onchange_divexec_goals_latest_year = (i_newValue) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_goals_latest_year", i_newValue, "i");
  }

  onchange_divexec_goals_num_years = (i_newValue) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_goals_num_years", i_newValue, "i");
  }

  render() {
    const o_performanceGoalsGraphOptionsExpandedTF = this.props.DivexecMobx.o_performanceGoalsGraphOptionsExpandedTF;
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;

    var performanceGoalsGraphOptionsComponent = null;
    if(o_performanceGoalsGraphOptionsExpandedTF) {
      const fieldClass = "fontItalic";
      const goalsSpecifyYearsTrueShowAllYearsFalse = JSFUNC.is_number_not_nan_gt_0(c_combinedUserObj.divexec_goals_latest_year);
      
      performanceGoalsGraphOptionsComponent = (
        <div className="medFullPad">
          <div className="flex00a">
            <CEGeneralReact.SwitchWithTextAndConfirmBox
              p_isOnTF={(c_combinedUserObj.divexec_performance_view_dec0inc1 === 1)}
              p_sizeEm={2.5}
              p_onColor="789"
              p_offColor="798"
              p_onText="Years displayed low-to-high"
              p_offText="Years displayed high-to-low [default]"
              p_onTextFontClass="fontBold"
              p_offTextFontClass="fontBold"
              p_title="Reverse the direction of the FYRs diaplayed in the Peformance Goals graph"
              f_onSwitch={this.onswitch_performance_view_direction}
            />
          </div>
          <div className="flex00a hugeTopMargin">
            <CEGeneralReact.SwitchWithTextAndConfirmBox
              p_isOnTF={goalsSpecifyYearsTrueShowAllYearsFalse}
              p_sizeEm={2.5}
              p_onColor="373"
              p_offColor="777"
              p_onText="Specify Years Shown"
              p_offText="Show All Years [default]"
              p_onTextFontClass="fontBold"
              p_offTextFontClass="fontBold"
              p_title="Off [default] - all years are shown in the Goals graph which include any year a Won Capture has an award date set plus any year that has a goal set\nOn - ability to show a specific set of years to reduce the graph"
              f_onSwitch={this.onswitch_specify_years}
            />
          </div>
          {(goalsSpecifyYearsTrueShowAllYearsFalse) &&
            <>
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="divexecGraph_divexec_goals_latest_year"
                p_fieldDisplayName="Latest Year:"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj}
                p_valueRaw={c_combinedUserObj.divexec_goals_latest_year}
                p_valueIsEditableTFU={true}
                p_containerClass="microTopMargin"
                p_fieldClass={fieldClass}
                p_fieldWidth="6em"
                p_valueClass=""
                f_onSaveChanged={this.onchange_divexec_goals_latest_year}
              />
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="divexecGraph_divexec_goals_num_years"
                p_fieldDisplayName="# Years Shown:"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericIntPositiveFieldTypeObj}
                p_valueRaw={c_combinedUserObj.divexec_goals_num_years}
                p_valueIsEditableTFU={true}
                p_containerClass="microTopMargin"
                p_fieldClass={fieldClass}
                p_fieldWidth="7.5em"
                p_valueClass=""
                f_onSaveChanged={this.onchange_divexec_goals_num_years}
              />
            </>
          }
        </div>
      );
    }


    return(
      <div className="flex00a displayFlexColumn borderB1bbb bgLighterGreen">
        <div className="flex00a displayFlexRow" style={{minHeight:"2.5em"}}>
          <div className="flex00a displayFlexColumnHcVc lrMedPad">
            <CEGeneralReact.TabsList
              p_tabDbNamesArray={[0, 1, 2]}
              p_tabDisplayNamesArray={["Yearly", "Quarterly", "Monthly"]}
              p_selectedTabDbName={c_combinedUserObj.divexec_performance_view_y0q1m2}
              p_tabHeight="1.5em"
              p_textMaxHeight="1.4em"
              p_tabWidth="6em"
              p_unselectedFontClass=""
              p_unselectedBgClass="bgLightGrayGradient fontBold fontTextLight"
              p_selectedBgClass="bgDarkGreenGradient fontBold fontWhite"
              f_onSelect={this.onclick_yearly_quarterly_monthly_view_tab}
            />
          </div>
          <div className="flex11a displayFlexColumn" />
          <div className="flex00a displayFlexColumnVc" style={{flexBasis:"7em"}}>
            <LibraryReact.DivFont>
              {"Graph Options"}
            </LibraryReact.DivFont>
          </div>
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"3em"}}>
            <CEGeneralReact.ButtonExpandCollapse
              p_isExpandedTF={o_performanceGoalsGraphOptionsExpandedTF}
              p_sizeEm={2}
              p_bgClass={undefined}
              f_onClick={this.onclick_performance_expand_collapse_graph_options_button}
            />
          </div>
        </div>
        {performanceGoalsGraphOptionsComponent}
      </div>
    );
  }
}));


const PerformanceGoalsBarGraph = inject("DivexecMobx")(observer(
class PerformanceGoalsBarGraph extends Component { //props: 
  render() {
    const c_performanceQuotaGraphObj = this.props.DivexecMobx.c_performanceQuotaGraphObj;

    const graphHeightPx = c_performanceQuotaGraphObj.graphHeightPx;
    const graphBarsAreaWidthEm = c_performanceQuotaGraphObj.graphBarsAreaWidthEm;
    const yAxisObj = c_performanceQuotaGraphObj.yAxisObj;
    const computedGraphFyrsArrayOfObjs = c_performanceQuotaGraphObj.computedGraphFyrsArrayOfObjs;

    const xAxisHeight = "3em";
    const yAxisWidthEm = 4;

    return(
      <div className="displayFlexRow">
        <div className="flex00a displayFlexColumn xScrollAlways" style={{flexBasis:yAxisWidthEm + "em"}}>
          <LibraryReact.YAxisWithLabelsLeftColumn p_yAxisTicksArrayOfObjs={yAxisObj.axisTicksArrayOfObjs} p_yAxisWidthEm={yAxisWidthEm} />
          <div className="flex00a" style={{flexBasis:xAxisHeight}} />
        </div>
        <div className="flex11a displayFlexColumn xScrollAlways" style={{height:graphHeightPx + "px"}}>
          <div className="flex11a displayFlexRow" style={{width:graphBarsAreaWidthEm + "em"}}>
            {computedGraphFyrsArrayOfObjs.map((m_computedGraphFyrObj) =>
              <PerformanceQuotaGraphYearBarsGroup
                key={m_computedGraphFyrObj.fyr}
                p_computedGraphFyrObj={m_computedGraphFyrObj}
                p_yAxisObj={yAxisObj}
              />
            )}
          </div>
          <div className="flex00a displayFlexRow" style={{flexBasis:xAxisHeight, width:graphBarsAreaWidthEm + "em", borderTop:"solid 1px #aaa"}}>
            {computedGraphFyrsArrayOfObjs.map((m_computedGraphFyrObj) =>
              <div key={m_computedGraphFyrObj.fyrLabel} className="flex11a displayFlexColumnVc textCenter" style={{flexBasis:"100em"}}>
                <div className="displayFlexRow">
                  <div className="flex11a" style={{flexBasis:m_computedGraphFyrObj.subEdgeRatioOfBarWidthEm + "em"}} />
                  {(m_computedGraphFyrObj.subLabelsArray.map((m_subLabel) =>
                    <div className="flex11a displayFlexRow" style={{flexBasis:"100em"}}>
                      <LibraryReact.NowrapEllipsis p_fontClass="font11 fontItalic fontTextLighter">
                        {m_subLabel}
                      </LibraryReact.NowrapEllipsis>
                    </div>
                  ))}
                  <div className="flex11a" style={{flexBasis:m_computedGraphFyrObj.subEdgeRatioOfBarWidthEm + "em"}} />
                </div>
                <LibraryReact.NowrapEllipsis p_fontClass="font13 fontTextLight">
                  {m_computedGraphFyrObj.fyrLabel}
                </LibraryReact.NowrapEllipsis>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}));


const PerformanceQuotaGraphYearBarsGroup = inject("DivexecMobx")(observer(
class PerformanceQuotaGraphYearBarsGroup extends Component { //props: p_computedGraphFyrObj, p_yAxisObj
  onclick_bars_group = () => {
    this.props.DivexecMobx.a_performance_set_selected_fyr_to_view_edit(this.props.p_computedGraphFyrObj.fyr);
  }

  render() {
    const p_computedGraphFyrObj = this.props.p_computedGraphFyrObj;
    const p_yAxisObj = this.props.p_yAxisObj;

    return(
      <div
        className="flex11a hoverLighterBlueGradient cursorPointer"
        style={{flexBasis:"100em"}}
        title={p_computedGraphFyrObj.fyrHoverText}
        onClick={this.onclick_bars_group}>
        <svg width="100%" height="100%">
          <LibraryReact.YAxisTicksHorizontalLines p_yAxisTicksArrayOfObjs={p_yAxisObj.axisTicksArrayOfObjs} p_gridLineWidthPx={1} p_gridLineColor="#ccc" />
            {p_computedGraphFyrObj.computedGraphQuotasActualsArrayOfObjs.map((m_cgqaObj) =>
              <>
              {(m_cgqaObj.submittedQuotaBarDrawTF) &&
                <rect x={m_cgqaObj.submittedQuotaBarX} y={m_cgqaObj.submittedQuotaBarY} width={m_cgqaObj.submittedQuotaBarWidth} height={m_cgqaObj.submittedQuotaBarHeight} fill={m_cgqaObj.submittedQuotaBarHashColor} />
              }
              {(m_cgqaObj.wonQuotaBarDrawTF) &&
                <rect x={m_cgqaObj.wonQuotaBarX} y={m_cgqaObj.wonQuotaBarY} width={m_cgqaObj.wondQuotaBarWidth} height={m_cgqaObj.wonQuotaBarHeight} fill={m_cgqaObj.wonQuotaBarHashColor} />
              }
              {(m_cgqaObj.submittedActualBarDrawTF) &&
                <rect x={m_cgqaObj.submittedActualBarX} y={m_cgqaObj.submittedActualBarY} width={m_cgqaObj.submittedActualBarWidth} height={m_cgqaObj.submittedActualBarHeight} fill={m_cgqaObj.submittedActualBarHashColor} />
              }
              {(m_cgqaObj.wonActualBarDrawTF) &&
                <rect x={m_cgqaObj.wonActualBarX} y={m_cgqaObj.wonActualBarY} width={m_cgqaObj.wonActualBarWidth} height={m_cgqaObj.wonActualBarHeight} fill={m_cgqaObj.wonActualBarHashColor} />
              }
            </>
            )}
        </svg>
      </div>
    );
  }
}));


const PerformanceQuotaChooseFyrOrEditingFyrFloatingBox = inject("CaptureExecMobx", "DivexecMobx")(observer(
class PerformanceQuotaChooseFyrOrEditingFyrFloatingBox extends Component { //props: p_divexecPerformanceTrueUserMyPerformanceFalse
  constructor(props) {
    super(props);
    this.state = {
      s_chooseFyrInt: JSFUNC.now_year_int()
    };
  }

  decremement_fyr = () => {
    this.setState({s_chooseFyrInt:(this.state.s_chooseFyrInt - 1)});
  }

  increment_fyr = () => {
    this.setState({s_chooseFyrInt:(this.state.s_chooseFyrInt + 1)});
  }

  onclick_choose_fyr = () => {
    this.props.DivexecMobx.a_performance_set_selected_fyr_to_view_edit(this.state.s_chooseFyrInt);
  }

  onclick_close_editing_quota_floating_box = () => {
    this.props.DivexecMobx.a_performance_set_selected_fyr_to_view_edit(undefined);
  }

  render() {
    const s_chooseFyrInt = this.state.s_chooseFyrInt;

    const p_divexecPerformanceTrueUserMyPerformanceFalse = this.props.p_divexecPerformanceTrueUserMyPerformanceFalse;

    const o_performanceSelectedFyrToViewEdit = this.props.DivexecMobx.o_performanceSelectedFyrToViewEdit;

    //undefined - no quota editor open
    if(o_performanceSelectedFyrToViewEdit === undefined) {
      return(null);
    }

    //-1 - choose which year to edit
    if(o_performanceSelectedFyrToViewEdit <= 0) {
      return(
        <CEGeneralReact.FloatingBoxWithSaveCancel
          p_trblFlag="smallVertical"
          p_title="Choose a Fiscal Year to Add/Edit Goals"
          p_zIndexWithinParentOrUndefinedForceFront={1}
          f_onClickCancel={this.onclick_close_editing_quota_floating_box}>
          <div className="flex11a displayFlexColumnHc medFullPad yScroll">
            <div className="displayFlexRowVc">
              <div className="flex00a">
                <CEGeneralReact.ButtonExpandCollapse
                  p_isExpandedTF={false}
                  p_sizeEm={2}
                  p_title={undefined}
                  f_onClick={this.decremement_fyr}
                />
              </div>
              <div className="flex00a lrMedMargin noSelect">
                <LibraryReact.DivFont p_fontClass="font16 fontBold fontTextLight">
                  {s_chooseFyrInt}
                </LibraryReact.DivFont>
              </div>
              <div className="flex00a">
                <CEGeneralReact.ButtonExpandCollapse
                  p_isExpandedTF={true}
                  p_sizeEm={2}
                  p_title={undefined}
                  f_onClick={this.increment_fyr}
                />
              </div>
              <div className="flex11a" />
            </div>
            <div className="displayFlexRowVc medTopMargin">
              <div className="flex00a">
                <CEGeneralReact.CEButton
                  p_type="blue"
                  p_text={"Choose Year " + s_chooseFyrInt}
                  f_onClick={this.onclick_choose_fyr}
                />
              </div>
              <div className="flex00a lrMedMargin">
                <CEGeneralReact.CEButton
                  p_type="gray"
                  p_text="Cancel"
                  f_onClick={this.onclick_close_editing_quota_floating_box}
                />
              </div>
            </div>
          </div>
        </CEGeneralReact.FloatingBoxWithSaveCancel>
      );
    }

    return(
      <PerformanceQuotaEditingFyrFloatingBox
        p_divexecPerformanceTrueUserMyPerformanceFalse={p_divexecPerformanceTrueUserMyPerformanceFalse}
        f_onClickClose={this.onclick_close_editing_quota_floating_box}
      />
    );
  }
}));


const PerformanceQuotaEditingFyrFloatingBox = inject("CaptureExecMobx", "DivexecMobx", "OpenCaptureMobx", "UserMobx")(observer(
class PerformanceQuotaEditingFyrFloatingBox extends Component { //props: p_divexecPerformanceTrueUserMyPerformanceFalse, f_onClickClose
  onclick_capture_open_capture = (i_captureID) => {
    this.props.OpenCaptureMobx.a_open_single_capture(i_captureID);
  }

  onclick_close_view_fyr_selected_captures_to_view_search_fields_cst_table = () => {
    this.props.DivexecMobx.a_performance_set_view_fyr_selected_captures_to_view_obj_or_undefined(undefined);
  }

  render() {
    const p_divexecPerformanceTrueUserMyPerformanceFalse = this.props.p_divexecPerformanceTrueUserMyPerformanceFalse;
    const f_onClickClose = this.props.f_onClickClose;

    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;
    const o_performanceSelectedFyrToViewEdit = this.props.DivexecMobx.o_performanceSelectedFyrToViewEdit;
    const o_performanceViewFyrSelectedCapturesToViewObjOrUndefined = this.props.DivexecMobx.o_performanceViewFyrSelectedCapturesToViewObjOrUndefined;
    const c_performanceSelectedUserOrDivisionString = this.props.DivexecMobx.c_performanceSelectedUserOrDivisionString;
    const c_performanceSelectedUserOrDivisionName = this.props.DivexecMobx.c_performanceSelectedUserOrDivisionName;
    const c_performanceUserSelectedMoneyFieldDisplayName = this.props.DivexecMobx.c_performanceUserSelectedMoneyFieldDisplayName;
    const c_performanceViewFyrSelectedSearchFieldsCstTableObjOrUndefined = this.props.DivexecMobx.c_performanceViewFyrSelectedSearchFieldsCstTableObjOrUndefined;
    const c_userCanEditDivexecPerformanceGoalsTF = this.props.UserMobx.c_userCanEditDivexecPerformanceGoalsTF;

    const userOrDivisionAndNameString = c_performanceSelectedUserOrDivisionString + " '" + c_performanceSelectedUserOrDivisionName + "'";
    const submittedWonEditorsVerticalTF = (o_mediaQueryFlag <= 3);

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="divexecPerformanceEditQuota"
        p_title={"Edit FY" + o_performanceSelectedFyrToViewEdit + " Goals for " + userOrDivisionAndNameString}
        p_zIndexWithinParentOrUndefinedForceFront={1}
        f_onClickSave={((c_userCanEditDivexecPerformanceGoalsTF) ? (f_onClickClose) : (undefined))}
        f_onClickCancel={((c_userCanEditDivexecPerformanceGoalsTF) ? (undefined) : (f_onClickClose))}>
        <div className="flex11a displayFlexColumn yScroll" style={{flexBasis:"100em"}}>
          <div className="flex00a displayFlexRow">
            <LibraryReact.DivFont p_class="flex00a displayFlexColumnHcVc textCenter" p_styleObj={{flexBasis:"14em"}} p_fontClass="font18 fontBold fontTextLighter">
              {"Goals FY" + o_performanceSelectedFyrToViewEdit}
            </LibraryReact.DivFont>
            <div className="flex11a displayFlexColumnVc">
              <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="font12 fontBold fontItalic fontTextLighter">
                {userOrDivisionAndNameString}
              </LibraryReact.DivFont>
              <LibraryReact.DivFont p_class="" p_fontClass="font11 fontItalic fontTextLight">
                {"Capture $ Value Field: " + c_performanceUserSelectedMoneyFieldDisplayName}
              </LibraryReact.DivFont>
            </div>
          </div>
          <div className={"flex00a " + ((submittedWonEditorsVerticalTF) ? ("displayFlexColumnHcVc") : ("displayFlexColumnHcVc")) + " lrMedPad"}>
            <div className={"flex00a " + ((submittedWonEditorsVerticalTF) ? ("displayFlexColumn") : ("displayFlexRow"))} style={{width:"100%", maxWidth:((submittedWonEditorsVerticalTF) ? ("43em") : ("86em"))}}>
              <div className={((submittedWonEditorsVerticalTF) ? ("flex00a") : ("flex11a")) + " displayFlexColumn smallFullPad"} style={{flexBasis:((submittedWonEditorsVerticalTF) ? (undefined) : ("100em"))}}>
                <PerformanceEditSingleGoal p_divexecPerformanceTrueUserMyPerformanceFalse={p_divexecPerformanceTrueUserMyPerformanceFalse} p_submittedTrueWonFalse={true} />
              </div>
              <div className={((submittedWonEditorsVerticalTF) ? ("flex00a") : ("flex11a")) + " displayFlexColumn smallFullPad"} style={{flexBasis:((submittedWonEditorsVerticalTF) ? (undefined) : ("100em"))}}>
                <PerformanceEditSingleGoal p_divexecPerformanceTrueUserMyPerformanceFalse={p_divexecPerformanceTrueUserMyPerformanceFalse} p_submittedTrueWonFalse={false} />
              </div>
            </div>
          </div>
        </div>
        {(c_performanceViewFyrSelectedSearchFieldsCstTableObjOrUndefined !== undefined) &&
          <div className="flex11a xyScroll borderT1bbb medTopPad lrMedPad hugeBottomPad" style={{flexBasis:"200em"}}>
            <div className="displayFlexRow smallBottomMargin">
              <div className="flex11a displayFlexRowVc">
                <LibraryReact.DivFont p_class="flex00a" p_fontClass="font13 fontBold fontTextLighter">
                  {o_performanceViewFyrSelectedCapturesToViewObjOrUndefined.tableTitle}
                </LibraryReact.DivFont>
              </div>
              <div
                className="flex00a displayFlexColumnHcVc hoverLightestGrayGradient cursorPointer"
                style={{flexBasis:"3em"}}
                onClick={this.onclick_close_view_fyr_selected_captures_to_view_search_fields_cst_table}
                title="[Click to close this Goals Capture Table]">
                <LibraryReact.DivFont p_class="flex00a textCenter" p_fontClass="font13">
                  {"\u2715"}
                </LibraryReact.DivFont>
              </div>
            </div>
            <CapturesReact.SearchFieldsCaptureSummaryTable
              p_filteredCstMaskedCaptureValuesArrayOfObjs={c_performanceViewFyrSelectedSearchFieldsCstTableObjOrUndefined.searchFieldsFilteredCstMaskedCaptureValuesArrayOfObjs}
              p_cstSumRowColumnsArrayOfObjsOrUndefined={c_performanceViewFyrSelectedSearchFieldsCstTableObjOrUndefined.searchFieldsCstSumRowColumnsArrayOfObjsOrUndefined}
              p_expandedCstColumnsArrayOfObjs={c_performanceViewFyrSelectedSearchFieldsCstTableObjOrUndefined.searchFieldsExpandedCstColumnsArrayOfObjs}
              p_initialSortFieldID={c_performanceViewFyrSelectedSearchFieldsCstTableObjOrUndefined.sortFieldIDOrUndefined}
              p_initialSortIsAscTF={c_performanceViewFyrSelectedSearchFieldsCstTableObjOrUndefined.sortIsAscTFOrUndefined}
              p_maxNumCapturesShown={25}
              f_onClickCapture={this.onclick_capture_open_capture}
            />
          </div>
        }
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));




const PerformanceEditSingleGoal = inject("DivexecMobx", "DatabaseMobx", "UserMobx")(observer(
class PerformanceEditSingleGoal extends Component { //props: p_divexecPerformanceTrueUserMyPerformanceFalse, p_submittedTrueWonFalse
  onsave_performance_any_yqm = (i_updatedMonthly12CommaString) => {
    const p_submittedTrueWonFalse = this.props.p_submittedTrueWonFalse;

    const o_performanceSelectedFyrToViewEdit = this.props.DivexecMobx.o_performanceSelectedFyrToViewEdit;

    const tblDQuotaColumnDbNameToUpdate = ((p_submittedTrueWonFalse) ? ("sales_performance_submitted_goal_12months_comma") : ("sales_performance_won_goal_12months_comma"));

    this.props.DivexecMobx.a_performance_update_or_insert_fyr_quota(o_performanceSelectedFyrToViewEdit, tblDQuotaColumnDbNameToUpdate, i_updatedMonthly12CommaString);
  }

  onclick_performance_num_captures_block = (i_yqmNumCapturesObj) => {
    const p_submittedTrueWonFalse = this.props.p_submittedTrueWonFalse;
    
    const o_performanceViewFyrSelectedCapturesToViewObjOrUndefined = this.props.DivexecMobx.o_performanceViewFyrSelectedCapturesToViewObjOrUndefined;

    var tableTitle = ((p_submittedTrueWonFalse) ? ("Submitted") : ("Won")) + " Captures within " + i_yqmNumCapturesObj.fyrPlusQmBinLabel;

    const yqmNumCapturesObj = JSFUNC.copy_obj(i_yqmNumCapturesObj);
    yqmNumCapturesObj.submittedTrueWonFalse = p_submittedTrueWonFalse;
    yqmNumCapturesObj.tableTitle = tableTitle;

    var viewFyrSelectedCapturesToViewObjOrUndefined = yqmNumCapturesObj;
    if(o_performanceViewFyrSelectedCapturesToViewObjOrUndefined !== undefined) {
      if(yqmNumCapturesObj.submittedTrueWonFalse === o_performanceViewFyrSelectedCapturesToViewObjOrUndefined.submittedTrueWonFalse) {
        if(yqmNumCapturesObj.yqmIndex012 === o_performanceViewFyrSelectedCapturesToViewObjOrUndefined.yqmIndex012) {
          if(yqmNumCapturesObj.yqmBinIndex === o_performanceViewFyrSelectedCapturesToViewObjOrUndefined.yqmBinIndex) {
            viewFyrSelectedCapturesToViewObjOrUndefined = undefined; //if viewing this captures table and it's clicked again, unselect it with undefined
          }
        }
      }
    }

    this.props.DivexecMobx.a_performance_set_view_fyr_selected_captures_to_view_obj_or_undefined(viewFyrSelectedCapturesToViewObjOrUndefined);
  }

  render() {
    const p_divexecPerformanceTrueUserMyPerformanceFalse = this.props.p_divexecPerformanceTrueUserMyPerformanceFalse;
    const p_submittedTrueWonFalse = this.props.p_submittedTrueWonFalse;

    const o_performanceSelectedFyrToViewEdit = this.props.DivexecMobx.o_performanceSelectedFyrToViewEdit;
    const c_performanceEditingSingleQuotaFyrYqmDataObj = this.props.DivexecMobx.c_performanceEditingSingleQuotaFyrYqmDataObj;
    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;
    const c_fieldMapOfProposalDueDateTimeUtc = this.props.DatabaseMobx.c_fieldMapOfProposalDueDateTimeUtc;
    const c_fieldMapOfAwardDate = this.props.DatabaseMobx.c_fieldMapOfAwardDate;
    const c_userCanEditDivexecPerformanceGoalsTF = this.props.UserMobx.c_userCanEditDivexecPerformanceGoalsTF;
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;

    const stageFieldDisplayName = c_fieldMapOfStage.get("display_name");
    const canEditGoalTF = (c_userCanEditDivexecPerformanceGoalsTF && p_divexecPerformanceTrueUserMyPerformanceFalse);

    //initialized YQM obj from database value of 12 months comma
    var initialYqmObjOrUndefined = undefined;
    if(p_submittedTrueWonFalse) { //Submitted quota
      initialYqmObjOrUndefined = c_performanceEditingSingleQuotaFyrYqmDataObj.fyrSubmittedQuotaYqmObj;
    }
    else { //Won quota
      initialYqmObjOrUndefined = c_performanceEditingSingleQuotaFyrYqmDataObj.fyrWonQuotaYqmObj;
    }

    var actualFieldName = "";
    var actualCaptureIDsArrayFieldName = "";
    var actualPartialNumCapturesFieldName = "";
    var stageCategoryName = "";
    var stageCategoryStagesString = "";
    var dateFieldDisplayName = "";
    if(p_submittedTrueWonFalse) { //Submitted quota
      actualFieldName = "submittedActualSumFromCapturesMoneyField";
      actualCaptureIDsArrayFieldName = "submittedActualCaptureIDsArray";
      actualPartialNumCapturesFieldName = "submittedActualPartialNumCaptures";
      stageCategoryName = "Submitted";
      stageCategoryStagesString = "either Submitted, Won, or Lost";
      dateFieldDisplayName = c_fieldMapOfProposalDueDateTimeUtc.get("display_name");
    }
    else { //Won quota
      actualFieldName = "wonActualSumFromCapturesMoneyField";
      actualCaptureIDsArrayFieldName = "wonActualCaptureIDsArray";
      actualPartialNumCapturesFieldName = "wonActualPartialNumCaptures";
      stageCategoryName = "Won";
      stageCategoryStagesString = "Won";
      dateFieldDisplayName = c_fieldMapOfAwardDate.get("display_name");
    }

    const yearsActualIntegersArray = JSFUNC.get_column_vector_from_arrayOfObjs(c_performanceEditingSingleQuotaFyrYqmDataObj.yearQuotasActualsArrayOfObjs, actualFieldName);
    const quartersActualIntegersArray = JSFUNC.get_column_vector_from_arrayOfObjs(c_performanceEditingSingleQuotaFyrYqmDataObj.quartersQuotasActualsArrayOfObjs, actualFieldName);
    const monthsActualIntegersArray = JSFUNC.get_column_vector_from_arrayOfObjs(c_performanceEditingSingleQuotaFyrYqmDataObj.monthsQuotasActualsArrayOfObjs, actualFieldName);

    const yearsActualCaptureIDsArrayOfArrays = JSFUNC.get_column_vector_from_arrayOfObjs(c_performanceEditingSingleQuotaFyrYqmDataObj.yearQuotasActualsArrayOfObjs, actualCaptureIDsArrayFieldName);
    const quartersActualCaptureIDsArrayOfArrays = JSFUNC.get_column_vector_from_arrayOfObjs(c_performanceEditingSingleQuotaFyrYqmDataObj.quartersQuotasActualsArrayOfObjs, actualCaptureIDsArrayFieldName);
    const monthsActualCaptureIDsArrayOfArrays = JSFUNC.get_column_vector_from_arrayOfObjs(c_performanceEditingSingleQuotaFyrYqmDataObj.monthsQuotasActualsArrayOfObjs, actualCaptureIDsArrayFieldName);

    const yearsActualPartialNumCapturesArray = JSFUNC.get_column_vector_from_arrayOfObjs(c_performanceEditingSingleQuotaFyrYqmDataObj.yearQuotasActualsArrayOfObjs, actualPartialNumCapturesFieldName);
    const quartersActualPartialNumCapturesArray = JSFUNC.get_column_vector_from_arrayOfObjs(c_performanceEditingSingleQuotaFyrYqmDataObj.quartersQuotasActualsArrayOfObjs, actualPartialNumCapturesFieldName);
    const monthsActualPartialNumCapturesArray = JSFUNC.get_column_vector_from_arrayOfObjs(c_performanceEditingSingleQuotaFyrYqmDataObj.monthsQuotasActualsArrayOfObjs, actualPartialNumCapturesFieldName);

    const actualArraysObj = {
      yearsActualIntegersArray: yearsActualIntegersArray,
      quartersActualIntegersArray: quartersActualIntegersArray,
      monthsActualIntegersArray: monthsActualIntegersArray,
      yearsActualCaptureIDsArrayOfArrays: yearsActualCaptureIDsArrayOfArrays,
      quartersActualCaptureIDsArrayOfArrays: quartersActualCaptureIDsArrayOfArrays,
      monthsActualCaptureIDsArrayOfArrays: monthsActualCaptureIDsArrayOfArrays,
      yearsActualPartialNumCapturesArray: yearsActualPartialNumCapturesArray,
      quartersActualPartialNumCapturesArray: quartersActualPartialNumCapturesArray,
      monthsActualPartialNumCapturesArray: monthsActualPartialNumCapturesArray,
    };

    return(
      <InputYqmEditSaveCancel
        p_fyr={o_performanceSelectedFyrToViewEdit}
        p_y0q1m2Selected={c_combinedUserObj.divexec_performance_view_y0q1m2}
        p_initialYqmObjOrUndefined={initialYqmObjOrUndefined}
        p_actualArraysObj={actualArraysObj}
        p_cardTitle={stageCategoryName + " Goal"}
        p_cardSubTitle={"A Capture is considered '" + stageCategoryName + "' if the " + stageFieldDisplayName + " is " + stageCategoryStagesString + ".\nThe " + dateFieldDisplayName + " must be filled out."}
        p_canEditTF={canEditGoalTF}
        f_onSaveChanged={this.onsave_performance_any_yqm}
        f_onClickNumCapturesBlock={this.onclick_performance_num_captures_block}
      />
    );
  }
}));



class InputYqmEditSaveCancel extends Component { //props: p_fyr, p_y0q1m2Selected, p_initialYqmObjOrUndefined, p_actualArraysObj, p_cardTitle, p_cardSubTitle, p_canEditTF, f_onSaveChanged(i_updatedMonthly12CommaString), f_onClickNumCapturesBlock(i_yqmNumCapturesObj)
  constructor(props) {
    super(props);

    const p_initialYqmObjOrUndefined = this.props.p_initialYqmObjOrUndefined;

    var initialYqmObjOrUndefined = p_initialYqmObjOrUndefined;
    if(!JSFUNC.is_obj(initialYqmObjOrUndefined)) {
      initialYqmObjOrUndefined = JSFUNC.convert_input_money_into_yearly_quarterly_monthly_obj_as_whole_dollars("yearly", 0);
    }

    this.state = {
      s_isEditingYearTF: false,
      s_isEditingQuartersTF: false,
      s_isEditingMonthsTF: false,
      s_tempEditingYmqObj: initialYqmObjOrUndefined
    };
  }

  componentDidUpdate(prevProps) {
    const p_initialYqmObjOrUndefined = this.props.p_initialYqmObjOrUndefined;

    if(prevProps.p_initialYqmObjOrUndefined !== p_initialYqmObjOrUndefined) {
      var updatedYqmObjOrUndefined = p_initialYqmObjOrUndefined;
      if(!JSFUNC.is_obj(p_initialYqmObjOrUndefined)) {
        updatedYqmObjOrUndefined = JSFUNC.convert_input_money_into_yearly_quarterly_monthly_obj_as_whole_dollars("yearly", 0);
      }

      this.setState({
        s_isEditingYearTF: false,
        s_isEditingQuartersTF: false,
        s_isEditingMonthsTF: false,
        s_tempEditingYmqObj: updatedYqmObjOrUndefined
      });
    }
  }

  set_initial_yqm_obj = (i_yqmObjOrUndefined) => {
    var initialYqmObjOrUndefined = i_yqmObjOrUndefined;
    if(!JSFUNC.is_obj(i_yqmObjOrUndefined)) {
      initialYqmObjOrUndefined = JSFUNC.convert_input_money_into_yearly_quarterly_monthly_obj_as_whole_dollars("yearly", 0);
    }

    this.setState({
      s_isEditingYearTF: false,
      s_isEditingQuartersTF: false,
      s_isEditingMonthsTF: false,
      s_tempEditingYmqObj: initialYqmObjOrUndefined
    });
  }

  onclick_edit_year = () => { this.setState({s_isEditingYearTF:true}); }
  onclick_edit_quarters = () => { this.setState({s_isEditingQuartersTF:true}); }
  onclick_edit_months = () => { this.setState({s_isEditingMonthsTF:true}); }
  onclick_close_edit_year = () => { this.setState({s_isEditingYearTF:false}); }
  onclick_close_edit_quarters = () => { this.setState({s_isEditingQuartersTF:false}); }
  onclick_close_edit_months = () => { this.setState({s_isEditingMonthsTF:false}); }

  onchange_yearly = (i_updatedIntegersArray) => {
    const updatedYearlyInt = i_updatedIntegersArray[0];
    const updatedYmqObj = JSFUNC.convert_input_money_into_yearly_quarterly_monthly_obj_as_whole_dollars("yearly", updatedYearlyInt);
    this.setState({s_tempEditingYmqObj:updatedYmqObj});
  }

  onchange_quarterly = (i_updatedIntegersArray) => {
    const updatedYmqObj = JSFUNC.convert_input_money_into_yearly_quarterly_monthly_obj_as_whole_dollars("quarterly", i_updatedIntegersArray);
    this.setState({s_tempEditingYmqObj:updatedYmqObj});
  }

  onchange_monthly = (i_updatedIntegersArray) => {
    const updatedYmqObj = JSFUNC.convert_input_money_into_yearly_quarterly_monthly_obj_as_whole_dollars("monthly", i_updatedIntegersArray);
    this.setState({s_tempEditingYmqObj:updatedYmqObj});
  }

  onsave_any_yqm = () => {
    const s_tempEditingYmqObj = this.state.s_tempEditingYmqObj;

    const f_onSaveChanged = this.props.f_onSaveChanged;
    
    const tempQuotaMonthly12CommaString = JSFUNC.convert_array_to_comma_list(s_tempEditingYmqObj.monthly12Array, "");
    if(JSFUNC.is_function(f_onSaveChanged)) {
      f_onSaveChanged(tempQuotaMonthly12CommaString);
    }

    this.setState({
      s_isEditingYearTF: false,
      s_isEditingQuartersTF: false,
      s_isEditingMonthsTF: false
    });
  }

  render() {
    const s_isEditingYearTF = this.state.s_isEditingYearTF;
    const s_isEditingQuartersTF = this.state.s_isEditingQuartersTF;
    const s_isEditingMonthsTF = this.state.s_isEditingMonthsTF;
    const s_tempEditingYmqObj = this.state.s_tempEditingYmqObj;

    const p_fyr = this.props.p_fyr;
    const p_y0q1m2Selected = JSFUNC.prop_value(this.props.p_y0q1m2Selected, 0);
    const p_initialYqmObjOrUndefined = this.props.p_initialYqmObjOrUndefined;
    const p_actualArraysObj = this.props.p_actualArraysObj;
    const p_cardTitle = this.props.p_cardTitle;
    const p_cardSubTitle = this.props.p_cardSubTitle;
    const p_canEditTF = JSFUNC.prop_value(this.props.p_canEditTF, true);
    const f_onSaveChanged = this.props.f_onSaveChanged;
    const f_onClickNumCapturesBlock = this.props.f_onClickNumCapturesBlock;

    const anyYqmIsEditingTF = (s_isEditingYearTF || s_isEditingQuartersTF || s_isEditingMonthsTF);
    const headerLabelFontClass = "fontBold fontTextLight";

    var actualsExistTF = false;
    var yearsActualIntegersArray = undefined;
    var yearsActualCaptureIDsArrayOfArrays = undefined;
    var yearsActualPartialNumCapturesArray = undefined;
    var quartersActualIntegersArray = undefined;
    var quartersActualCaptureIDsArrayOfArrays = undefined;
    var quartersActualPartialNumCapturesArray = undefined;
    var monthsActualIntegersArray = undefined;
    var monthsActualCaptureIDsArrayOfArrays = undefined;
    var monthsActualPartialNumCapturesArray = undefined;
    if(p_actualArraysObj !== undefined) {
      actualsExistTF = (JSFUNC.is_array(p_actualArraysObj.yearsActualIntegersArray) && JSFUNC.is_array(p_actualArraysObj.quartersActualIntegersArray) && JSFUNC.is_array(p_actualArraysObj.monthsActualIntegersArray));
      if(actualsExistTF) {
        yearsActualIntegersArray = p_actualArraysObj.yearsActualIntegersArray;
        yearsActualCaptureIDsArrayOfArrays = p_actualArraysObj.yearsActualCaptureIDsArrayOfArrays;
        yearsActualPartialNumCapturesArray = p_actualArraysObj.yearsActualPartialNumCapturesArray;
        quartersActualIntegersArray = p_actualArraysObj.quartersActualIntegersArray;
        quartersActualCaptureIDsArrayOfArrays = p_actualArraysObj.quartersActualCaptureIDsArrayOfArrays;
        quartersActualPartialNumCapturesArray = p_actualArraysObj.quartersActualPartialNumCapturesArray;
        monthsActualIntegersArray = p_actualArraysObj.monthsActualIntegersArray;
        monthsActualCaptureIDsArrayOfArrays = p_actualArraysObj.monthsActualCaptureIDsArrayOfArrays;
        monthsActualPartialNumCapturesArray = p_actualArraysObj.monthsActualPartialNumCapturesArray;
      }
    }

    return(
      <div className="flex00a displayFlexColumn border1bbb tbPad lrMedPad">
        <LibraryReact.DivFont p_class="smallBottomMargin textCenter" p_fontClass="font13 fontBold fontTextLighter">
          {p_cardTitle}
        </LibraryReact.DivFont>
        <LibraryReact.DivFont p_class="smallBottomMargin lrMedPad textCenter" p_fontClass="fontItalic fontTextLighter">
          {p_cardSubTitle}
        </LibraryReact.DivFont>
        <div className={"flex00a displayFlexColumn border1ddd borderRadius05 bgLightestGray medFullPad"}>
          <div className="flex00a displayFlexRow">
            <div className="flex00a" style={{flexBasis:"11em"}} />
            <div className="flex11a">
              <LibraryReact.NowrapEllipsis p_fontClass="fontBold fontDarkBlue">
                {"Goal"}
              </LibraryReact.NowrapEllipsis>
            </div>
            {(actualsExistTF) &&
              <>
                <div className="flex00a" style={{flexBasis:"6em"}}>
                  <LibraryReact.NowrapEllipsis p_fontClass={headerLabelFontClass}>
                    {"Actual"}
                  </LibraryReact.NowrapEllipsis>
                </div>
                <div className="flex00a" style={{flexBasis:"6em"}}>
                  <LibraryReact.NowrapEllipsis p_fontClass={headerLabelFontClass}>
                    {"Achieved"}
                  </LibraryReact.NowrapEllipsis>
                </div>
                <div className="flex00a" style={{flexBasis:"5em"}}>
                  <LibraryReact.NowrapEllipsis p_fontClass={headerLabelFontClass}>
                    {"Captures"}
                  </LibraryReact.NowrapEllipsis>
                </div>
              </>
            }
          </div>
          <InputMultipleMoneyVerticalWidthFieldEditSaveCancel
            p_fyr={p_fyr}
            p_yqmIndex012={0}
            p_quotaIntegersArray={[s_tempEditingYmqObj.yearlyInt]}
            p_actualIntegersArray={yearsActualIntegersArray}
            p_actualCaptureIDsArrayOfArrays={yearsActualCaptureIDsArrayOfArrays}
            p_actualPartialNumCapturesArray={yearsActualPartialNumCapturesArray}
            p_valueIsEditableTF={p_canEditTF}
            p_isEditingTF={s_isEditingYearTF}
            p_anyYqmIsEditingTF={anyYqmIsEditingTF}
            p_isSelectedViewTF={(p_y0q1m2Selected === 0)}
            f_onClickEdit={this.onclick_edit_year}
            f_onChange={this.onchange_yearly}
            f_onClickSave={this.onsave_any_yqm}
            f_onClickCancel={this.onclick_close_edit_year}
            f_onClickNumCapturesBlock={f_onClickNumCapturesBlock}
          />
          <InputMultipleMoneyVerticalWidthFieldEditSaveCancel
            p_fyr={p_fyr}
            p_yqmIndex012={1}
            p_quotaIntegersArray={s_tempEditingYmqObj.quarterly4Array}
            p_actualIntegersArray={quartersActualIntegersArray}
            p_actualCaptureIDsArrayOfArrays={quartersActualCaptureIDsArrayOfArrays}
            p_actualPartialNumCapturesArray={quartersActualPartialNumCapturesArray}
            p_valueIsEditableTF={p_canEditTF}
            p_isEditingTF={s_isEditingQuartersTF}
            p_anyYqmIsEditingTF={anyYqmIsEditingTF}
            p_isSelectedViewTF={(p_y0q1m2Selected === 1)}
            f_onClickEdit={this.onclick_edit_quarters}
            f_onChange={this.onchange_quarterly}
            f_onClickSave={this.onsave_any_yqm}
            f_onClickCancel={this.onclick_close_edit_quarters}
            f_onClickNumCapturesBlock={f_onClickNumCapturesBlock}
          />
          <InputMultipleMoneyVerticalWidthFieldEditSaveCancel
            p_fyr={p_fyr}
            p_yqmIndex012={2}
            p_quotaIntegersArray={s_tempEditingYmqObj.monthly12Array}
            p_actualIntegersArray={monthsActualIntegersArray}
            p_actualCaptureIDsArrayOfArrays={monthsActualCaptureIDsArrayOfArrays}
            p_actualPartialNumCapturesArray={monthsActualPartialNumCapturesArray}
            p_valueIsEditableTF={p_canEditTF}
            p_isEditingTF={s_isEditingMonthsTF}
            p_anyYqmIsEditingTF={anyYqmIsEditingTF}
            p_isSelectedViewTF={(p_y0q1m2Selected === 2)}
            f_onClickEdit={this.onclick_edit_months}
            f_onChange={this.onchange_monthly}
            f_onClickSave={this.onsave_any_yqm}
            f_onClickCancel={this.onclick_close_edit_months}
            f_onClickNumCapturesBlock={f_onClickNumCapturesBlock}
          />
        </div>
      </div>
    );
  }
}


class InputMultipleMoneyVerticalWidthFieldEditSaveCancel extends Component { //props: p_fyr, p_yqmIndex012, p_quotaIntegersArray, p_actualIntegersArray, p_actualCaptureIDsArrayOfArrays, p_actualPartialNumCapturesArray, p_valueIsEditableTF, p_isEditingTF, p_anyYqmIsEditingTF, p_isSelectedViewTF, f_onClickEdit(), f_onChange(updatedIntegersArray), f_onClickSave(), f_onClickCancel(), f_onClickNumCapturesBlock()
  onchange_single_integer = (m_integerIndex, i_newValueInt) => {
    const p_quotaIntegersArray = this.props.p_quotaIntegersArray;
    const f_onChange = this.props.f_onChange;

    if(JSFUNC.is_function(f_onChange)) {
      var updatedIntegersArray = JSFUNC.copy_array(p_quotaIntegersArray);
      updatedIntegersArray[m_integerIndex] = i_newValueInt;
      f_onChange(updatedIntegersArray);
    }
  }

  render() {
    const p_fyr = this.props.p_fyr;
    const p_yqmIndex012 = this.props.p_yqmIndex012;
    const p_quotaIntegersArray = this.props.p_quotaIntegersArray;
    const p_actualIntegersArray = this.props.p_actualIntegersArray;
    const p_actualCaptureIDsArrayOfArrays = this.props.p_actualCaptureIDsArrayOfArrays;
    const p_actualPartialNumCapturesArray = this.props.p_actualPartialNumCapturesArray;
    const p_valueIsEditableTF = this.props.p_valueIsEditableTF;
    const p_isEditingTF = this.props.p_isEditingTF;
    const p_anyYqmIsEditingTF = this.props.p_anyYqmIsEditingTF;
    const p_isSelectedViewTF = this.props.p_isSelectedViewTF;
    const f_onClickEdit = this.props.f_onClickEdit;
    const f_onChange = this.props.f_onChange;
    const f_onClickSave = this.props.f_onClickSave;
    const f_onClickCancel = this.props.f_onClickCancel;
    const f_onClickNumCapturesBlock = this.props.f_onClickNumCapturesBlock;

    var fieldDisplayName = "";
    if(p_yqmIndex012 === 0) { fieldDisplayName = "Yearly"; }
    else if(p_yqmIndex012 === 1) { fieldDisplayName = "Quarterly"; }
    else if(p_yqmIndex012 === 2) { fieldDisplayName = "Monthly"; }

    var editSaveCancelButtonsComponent = null;
    if(p_valueIsEditableTF) {
      if(p_isEditingTF) {
        editSaveCancelButtonsComponent = (
          <>
            <CEGeneralReact.EditSaveCancelIcon p_iconType="save" f_onClick={f_onClickSave} />
            <CEGeneralReact.EditSaveCancelIcon p_iconType="cancel" f_onClick={f_onClickCancel} />
          </>
        );
      }
      else {
        editSaveCancelButtonsComponent = (
          <CEGeneralReact.EditSaveCancelIcon p_iconType="edit" f_onClick={((p_valueIsEditableTF) ? (f_onClickEdit) : (undefined))} />
        );
      }
    }
    else {
      editSaveCancelButtonsComponent = (
        <div className="flex00a" style={{flexBasis:"2em"}} />
      );
    }
    
    return(
      <div className="flex00a displayFlexRow smallBottomMargin borderRadius05 smallFullPad" style={{border:"solid 2px " + ((p_isSelectedViewTF) ? ("#669966") : ("#dddddd"))}}>
        <div className="flex00a displayFlexColumnVc" style={{flexBasis:"5em"}}>
          <LibraryReact.DivFont p_fontClass="fontBold fontDarkGreen">
            {fieldDisplayName}
          </LibraryReact.DivFont>
        </div>
        {editSaveCancelButtonsComponent}
        <div className="flex11a displayFlexColumn">
          {p_quotaIntegersArray.map((m_quotaInteger, m_index) =>
            <PerformanceSingleYqmQuotaItemDisplayOrMoneyEdit
              key={"int" + m_index}
              p_fyr={p_fyr}
              p_yqmIndex012={p_yqmIndex012}
              p_yqmBinIndex={m_index}
              p_quotaInteger={m_quotaInteger}
              p_actualInteger={((p_actualIntegersArray !== undefined) ? (p_actualIntegersArray[m_index]) : (undefined))}
              p_actualCaptureIDsArray={((p_actualCaptureIDsArrayOfArrays !== undefined) ? (p_actualCaptureIDsArrayOfArrays[m_index]) : (undefined))}
              p_actualPartialNumCaptures={((p_actualPartialNumCapturesArray !== undefined) ? (p_actualPartialNumCapturesArray[m_index]) : (undefined))}
              p_isEditingTF={p_isEditingTF}
              p_anyYqmIsEditingTF={p_anyYqmIsEditingTF}
              p_isSelectedViewTF={p_isSelectedViewTF}
              f_onChange={this.onchange_single_integer}
              f_onKeyDownEnter={f_onClickSave}
              f_onClickNumCapturesBlock={f_onClickNumCapturesBlock}
            />
          )}
        </div>
      </div>
    );
  }
}


const PerformanceSingleYqmQuotaItemDisplayOrMoneyEdit = inject("DatabaseMobx")(observer(
class PerformanceSingleYqmQuotaItemDisplayOrMoneyEdit extends Component { //props: p_fyr, p_yqmIndex012, p_yqmBinIndex, p_quotaInteger, p_actualInteger, p_actualCaptureIDsArray, p_actualPartialNumCaptures, p_isEditingTF, p_anyYqmIsEditingTF, p_isSelectedViewTF, f_onChange(i_newValueInt), f_onKeyDownEnter(), f_onClickNumCapturesBlock()
  onchange_goal_value = (i_newValueInt) => {
    const p_yqmBinIndex = this.props.p_yqmBinIndex;
    const f_onChange = this.props.f_onChange;
    if(JSFUNC.is_function(f_onChange)) {
      f_onChange(p_yqmBinIndex, i_newValueInt);
    }
  }

  onclick_goal_num_captures_show_capture_table = () => {
    const p_yqmIndex012 = this.props.p_yqmIndex012;
    const p_yqmBinIndex = this.props.p_yqmBinIndex;
    const p_actualCaptureIDsArray = this.props.p_actualCaptureIDsArray;
    const f_onClickNumCapturesBlock = this.props.f_onClickNumCapturesBlock;

    if(JSFUNC.is_function(f_onClickNumCapturesBlock)) {
      const labelsObj = this.compute_labels_obj();

      const viewFyrSelectedCapturesToViewObjOrUndefined = {
        yqmIndex012: p_yqmIndex012,
        yqmBinIndex: p_yqmBinIndex,
        actualCaptureIDsArray: p_actualCaptureIDsArray,
        fyrPlusQmBinLabel: labelsObj.fyrPlusQmBinLabel
      };

      f_onClickNumCapturesBlock(viewFyrSelectedCapturesToViewObjOrUndefined);
    }
  }

  compute_labels_obj = () => {
    const p_fyr = this.props.p_fyr;
    const p_yqmIndex012 = this.props.p_yqmIndex012;
    const p_yqmBinIndex = this.props.p_yqmBinIndex;

    const c_companyFyrMonthsAndQuartersInfoObj = this.props.DatabaseMobx.c_companyFyrMonthsAndQuartersInfoObj;

    var yqmBinLabel = "";
    var fyrPlusQmBinLabel = "FY" + p_fyr;
    if(p_yqmIndex012 === 0) { //yearly
      yqmBinLabel = p_fyr;
    }
    else if(p_yqmIndex012 === 1) { //quarterly
      yqmBinLabel = c_companyFyrMonthsAndQuartersInfoObj.fyrQNamesArray[p_yqmBinIndex];
      fyrPlusQmBinLabel += " " + yqmBinLabel;
    }
    else if(p_yqmIndex012 === 2) { //monthly
      yqmBinLabel = c_companyFyrMonthsAndQuartersInfoObj.fyrMthNamesArray[p_yqmBinIndex];
      fyrPlusQmBinLabel += " " + yqmBinLabel;
    }

    return({
      yqmBinLabel: yqmBinLabel,
      fyrPlusQmBinLabel: fyrPlusQmBinLabel
    })
  }

  render() {
    const p_fyr = this.props.p_fyr;
    const p_yqmIndex012 = this.props.p_yqmIndex012;
    const p_yqmBinIndex = this.props.p_yqmBinIndex;
    const p_quotaInteger = this.props.p_quotaInteger;
    const p_actualInteger = this.props.p_actualInteger;
    const p_actualCaptureIDsArray = this.props.p_actualCaptureIDsArray;
    const p_actualPartialNumCaptures = this.props.p_actualPartialNumCaptures;
    const p_isEditingTF = this.props.p_isEditingTF;
    const p_anyYqmIsEditingTF = this.props.p_anyYqmIsEditingTF;
    const p_isSelectedViewTF = this.props.p_isSelectedViewTF;
    const f_onChange = this.props.f_onChange;
    const f_onKeyDownEnter = this.props.f_onKeyDownEnter;
    const f_onClickNumCapturesBlock = this.props.f_onClickNumCapturesBlock;

    const labelsObj = this.compute_labels_obj();

    const yqmBinLabelComponent = (
      <div className="flex00a textCenter" style={{flexBasis:"2.9em"}}>
        <LibraryReact.NowrapEllipsis p_fontClass="font09 fontItalic fontDarkGreen">
          {labelsObj.yqmBinLabel}
        </LibraryReact.NowrapEllipsis>
      </div>
    );

    if(p_isEditingTF) {
      return(
        <div className="flex11a displayFlexRowVc microBottomMargin">
          {yqmBinLabelComponent}
          <div className="flex11a">
            <LibraryReact.Money
              p_value={p_quotaInteger}
              p_centsTF={false}
              p_class="microBottomMargin"
              p_styleObj={{width:"100%", maxWidth:"10em"}}
              p_tabIndex={(p_yqmBinIndex + 1)}
              p_title={undefined}
              p_placeholder={undefined}
              p_errorTF={undefined}
              f_onChange={this.onchange_goal_value}
              f_onKeyDownEnter={f_onKeyDownEnter}
            />
          </div>
        </div>
      );
    }
    
    const atLeast1CaptureTF = (p_actualPartialNumCaptures > 0);
    const viewingCapturesTF = false; //not passing down which bin is has its capture table currently viewed

    const quotaMoneyDisplay = JSFUNC.money(p_quotaInteger, 0, true);
    const actualMoneyDisplay = JSFUNC.money(p_actualInteger, 0, true);
    const actualMoneyShortDisplay = JSFUNC.money_short(p_actualInteger, true);
    const achievedPercentRoundedDisplay = JSFUNC.percent_fixed_from_numerator_denominator(p_actualInteger, p_quotaInteger, 0, 100);
    const achievedPercent2DecimalsDisplay = JSFUNC.percent_fixed_from_numerator_denominator(p_actualInteger, p_quotaInteger, 2, 100);

    var quotaFontClass = "fontItalic";
    if(p_isSelectedViewTF) {
      if(p_anyYqmIsEditingTF && !p_isEditingTF) {
        quotaFontClass = "fontItalic fontTextLight";
      }
      else {
        quotaFontClass = "";
      }
    }

    var actualFontClass = "fontItalic fontTextLight";
    var actualPercentFontClass = "font09 fontItalic fontTextLighter";
    if(p_isSelectedViewTF) {
      if((p_actualInteger === undefined) || (p_actualInteger >= p_quotaInteger)) {
        actualFontClass = "fontBold fontGreen";
        actualPercentFontClass = "font09 fontGreen";
      }
      else {
        actualFontClass = "fontBold fontDarkRed";
        actualPercentFontClass = "font09 fontDarkRed";
      }
    }

    return(
      <div className={"flex11a displayFlexRowVc " + ((p_yqmBinIndex > 0) ? ("microTopMargin") : ("")) + " " + ((viewingCapturesTF) ? ("border1 bevelBorderColors bgLighterBlue") : (""))}>
        {yqmBinLabelComponent}
        <div className="flex11a" title={labelsObj.fyrPlusQmBinLabel + " Goal: " + quotaMoneyDisplay}>
          <LibraryReact.NowrapEllipsis p_fontClass={quotaFontClass}>
            {quotaMoneyDisplay}
          </LibraryReact.NowrapEllipsis>
        </div>
        {(p_actualInteger !== undefined) &&
          <>
            <div className="flex00a" style={{flexBasis:"7em"}} title={labelsObj.fyrPlusQmBinLabel + " Actual: " + actualMoneyDisplay}>
              <LibraryReact.NowrapEllipsis p_fontClass={actualFontClass}>
                {actualMoneyShortDisplay}
              </LibraryReact.NowrapEllipsis>
            </div>
            <div className="flex00a" style={{flexBasis:"5em"}} title={labelsObj.fyrPlusQmBinLabel + " Achieved Percent of Goal: " + achievedPercent2DecimalsDisplay}>
              <LibraryReact.NowrapEllipsis p_fontClass={actualPercentFontClass}>
                {achievedPercentRoundedDisplay}
              </LibraryReact.NowrapEllipsis>
            </div>
          </>
        }
        {(p_actualPartialNumCaptures !== undefined) &&
          <>
            <div
              className={"flex00a displayFlexColumnHcVc textCenter " + ((atLeast1CaptureTF) ? ("hoverFontUnderline cursorPointer") : ("")) + " " + ((!viewingCapturesTF && atLeast1CaptureTF) ? ("border1 bevelBorderColors bgLightesterGrayGradient") : (""))}
              style={{flexBasis:"3.5em"}}
              title={((atLeast1CaptureTF) ? (p_actualPartialNumCaptures + " " + JSFUNC.plural(p_actualPartialNumCaptures, "Capture", "Captures") + " within " + labelsObj.fyrPlusQmBinLabel + "\n[Click to view Captures below in a table]") : ("No Captures within " + labelsObj.fyrPlusQmBinLabel))}
              onClick={((atLeast1CaptureTF) ? (this.onclick_goal_num_captures_show_capture_table) : (undefined))}>
              <LibraryReact.NowrapEllipsis p_fontClass={((atLeast1CaptureTF) ? ("fontBlue") : ("fontItalic fontTextLightest"))}>
                {p_actualPartialNumCaptures}
              </LibraryReact.NowrapEllipsis>
            </div>
            <div className="flex00a" style={{flexBasis:"0.5em"}} />
          </>
        }
      </div>
    );
  }
}));



const PerformanceTiledGraphs = inject("CaptureExecMobx", "DivexecMobx", "UserMobx")(observer(
class PerformanceTiledGraphs extends Component {
  onselect_divexec_graph_start_date = (i_newValue) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_graphs_start_date", i_newValue, "s");
  }

  onselect_divexec_graph_end_date = (i_newValue) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_graphs_end_date", i_newValue, "s");
  }

  render() {
    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;

    const c_performanceGraphsDataArrayOfObjs = this.props.DivexecMobx.c_performanceGraphsDataArrayOfObjs;
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;

    const performanceStartDateRelative = c_combinedUserObj.divexec_graphs_start_date;
    const performanceEndDateRelative = c_combinedUserObj.divexec_graphs_end_date;
    const performanceStartDateFixed = JSFUNC.convert_relative_ymd_date_to_fixed_date_ymd(performanceStartDateRelative);
    const performanceEndDateFixed = JSFUNC.convert_relative_ymd_date_to_fixed_date_ymd(performanceEndDateRelative);

    var numGraphsPerRow = 1;
    var graphHeightEm = 20;
    if(o_mediaQueryFlag >= 6) {
      numGraphsPerRow = 4;
      graphHeightEm = 30;
    }
    else if(o_mediaQueryFlag >= 5) {
      numGraphsPerRow = 2;
      graphHeightEm = 30;
    }
    else if(o_mediaQueryFlag >= 3) {
      numGraphsPerRow = 2;
    }

    const pageNumGraphs = c_performanceGraphsDataArrayOfObjs.length;
    var graphsComponentsArray = [];
    for(let g = 0; g < pageNumGraphs; g++) {
      graphsComponentsArray.push(
        <DivexecGraph
          p_graphDataObj={c_performanceGraphsDataArrayOfObjs[g]}
          p_startDate={performanceStartDateFixed}
          p_endDate={performanceEndDateFixed}
          p_canEditDeleteReorderTF={false}
          p_canClickSegmentsTF={true}
          p_graphHeightEm={graphHeightEm}
        />
      );
    }

    return(
      <>
        <DivexecStartEndDateEditorRow
          p_startDate={performanceStartDateRelative}
          p_endDate={performanceEndDateRelative}
          p_canEditTF={true}
          f_onChangeStartDate={this.onselect_divexec_graph_start_date}
          f_onChangeEndDate={this.onselect_divexec_graph_end_date}
        />
        <LibraryReact.TileComponents
          p_componentsArray={graphsComponentsArray}
          p_numTilesPerRow={numGraphsPerRow}
          p_tileMarginClass="medFullMargin"
          p_tileClass="displayFlexColumn overflowHidden border bevelBorderColors boxShadowGreenDarkGreenHover"
          p_tileStyleObj={{height:graphHeightEm + "em"}}
        />
      </>
    );
  }
}));


const DivexecStartEndDateEditorRow = inject("DatabaseMobx", "UserMobx")(observer(
class DivexecStartEndDateEditorRow extends Component { //props: p_startDate, p_endDate, p_canEditTF, f_onChangeStartDate, f_onChangeEndDate
  onselect_stages = (i_selectedStageIDsCommaOrAll) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_graphs_selected_stage_ids_comma_or_all", i_selectedStageIDsCommaOrAll, "s");
  }

  render() {
    const p_startDate = this.props.p_startDate;
    const p_endDate = this.props.p_endDate;
    const p_canEditTF = this.props.p_canEditTF;
    const stageSelectFieldTypeObj = this.props.DatabaseMobx.c_selectMultiStagesOrAllFieldTypeObj;
    const selectedStageIDsCommaOrAll = this.props.UserMobx.c_combinedUserObj.divexec_graphs_selected_stage_ids_comma_or_all;
    const stageFieldDisplayName = this.props.DatabaseMobx.c_fieldMapOfStage.get("display_name");
    const addedDateFieldDisplayName = this.props.DatabaseMobx.c_fieldMapOfAddedDate.get("display_name");
    const awardDateFieldDisplayName = this.props.DatabaseMobx.c_fieldMapOfAwardDate.get("display_name");
    const lastStageDateFieldDisplayName = this.props.DatabaseMobx.c_fieldMapOfLastStageDate.get("display_name");

    const containerWidthEm = 30;
    const fieldClass = "fontItalic";
    const fieldWidthEm = 5.5;

    return(
      <>
        <div className="flex00a bgDarkGreen" style={{flexBasis:"0.8em"}} />
        <div className="flex00a displayFlexColumn tbPad lrMedPad bgLighterGreen">
          <div className="flex00a displayFlexRow flexWrap">
            <LibraryReact.DivFont p_fontClass="font10 fontItalic fontTextLight">
              {"Date range filtering uses the " + stageFieldDisplayName + " field: Active captures are filtered by " + addedDateFieldDisplayName + ", Won/Lost captures by " + awardDateFieldDisplayName + ", and No Bid/Cancelled captures by " + lastStageDateFieldDisplayName + "."}
            </LibraryReact.DivFont>
          </div>
          <div className="flex00a displayFlexRow flexWrap microTopMargin borderB1bbb" style={{minHeight:"2.2em"}}>
            <div className="flex00a displayFlexColumnVc" style={{flexBasis:"12em"}}>
              <LibraryReact.DivFont p_fontClass="font11 fontBold fontTextLight">
                {"Graph Controls"}
              </LibraryReact.DivFont>
            </div>
            <div className="flex00a displayFlexColumnVc lrPad" style={{flexBasis:containerWidthEm + "em"}}>
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="divexecGraph_start_date"
                p_fieldDisplayName="Start Date:"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericDateWithRelativeDateFieldTypeObj}
                p_valueRaw={p_startDate}
                p_valueIsEditableTFU={p_canEditTF}
                p_containerClass="tbMicroMargin"
                p_fieldClass={fieldClass}
                p_fieldWidth={fieldWidthEm + "em"}
                p_valueClass=""
                f_onSaveChanged={this.props.f_onChangeStartDate}
              />
            </div>
            <div className="flex00a displayFlexColumnVc lrPad" style={{flexBasis:containerWidthEm + "em"}}>
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="divexecGraph_end_date"
                p_fieldDisplayName="End Date:"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericDateWithRelativeDateFieldTypeObj}
                p_valueRaw={p_endDate}
                p_valueIsEditableTFU={p_canEditTF}
                p_containerClass="tbMicroMargin"
                p_fieldClass={fieldClass}
                p_fieldWidth={fieldWidthEm + "em"}
                p_valueClass=""
                f_onSaveChanged={this.props.f_onChangeEndDate}
              />
            </div>
            <div className="flex11a" />
            <div className="flex00a displayFlexRowVc lrPad" style={{flexBasis:"25em"}}>
              <LibraryReact.DivFont p_class="lrPad" p_fontClass="font10 fontItalic fontTextLight">
                {"Stages:"}
              </LibraryReact.DivFont>
              <div className="flex11a">
                <CEGeneralReact.GenericInputOrSelectFromInputType
                  p_fieldTypeObj={stageSelectFieldTypeObj}
                  p_valueRaw={selectedStageIDsCommaOrAll}
                  f_onChangeOrOnSelect={this.onselect_stages}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}));








//=============================================================================================================================================================================
//=============================================================================================================================================================================

//Financial Projections
export const FinancialProjections = inject("CaptureExecMobx", "DivexecMobx")(observer(
class FinancialProjections extends Component {
  onclick_export_finproj_to_excel_xml = () => {
    const c_finProjObj = this.props.DivexecMobx.c_finProjObj;

    const finProjXmlString = this.props.DivexecMobx.generate_finproj_excel_xml_string(c_finProjObj);
    const downloadFileNameAndExt = "Finanacial Projections " + JSFUNC.now_dateYmd() + " - filter " + c_finProjObj.filterName + ".xml";
    JSFUNC.browser_offer_file_download_from_file_data_string(finProjXmlString, downloadFileNameAndExt);
  }

  onclick_finproj_subtab = (i_selectedFinProjSubTabDbName) => {
    this.props.DivexecMobx.a_finproj_set_selected_subtab(i_selectedFinProjSubTabDbName);
  }

  render() {
    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;
    const o_finProjSelectedSubTabDbName = this.props.DivexecMobx.o_finProjSelectedSubTabDbName;

    const moneyFieldAndExportToExcelComponent = (
      <>
        <div className="flex00a displayFlexColumnVc lrPad borderL1ddd">
          <DivexecEditUserMoneyField p_userFieldDbName="divexec_finproj_money_field_id" />
        </div>
        <div className="flex00a displayFlexColumnHcVc lrPad borderL1ddd textCenter" style={{flexBasis:"13em"}}>
          <CEGeneralReact.CEButton
            p_type="add"
            p_text="Export to Excel"
            f_onClick={this.onclick_export_finproj_to_excel_xml}
          />
        </div>
      </>
    );

    var finProjTopControlsComponent = null;
    if(o_mediaQueryFlag <= 3) { //small screens, 2 rows of controls
      finProjTopControlsComponent = (
        <>
          <div className="flex00a displayFlexRow" style={{height:"5em"}}>
            <DivexecCaptureFilteringPanel />
          </div>
          <div className="flex00a displayFlexRow" style={{height:"4em"}}>
            <div className="flex11a" />
            {moneyFieldAndExportToExcelComponent}
          </div>
        </>
      );
    }
    else { //large screens, 1 row
      finProjTopControlsComponent = (
        <div className="flex11a displayFlexRow">
          <DivexecCaptureFilteringPanel />
          {moneyFieldAndExportToExcelComponent}
        </div>
      );
    }

    var finProjSubTabContentComponent = null;
    if(o_finProjSelectedSubTabDbName === "finProjTableAndGraph") {
      finProjSubTabContentComponent = (
        <FinProjTableAndGraphPage />
      );
    }
    else if(o_finProjSelectedSubTabDbName === "finProjCapturesList") {
      finProjSubTabContentComponent = (
        <div className="flex11a displayFlexColumn overflowHidden smallFullPad">
          <FinProjCapturesTable />
        </div>
      );
    }

    return(
      <>
        <div className="flex00a displayFlexColumn borderB1ddd">
          {finProjTopControlsComponent}
        </div>
        <div className="flex00a displayFlexColumnHcVc borderB1bbb bgLightesterGray" style={{flexBasis:"2.4em"}}>
          <CEGeneralReact.TabsList
            p_tabDbNamesArray={["finProjTableAndGraph", "finProjCapturesList"]}
            p_tabDisplayNamesArray={["Projections Table/Graph", "Projections Capture List"]}
            p_selectedTabDbName={o_finProjSelectedSubTabDbName}
            p_tabHeight="1.5em"
            p_textMaxHeight="1.3em"
            p_tabWidth="15em"
            p_unselectedFontClass=""
            p_unselectedBgClass="bgLightGrayGradient fontBold fontTextLight"
            p_selectedBgClass="bgGreenGradient fontBold fontWhite"
            f_onSelect={this.onclick_finproj_subtab}
          />
        </div>
        {finProjSubTabContentComponent}
      </>
    );
  }
}));


const DivexecCaptureFilteringPanel = inject("DivexecMobx", "DatabaseMobx", "UserMobx")(observer(
class DivexecCaptureFilteringPanel extends Component {
  onclick_finproj_custom_filters = () => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_finproj_custom0_manual1", 0, "i");
  }

  onclick_finproj_manual_fitler = () => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_finproj_custom0_manual1", 1, "i");
  }

  onchange_custom_filter_preset = (i_newValue) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_finproj_filter_preset_id", i_newValue, "i");
  }

  onchange_manual_filter_divisions = (i_newValue) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_finproj_division_ids_comma", i_newValue, "s");
  }

  onchange_manual_filter_stages = (i_newValue) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_finproj_stage_ids_comma", i_newValue, "s");
  }

  render() {
    const finProjCustom0Manual1 = this.props.UserMobx.c_combinedUserObj.divexec_finproj_custom0_manual1;
    const finProjFilterPresetID = this.props.UserMobx.c_combinedUserObj.divexec_finproj_filter_preset_id;
    const finProjDivisionIDsComma = this.props.UserMobx.c_combinedUserObj.divexec_finproj_division_ids_comma;
    const finProjStageIDsComma = this.props.UserMobx.c_combinedUserObj.divexec_finproj_stage_ids_comma;

    const filterButtonWidth = "16em";

    return(
      <div className="flex11a displayFlexRow" style={{minHeight:"4em"}}>
        <div className="flex00a displayFlexColumnHcVc lrMedPad borderR1ddd">
          <DivexecChangeViewButton p_label="Custom Filter Preset" p_width={filterButtonWidth} p_isSelectedTF={(finProjCustom0Manual1 === 0)} f_onClick={this.onclick_finproj_custom_filters} />
          <DivexecChangeViewButton p_label="Manual Filter Divisions/Stages" p_width={filterButtonWidth} p_isSelectedTF={(finProjCustom0Manual1 === 1)} f_onClick={this.onclick_finproj_manual_fitler} />
        </div>
        {(finProjCustom0Manual1 === 0) ? (
          <>
            <div className="flex00a displayFlexRowVc lrMedPad">
              <CapturesReact.MasterPresetsEditorButton
                p_selectedPresetType="filter"
                p_selectedPresetID={finProjFilterPresetID}
              />
            </div>
            <div className="flex11a displayFlexRowVc smallRightMargin" style={{minWidth:"35em"}}>
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="divexecFinProjFilter"
                p_fieldDisplayName="Capture Filter Preset"
                p_fieldTypeObj={this.props.DivexecMobx.c_graphsSelectFilterPresetFieldTypeObj}
                p_valueRaw={finProjFilterPresetID}
                p_valueIsEditableTFU={true}
                p_containerClass="width100"
                p_fieldClass="fontBlue"
                p_fieldWidth="10em"
                f_onSaveChanged={this.onchange_custom_filter_preset}
              />
            </div>
          </>
        ) : (
          <div className="flex11a displayFlexColumnVc lrMedPad" style={{minWidth:"35em"}}>
            <CEGeneralReact.CaptureExecFieldEditSaveCancel
              p_ceEditItemString="divexecFinProjManualFilterDivisions"
              p_fieldDisplayName={"Filtered Division(s) Selected:"}
              p_fieldTypeObj={this.props.DatabaseMobx.c_selectMultiDivisionsFieldTypeObj}
              p_valueRaw={finProjDivisionIDsComma}
              p_valueIsEditableTFU={true}
              p_valuesToNotIncludeArray={undefined}
              p_containerClass="tbMicroMargin"
              p_fieldClass="fontBlue"
              p_fieldWidth="13em"
              p_valueMaxHeight="nowrap"
              p_valueHoverTextTF={true}
              p_fieldValueVerticallyAlignedTF={true}
              f_onSaveChanged={this.onchange_manual_filter_divisions}
            />
            <CEGeneralReact.CaptureExecFieldEditSaveCancel
              p_ceEditItemString="divexecFinProjManualFilterStages"
              p_fieldDisplayName="Filtered Stage(s) Selected:"
              p_fieldTypeObj={this.props.DatabaseMobx.c_selectMultiStagesFieldTypeObj}
              p_valueRaw={finProjStageIDsComma}
              p_valueIsEditableTFU={true}
              p_valuesToNotIncludeArray={undefined}
              p_containerClass="microBottomMargin"
              p_fieldClass="fontBlue"
              p_fieldWidth="13em"
              p_valueMaxHeight="nowrap"
              p_valueHoverTextTF={true}
              p_fieldValueVerticallyAlignedTF={true}
              f_onSaveChanged={this.onchange_manual_filter_stages}
            />
          </div>
        )}
      </div>
    );
  }
}));


const DivexecChangeViewButton = inject("CaptureExecMobx")(observer(
class DivexecChangeViewButton extends Component { //props: p_label, p_width, p_isSelectedTF, f_onClick
  render() {
    const p_label = this.props.p_label;
    const p_width = this.props.p_width;
    const p_isSelectedTF = this.props.p_isSelectedTF;
    const f_onClick = this.props.f_onClick;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;

    return(
      <div
        className={"displayFlexColumnHcVc tbMicroMargin textCenter " + ((p_isSelectedTF) ? (c_productStylingObj.capturesTabSubTabButtonSelectedBgClass) : (c_productStylingObj.capturesTabSubTabButtonUnselectedBgClass + " cursorPointer"))}
        style={{width:p_width, height:"1.4em"}}
        onClick={((p_isSelectedTF) ? (undefined) : (f_onClick))}>
        <LibraryReact.DivFont p_fontClass={((p_isSelectedTF) ? (c_productStylingObj.capturesTabSubTabButtonSelectedFontClass) : (c_productStylingObj.capturesTabSubTabButtonUnselectedFontClass))}>
          {p_label}
        </LibraryReact.DivFont>
      </div>
    );
  }
}));


const FinProjTableAndGraphPage = inject("CaptureExecMobx", "DivexecMobx", "DatabaseMobx", "UserMobx")(observer(
class FinProjTableAndGraphPage extends Component {
  render() {
    const c_currentMainContentLeftEdgeDueToLeftNavEm = this.props.CaptureExecMobx.c_currentMainContentLeftEdgeDueToLeftNavEm;
    const c_currentMainContentAndOpenCaptureRightEdgeDueToRightAndHelpPanelsEm = this.props.CaptureExecMobx.c_currentMainContentAndOpenCaptureRightEdgeDueToRightAndHelpPanelsEm;
    const c_finProjObj = this.props.DivexecMobx.c_finProjObj;
    const c_finProjYearlyGraphObj = this.props.DivexecMobx.c_finProjYearlyGraphObj;
    const c_companyFyrMonthsAndQuartersInfoObj = this.props.DatabaseMobx.c_companyFyrMonthsAndQuartersInfoObj;
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const finprojMoneyValueDisplayName = c_finProjObj.finprojMoneyFieldDisplayName;
    const graphHeightPx = 500;

    //finproj graph estimated width in main content
    var trendGraphEstimatedWidthPx = 300;
    if(JSFUNC.is_number_not_nan_gt_0(window.innerWidth) && JSFUNC.is_number_not_nan_gt_0(c_userFontSizePx)) {
      const openPanelsTotalWidthPx = ((c_currentMainContentLeftEdgeDueToLeftNavEm + c_currentMainContentAndOpenCaptureRightEdgeDueToRightAndHelpPanelsEm) * c_userFontSizePx);
      trendGraphEstimatedWidthPx = Math.round((window.innerWidth - openPanelsTotalWidthPx) * 0.9);
    }

    var yqmDisplayString = "Yearly";
    var finProjGraphTimeBinsString = "yearlyFYR";
    if(c_combinedUserObj.divexec_finproj_view_y0q1m2 === 1) {
      yqmDisplayString = "Quarterly";
      finProjGraphTimeBinsString = "quarterlyFYR";
    }
    else if(c_combinedUserObj.divexec_finproj_view_y0q1m2 === 2) {
      yqmDisplayString = "Monthly";
      finProjGraphTimeBinsString = "monthlyFYR";
    }
    const finProjTimeGraphType = ((c_combinedUserObj.divexec_finproj_view_stackedarea0_vbars1 === 1) ? ("bar") : ("line"));
    
    return(
      <div className="flex11a displayFlexColumn yScroll medFullPad">
        <FinProjFyrMonthlyTable />
        <div className="hugeTopMargin displayFlexColumn">
          <FinProjGraphControls />
        </div>
        <div className="hugeTopMargin">
          <div className="smallBottomMargin textCenter">
            <LibraryReact.NowrapEllipsis p_fontClass="font12 fontBold fontTextLightest">
              {"Waterfall Projections using " + finprojMoneyValueDisplayName + " (" + yqmDisplayString + ")"}
            </LibraryReact.NowrapEllipsis>
          </div>
          <LibraryReact.TimeGraph
            p_categoriesArrayOfObjs={c_finProjYearlyGraphObj.categoriesArrayOfObjs}
            p_timeGraphType={finProjTimeGraphType}
            p_startDate={c_finProjYearlyGraphObj.startDate}
            p_endDate={c_finProjYearlyGraphObj.endDate}
            p_timeBins={finProjGraphTimeBinsString}
            p_fyrStartMonth0to11={c_companyFyrMonthsAndQuartersInfoObj.companyFyrStartMonthIndex0to11}
            p_yLogScaleTF={(c_combinedUserObj.divexec_finproj_view_logy_01 === 1)}
            p_valueFormat="moneyShort"
            p_heightPx={graphHeightPx}
            p_estimatedWidthPx={300}
            p_yAxisWidthEm={4}
            p_fontSizePx={c_userFontSizePx}
            p_legendTF={true}
            f_onClickSegment={undefined}
          />
          <div style={{paddingBottom:"10em"}} />
        </div>
      </div>
    );
  }
}));


const FinProjFyrMonthlyTable = inject("CaptureExecMobx", "DivexecMobx", "DatabaseMobx")(observer(
class FinProjFyrMonthlyTable extends Component {
  render() {
    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;
    const c_finProjObj = this.props.DivexecMobx.c_finProjObj;
    const c_companyFyrMonthsAndQuartersInfoObj = this.props.DatabaseMobx.c_companyFyrMonthsAndQuartersInfoObj;

    const fyrArray = c_finProjObj.fyrArray;
    const fyrMthLabelsArray = c_finProjObj.fyrMthLabelsArray;
    const moneyValueMatrix = c_finProjObj.moneyValueMatrix;
    const totalMoneyValuePerFyrArray = c_finProjObj.totalMoneyValuePerFyrArray;
    const totalTcv = c_finProjObj.totalTcv;

    const nowFyrObj = this.props.DatabaseMobx.convert_date_Ymd_to_fyrYear_fyrMonth0to11_obj(JSFUNC.now_dateYmd());
    const moneyTrueMoneyShortFalse = (o_mediaQueryFlag > 4);
    const companyFyrStartMonthIndex0to11 = c_companyFyrMonthsAndQuartersInfoObj.companyFyrStartMonthIndex0to11;
    const fyrColumnWidth = "5.5em";
    const totalColumnFlexBasis = "125em";

    return(
      <div className="flex00a displayFlexColumn">
        <FinProjMonthLabelsRow p_fyrMthLabelsArray={fyrMthLabelsArray} p_fyrColumnWidth={fyrColumnWidth} p_totalColumnFlexBasis={totalColumnFlexBasis} p_totalTcv={undefined} p_moneyTrueMoneyShortFalse={moneyTrueMoneyShortFalse} />
        {fyrArray.map((m_fyr, m_fyrIndex) =>
          <div key={m_fyr} className={"displayFlexRow tbMicroPad borderT1ddd hoverLighterBlueGradient " + ((m_fyr === nowFyrObj.fyrYear) ? ("bgLighterBlue") : (""))}>
            <div className="flex00a lrPad borderR1ddd" style={{flexBasis:fyrColumnWidth}}>
              <LibraryReact.NowrapEllipsis p_fontClass="fontBold fontTextLight">
                {"FY" + m_fyr}
              </LibraryReact.NowrapEllipsis>
            </div>
            {fyrMthLabelsArray.map((m_fyrMthLabel, m_monthIndex) => {
              const realMonthYearObj = JSFUNC.compute_real_year_month_obj_from_fyr_month_index0to11_and_fyr_start_month0to11(m_fyr, m_monthIndex, companyFyrStartMonthIndex0to11);
              const monthStartJsDateObj = new Date(realMonthYearObj.realYear, realMonthYearObj.realMonthIndex0To11, 1);
              const monthEndJsDateObj = new Date(realMonthYearObj.realYear, (realMonthYearObj.realMonthIndex0To11 + 1), 0);
              const moneyValue = moneyValueMatrix[m_fyrIndex][m_monthIndex];
              const fyrMonthCellHoverText = JSFUNC.get_MjY_date_from_jsdateobj_and_utctf(monthStartJsDateObj, false) + " - " + JSFUNC.get_MjY_date_from_jsdateobj_and_utctf(monthEndJsDateObj, false) + "\n" + JSFUNC.money(moneyValue, 0, true);

              return(
                <div key={m_fyr + "_" + m_fyrMthLabel} className="flex11a borderR1ddd textRight" style={{flexBasis:"100em"}} title={fyrMonthCellHoverText}>
                  <div className="lrPad" style={{border:"solid 1px " + (((m_fyr === nowFyrObj.fyrYear) && (nowFyrObj.fyrMonth0to11 === m_monthIndex)) ? ("#11c") : ("transparent"))}}>
                    <LibraryReact.NowrapEllipsis p_fontClass="">
                      {((moneyTrueMoneyShortFalse) ? (JSFUNC.money(moneyValue, 0, true)) : (JSFUNC.money_short(moneyValue)))}
                    </LibraryReact.NowrapEllipsis>
                  </div>
                </div>
              );
            })}
            <div className="flex11a lrPad textRight" style={{flexBasis:totalColumnFlexBasis}}>
              <LibraryReact.NowrapEllipsis p_fontClass="fontBold fontTextLight">
                {((moneyTrueMoneyShortFalse) ? (JSFUNC.money(totalMoneyValuePerFyrArray[m_fyrIndex], 0, true)) : (JSFUNC.money_short(totalMoneyValuePerFyrArray[m_fyrIndex])))}
              </LibraryReact.NowrapEllipsis>
            </div>
          </div>
        )}
        <FinProjMonthLabelsRow p_fyrMthLabelsArray={fyrMthLabelsArray} p_fyrColumnWidth={fyrColumnWidth} p_totalColumnFlexBasis={totalColumnFlexBasis} p_totalTcv={totalTcv} p_moneyTrueMoneyShortFalse={moneyTrueMoneyShortFalse} />
      </div>
    );
  }
}));


function FinProjMonthLabelsRow(props) { //props: p_fyrMthLabelsArray, p_fyrColumnWidth, p_totalColumnFlexBasis, p_totalTcv, p_moneyTrueMoneyShortFalse
  const fyrMthLabelsArray = props.p_fyrMthLabelsArray;
  const fyrColumnWidth = props.p_fyrColumnWidth
  const totalColumnFlexBasis = props.p_totalColumnFlexBasis;
  const totalTcv = props.p_totalTcv;
  const moneyTrueMoneyShortFalse = props.p_moneyTrueMoneyShortFalse;

  return(
    <div className="displayFlexRow tbMicroPad borderB1bbb" style={{borderTop:"solid 1px #ccc"}}>
      <div className="flex00a lrPad borderR1ddd" style={{flexBasis:fyrColumnWidth}}>
        <LibraryReact.NowrapEllipsis p_fontClass="fontBold fontItalic fontTextLight">
          {"FYR"}
        </LibraryReact.NowrapEllipsis>
      </div>
      {fyrMthLabelsArray.map((m_fyrMthLabel) =>
        <div key={m_fyrMthLabel} className="flex11a lrPad borderR1ddd" style={{flexBasis:"100em"}}>
          <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLight">
            {m_fyrMthLabel}
          </LibraryReact.NowrapEllipsis>
        </div>
      )}
      {(totalTcv !== undefined) ? (
        <div className="flex11a lrPad textRight" style={{flexBasis:totalColumnFlexBasis}}>
          <LibraryReact.NowrapEllipsis p_fontClass="fontBold fontBlue">
            {((moneyTrueMoneyShortFalse) ? (JSFUNC.money(totalTcv, 0, true)) : (JSFUNC.money_short(totalTcv)))}
          </LibraryReact.NowrapEllipsis>
        </div>
      ) : (
        <div className="flex11a lrPad" style={{flexBasis:totalColumnFlexBasis}}>
          <LibraryReact.NowrapEllipsis p_fontClass="fontBold fontItalic fontTextLight">
            {"Total"}
          </LibraryReact.NowrapEllipsis>
        </div>
      )}
    </div>
  );
}





const FinProjGraphControls = inject("CaptureExecMobx", "DivexecMobx", "DatabaseMobx", "UserMobx")(observer(
class FinProjGraphControls extends Component {
  onclick_finproj_expand_collapse_graph_options_button = () => {
    const o_finProjGraphOptionsExpandedTF = this.props.DivexecMobx.o_finProjGraphOptionsExpandedTF;
    this.props.DivexecMobx.a_finproj_set_graph_options_expanded_tf(!o_finProjGraphOptionsExpandedTF);
  }

  onselect_finproj_graph_yqm = (i_selectedYqm012Int) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_finproj_view_y0q1m2", i_selectedYqm012Int, "i");
  }

  onselect_finproj_stacked_area_active_stages = (i_selectedStageIDsComma) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_finproj_stacked_area_active_stage_ids_comma", i_selectedStageIDsComma, "s");
  }

  onselect_finproj_goals_division = (i_selectedDivisionID) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_finproj_goals_division_id", i_selectedDivisionID, "i");
  }

  onchange_finproj_view_date_range = (i_startAndEndDatesSemicolon) => {
    const startAndEndDatesArray = String(i_startAndEndDatesSemicolon).split(";");
    const startDateYmd = ((JSFUNC.date_is_filled_out_tf(startAndEndDatesArray[0])) ? (startAndEndDatesArray[0]) : (JSFUNC.blank_date()));
    const endDateYmd = ((JSFUNC.date_is_filled_out_tf(startAndEndDatesArray[1])) ? (startAndEndDatesArray[1]) : (JSFUNC.blank_date()));
    this.props.UserMobx.a_update_logged_in_user_field(["divexec_finproj_view_start_date", "divexec_finproj_view_end_date"], [startDateYmd, endDateYmd], ["s", "s"]);
  }

  onclick_decrement_fyr_edited = () => {
    const o_finProjGraphEditingGoalFyr = this.props.DivexecMobx.o_finProjGraphEditingGoalFyr;
    this.props.DivexecMobx.a_finproj_set_graph_editing_goal_fyr(o_finProjGraphEditingGoalFyr - 1);
  }

  onclick_increment_fyr_edited = () => {
    const o_finProjGraphEditingGoalFyr = this.props.DivexecMobx.o_finProjGraphEditingGoalFyr;
    this.props.DivexecMobx.a_finproj_set_graph_editing_goal_fyr(o_finProjGraphEditingGoalFyr + 1);
  }

  onsave_finproj_any_yqm = (i_updatedMonthly12CommaString) => {
    const o_finProjGraphEditingGoalFyr = this.props.DivexecMobx.o_finProjGraphEditingGoalFyr;
    this.props.DivexecMobx.a_performance_update_or_insert_fyr_quota(o_finProjGraphEditingGoalFyr, "waterfall_projections_won_goal_12_months_comma", i_updatedMonthly12CommaString);
  }

  onselect_finproj_view_yaxis_log = (i_selectedValue01) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_finproj_view_logy_01", i_selectedValue01, "i");
  }

  onselect_finproj_view_graph_type = (i_selectedValue01) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_finproj_view_stackedarea0_vbars1", i_selectedValue01, "i");
  }

  render() {
    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const o_finProjGraphOptionsExpandedTF = this.props.DivexecMobx.o_finProjGraphOptionsExpandedTF;
    const o_finProjGraphEditingGoalFyr = this.props.DivexecMobx.o_finProjGraphEditingGoalFyr;
    const c_finProjEditingWaterfallGoalSingleFyrYqmObjOrUndefined = this.props.DivexecMobx.c_finProjEditingWaterfallGoalSingleFyrYqmObjOrUndefined;
    const c_closedStageIDsArray = this.props.DatabaseMobx.c_closedStageIDsArray;
    const c_fieldMapOfContractStartDate = this.props.DatabaseMobx.c_fieldMapOfContractStartDate;
    const c_fieldMapOfPeriodOfPerformance = this.props.DatabaseMobx.c_fieldMapOfPeriodOfPerformance;
    const c_genericStartAndEndDatesWithYearsDurationFieldTypeObj = this.props.DatabaseMobx.c_genericStartAndEndDatesWithYearsDurationFieldTypeObj;
    const c_selectDivisionFieldTypeObj = this.props.DatabaseMobx.c_selectDivisionFieldTypeObj;
    const c_selectMultiStagesFieldTypeObj = this.props.DatabaseMobx.c_selectMultiStagesFieldTypeObj;
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;
    const c_userCanEditDivexecPerformanceGoalsTF = this.props.UserMobx.c_userCanEditDivexecPerformanceGoalsTF;

    const yqmValueArray = [0, 1, 2];
    const yqmDisplayArray = ["Yearly", "Quarterly", "Monthly"];
    const swsOptionsObj = {};
    const yqmSelectWithSearchDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("View (Year/Quarter/Month)", yqmValueArray, false, yqmDisplayArray, swsOptionsObj);
    const selectYqmFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", yqmSelectWithSearchDataObj);

    const verticalSelectYAxisLogFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Yaxis Log", [0, 1], false, ["Linear (0,20,40,60,80)", "Logarithmic (1,10,100,1k,10k)"], undefined);
    const verticalSelectGraphTypeFieldTypeObj = this.props.DatabaseMobx.create_verticalswitch_field_type_obj_from_value_array_and_display_array("Graph Type", [0, 1], false, ["Stacked Area Graph", "Vertical Bars"], undefined);

    const graphOptionsExpandCollapseButtonComponent = (
      <div className="flex00a displayFlexRow" style={{width:"19em", height:"2.8em"}}>
        <div className="flex11a displayFlexColumnVc">
          <LibraryReact.DivFont>
            {"Graph Options/Set Waterfall Goals"}
          </LibraryReact.DivFont>
        </div>
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"3em"}}>
          <CEGeneralReact.ButtonExpandCollapse
            p_isExpandedTF={o_finProjGraphOptionsExpandedTF}
            p_sizeEm={2}
            p_bgClass={undefined}
            f_onClick={this.onclick_finproj_expand_collapse_graph_options_button}
          />
        </div>
      </div>
    );

    var graphOptionsComponent = null;
    if(o_finProjGraphOptionsExpandedTF) {
      graphOptionsComponent = (
        <div className="flex00a displayFlexRow flexWrap">
          <div className="flex00a displayFlexColumn medFullMargin">
            <FinProjGraphControlsContainerShell p_label="Graph View Options">
              <div className="flex00a" style={{width:"25em"}}>
                <CEGeneralReact.CaptureExecFieldEditSaveCancel
                  p_ceEditItemString="divexecFinProjGraphYqm"
                  p_fieldDisplayName="View:"
                  p_fieldTypeObj={selectYqmFieldTypeObj}
                  p_valueRaw={c_combinedUserObj.divexec_finproj_view_y0q1m2}
                  p_valueIsEditableTFU={true}
                  p_containerClass="tbMicroMargin"
                  p_fieldClass="fontBlue"
                  p_fieldWidth="10em"
                  f_onSaveChanged={this.onselect_finproj_graph_yqm}
                />
              </div>
              <div className="flex00a" style={{width:"35em"}}>
                <CEGeneralReact.CaptureExecFieldEditSaveCancel
                  p_ceEditItemString="divexecFinProjGraphActiveStages"
                  p_fieldDisplayName="Graph Active Stages:"
                  p_fieldTypeObj={c_selectMultiStagesFieldTypeObj}
                  p_valueRaw={c_combinedUserObj.divexec_finproj_stacked_area_active_stage_ids_comma}
                  p_valuesToNotIncludeArray={c_closedStageIDsArray}
                  p_valueIsEditableTFU={true}
                  p_containerClass="tbMicroMargin"
                  p_fieldClass="fontBlue"
                  p_fieldWidth="10em"
                  f_onSaveChanged={this.onselect_finproj_stacked_area_active_stages}
                />
              </div>
              <div className="flex00a" style={{width:"35em"}}>
                <CEGeneralReact.CaptureExecFieldEditSaveCancel
                  p_ceEditItemString="divexecFinProjGraphDateRange"
                  p_fieldDisplayName="Graph Date Range:"
                  p_fieldTypeObj={c_genericStartAndEndDatesWithYearsDurationFieldTypeObj}
                  p_valueRaw={c_combinedUserObj.divexec_finproj_view_start_date + ";" + c_combinedUserObj.divexec_finproj_view_end_date}
                  p_valueIsEditableTFU={true}
                  p_containerClass="tbMicroMargin"
                  p_fieldClass="fontBlue"
                  p_fieldWidth="10em"
                  f_onSaveChanged={this.onchange_finproj_view_date_range}
                />
              </div>
              <div className="flex00a" style={{width:"35em"}}>
                <CEGeneralReact.CaptureExecFieldEditSaveCancel
                  p_ceEditItemString="divexecFinProjGraphYaxisLog"
                  p_fieldDisplayName="Y-axis:"
                  p_fieldTypeObj={verticalSelectYAxisLogFieldTypeObj}
                  p_valueRaw={c_combinedUserObj.divexec_finproj_view_logy_01}
                  p_valueIsEditableTFU={true}
                  p_containerClass="tbMicroMargin"
                  p_fieldClass="fontBlue"
                  p_fieldWidth="10em"
                  f_onSaveChanged={this.onselect_finproj_view_yaxis_log}
                />
              </div>
              <div className="flex00a" style={{width:"35em"}}>
                <CEGeneralReact.CaptureExecFieldEditSaveCancel
                  p_ceEditItemString="divexecFinProjGraphType"
                  p_fieldDisplayName="Graph Type:"
                  p_fieldTypeObj={verticalSelectGraphTypeFieldTypeObj}
                  p_valueRaw={c_combinedUserObj.divexec_finproj_view_stackedarea0_vbars1}
                  p_valueIsEditableTFU={true}
                  p_containerClass="tbMicroMargin"
                  p_fieldClass="fontBlue"
                  p_fieldWidth="10em"
                  f_onSaveChanged={this.onselect_finproj_view_graph_type}
                />
              </div>
            </FinProjGraphControlsContainerShell>
            <FinProjGraphControlsContainerShell p_label="Set Waterfall Goals" p_class="medTopMargin">
              <div className="flex00a" style={{width:"35em"}}>
                <CEGeneralReact.CaptureExecFieldEditSaveCancel
                  p_ceEditItemString="divexecFinProjGraphGoalsDivision"
                  p_fieldDisplayName="Goals Division:"
                  p_fieldTypeObj={c_selectDivisionFieldTypeObj}
                  p_valueRaw={c_combinedUserObj.divexec_finproj_goals_division_id}
                  p_valueIsEditableTFU={true}
                  p_containerClass="tbMicroMargin"
                  p_fieldClass="fontBlue"
                  p_fieldWidth="10em"
                  f_onSaveChanged={this.onselect_finproj_goals_division}
                />
              </div>
              <div className="flex00a displayFlexRow">
                <div className="flex00a displayFlexRowVc" style={{flexBasis:"12em"}}>
                  <LibraryReact.DivFont p_fontClass="fontBlue">
                    {"Select Waterfall Goal Fyr"}
                  </LibraryReact.DivFont>
                </div>
                <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2em"}}>
                  <CEGeneralReact.ButtonLeftRightCircledCarat p_leftFalseRightTrue={false} p_sizeEm={1.7} p_bgClass="bgLighterGreenGradient" p_title="Decrease the currently editing FYR" f_onClick={this.onclick_decrement_fyr_edited} />
                </div>
                <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"4em"}}>
                  <LibraryReact.DivFont p_class="textCenter" p_fontClass="font12 fontBold">
                    {o_finProjGraphEditingGoalFyr}
                  </LibraryReact.DivFont>
                </div>
                <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2em"}}>
                  <CEGeneralReact.ButtonLeftRightCircledCarat p_leftFalseRightTrue={true} p_sizeEm={1.7} p_bgClass="bgLighterGreenGradient" p_title="Increase the currently editing FYR" f_onClick={this.onclick_increment_fyr_edited} />
                </div>
              </div>
            </FinProjGraphControlsContainerShell>
          </div>
          <div className="flex00a displayFlexColumn medFullMargin bgLightestestGray" style={{width:"30em"}}>
            {(this.props.DatabaseMobx.value_is_filled_out_tf_from_value_raw_and_field_type_obj(c_combinedUserObj.divexec_finproj_goals_division_id, c_selectDivisionFieldTypeObj)) ? (
              <InputYqmEditSaveCancel
                p_fyr={o_finProjGraphEditingGoalFyr}
                p_y0q1m2Selected={c_combinedUserObj.divexec_finproj_view_y0q1m2}
                p_initialYqmObjOrUndefined={c_finProjEditingWaterfallGoalSingleFyrYqmObjOrUndefined}
                p_actualArraysObj={undefined}
                p_cardTitle={"Waterfall Goal for FY" + o_finProjGraphEditingGoalFyr}
                p_cardSubTitle={"A Capture is included in the Waterfall Projections graph both the " + c_fieldMapOfContractStartDate.get("display_name") + " and the " + c_fieldMapOfPeriodOfPerformance.get("display_name") + " are filled out."}
                p_canEditTF={c_userCanEditDivexecPerformanceGoalsTF}
                f_onSaveChanged={this.onsave_finproj_any_yqm}
                f_onClickNumCapturesBlock={undefined}
              />
            ) : (
              <div className="flex11a displayFlexColumnHcVc border1bbb">
                <LibraryReact.DivFont p_fontClass="fontItalic fontTextLight">
                  {"Select a Division to set Waterfall Projection goals."}
                </LibraryReact.DivFont>
              </div>
            )}
          </div>
          <div className="flex11a" />
        </div>
      );
    }

    //small screens - expand/collapse button on top, content below
    if(c_isMobileOrTabletTF) {
      return(
        <div className="flex00a displayFlexColumn bgLightestGray border1bbb borderRadius05">
          <div className="flex00a displayFlexRow">
            <div className="flex11a" />
            <div className="flex00a displayFlexColumn">
              {graphOptionsExpandCollapseButtonComponent}
            </div>
          </div>
          {graphOptionsComponent}
        </div>
      );
    }

    return(
      <div className="flex00a displayFlexRow bgLightestGray border1bbb borderRadius05">
        <div className="flex11a displayFlexColumn">
          {graphOptionsComponent}
        </div>
        <div className="flex00a displayFlexColumn">
          {graphOptionsExpandCollapseButtonComponent}
        </div>
      </div>
    );
  }
}));

function FinProjGraphControlsContainerShell(props) { //props: p_label, p_class, children
  const p_label = props.p_label;
  const p_class = JSFUNC.prop_value(props.p_class, "");

  return(
    <div className={"flex00a border1bbb borderRadius05 smallFullPad " + p_class}>
      <div className="flex00a smallBottomMargin">
        <LibraryReact.DivFont p_fontClass="fontItalic fontTextLight">
          {p_label}
        </LibraryReact.DivFont>
      </div>
      <div className="flex00a">
        {props.children}
      </div>
    </div>
  );
}


const FinProjCapturesTable = inject("CapturesMobx", "DivexecMobx", "DatabaseMobx", "UserMobx")(observer(
class FinProjCapturesTable extends Component {
  onclick_show_all_captures = () => {
    this.props.DivexecMobx.a_finproj_set_max_num_captures(JSFUNC.sort_max_mysqli_int());
  }

  onselect_cst_column_preset = (i_selectedCstColumnPresetID) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_finproj_captures_list_selected_cst_column_preset_id", i_selectedCstColumnPresetID, "i");
  }

  render() {
    const c_selectMyAndPublicColumnPresetsFieldTypeObj = this.props.CapturesMobx.c_selectMyAndPublicColumnPresetsFieldTypeObj;
    const o_finProjMaxNumCaptures = this.props.DivexecMobx.o_finProjMaxNumCaptures;
    const c_finProjObj = this.props.DivexecMobx.c_finProjObj;
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;

    //unpack c_finProjObj
    const finProjCapturesArrayOfObjs = c_finProjObj.finProjCapturesArrayOfObjs;
    const fyrArray = c_finProjObj.fyrArray;
    const numYears = c_finProjObj.numYears;
    const numCaptures = c_finProjObj.numCaptures;
    const filterName = c_finProjObj.filterName;
    const tableColumnFieldsArrayOfObjs = c_finProjObj.tableColumnFieldsArrayOfObjs;

    var columnPresetEditorInitialSelectedPresetTypeOrUndefined = undefined;
    var columnPresetEditorInitialSelectedPresetIDOrUndefined = undefined;
    if(JSFUNC.select_int_is_filled_out_tf(c_combinedUserObj.divexec_finproj_captures_list_selected_cst_column_preset_id)) {
      columnPresetEditorInitialSelectedPresetTypeOrUndefined = "cstColumns";
      columnPresetEditorInitialSelectedPresetIDOrUndefined = c_combinedUserObj.divexec_finproj_captures_list_selected_cst_column_preset_id;
    }

    const captureRowHeight = "2.6em";

    const headerRowHeight = "2.8em";
    const headerCellMaxHeight = "2.4em";
    const headerFontClass = "fontWhite";
    const headerLeftBorder = "solid 1px #bbb";

    const valuePerMonthColumnWidthEm = 10;
    const tableRightFyrColumnWidthEm = 10;
    const tableRightFyrColumnWidth = tableRightFyrColumnWidthEm + "em";
    const totalCaptureColumnsWidthEm = (JSFUNC.sum_of_arrayOfObjs_int_or_decimal_column(tableColumnFieldsArrayOfObjs, "widthEm") - valuePerMonthColumnWidthEm);
    const totalTableRightWidthEm = ((tableRightFyrColumnWidthEm * numYears) + valuePerMonthColumnWidthEm);
    const totalTableWidth = (totalCaptureColumnsWidthEm + totalTableRightWidthEm) + "em";

    return(
      <>
        <div className="displayFlexRow flexWrap microBottomMargin">
          <LibraryReact.DivFont p_class="flex11a displayFlexColumnVc borderR1ddd lrPad" p_fontClass="font13 fontItalic">
            {numCaptures + " " + JSFUNC.plural(numCaptures, "Capture matches", "Captures match") + " filter '" + filterName + "'"}
          </LibraryReact.DivFont>
          <div className="flex00a displayFlexColumn" style={{flexBasis:"35em"}}>
            <div className="flex00a lrMedPad">
              <LibraryReact.DivFont p_fontClass="fontItalic fontTextLight">
                {"Select a Column Preset for custom 'Capture Info' table columns"}
              </LibraryReact.DivFont>
            </div>
            <div className="flex00a displayFlexRowVc">
              <div className="flex11a lrMedPad">
                <CEGeneralReact.GenericInputOrSelectFromInputType
                  p_fieldTypeObj={c_selectMyAndPublicColumnPresetsFieldTypeObj}
                  p_valueRaw={c_combinedUserObj.divexec_finproj_captures_list_selected_cst_column_preset_id}
                  f_onChangeOrOnSelect={this.onselect_cst_column_preset}
                />
              </div>
              <div className="flex00a lrMedPad">
                <CapturesReact.MasterPresetsEditorButton
                  p_selectedPresetType={columnPresetEditorInitialSelectedPresetTypeOrUndefined}
                  p_selectedPresetID={columnPresetEditorInitialSelectedPresetIDOrUndefined}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex11a xyScroll" style={{border:"solid 1px #ccc"}}>
          <div className="flex00a displayFlexColumn" style={{width:totalTableWidth}}>
          <div className="displayFlexRow" style={{height:"2.5em", borderBottom:"bbb"}}>
            <div className="flex00a displayFlexRowVc bgDarkBlueGradient textCenter" style={{flexBasis:totalCaptureColumnsWidthEm + "em"}}>
              <LibraryReact.NowrapEllipsis p_fontClass="font12 fontBold fontWhite">
                {"Capture Info"}
              </LibraryReact.NowrapEllipsis>
            </div>
            <div className="flex00a displayFlexRowVc bgDarkGreenGradient textCenter" style={{flexBasis:totalTableRightWidthEm + "em"}}>
              <LibraryReact.NowrapEllipsis p_fontClass="font12 fontBold fontWhite">
                {"FYR $ Value Per Year"}
              </LibraryReact.NowrapEllipsis>
            </div>
          </div>
          <div style={{borderBottom:"bbb"}}>
            <div className="displayFlexRow bgBlueGradient borderB1ddd" style={{height:headerRowHeight}}>
              {tableColumnFieldsArrayOfObjs.map((m_tableColumnFieldObj, m_index) =>
                <div
                  key={m_tableColumnFieldObj.captureFieldID + "_" + m_index}
                  className="flex00a displayFlexRowVc lrPad textCenter"
                  style={{flexBasis:m_tableColumnFieldObj.widthEm + "em", borderLeft:((m_index > 0) ? (headerLeftBorder) : (undefined))}}
                  title={m_tableColumnFieldObj.displayName}>
                  <LibraryReact.MaxHeightWrap p_maxHeight={headerCellMaxHeight} p_fontClass={headerFontClass}>
                    {m_tableColumnFieldObj.displayName}
                  </LibraryReact.MaxHeightWrap>
                </div>
              )}
              {fyrArray.map((m_fyr) =>
                <div key={m_fyr} className="flex00a displayFlexColumnHcVc" style={{flexBasis:tableRightFyrColumnWidth, borderLeft:headerLeftBorder}}>
                  <LibraryReact.DivFont p_class="textCenter" p_fontClass={headerFontClass}>
                    {m_fyr}
                  </LibraryReact.DivFont>
                </div>
              )}
            </div>
            {finProjCapturesArrayOfObjs.map((m_finProjCaptureObj, m_index) =>
              (m_index < o_finProjMaxNumCaptures) &&
              <FinProjSingleCaptureRow
                key={m_finProjCaptureObj.id}
                p_finProjCaptureObj={m_finProjCaptureObj}
                p_tableColumnFieldsArrayOfObjs={tableColumnFieldsArrayOfObjs}
                p_fyrArray={fyrArray}
                p_captureRowHeight={captureRowHeight}
                p_tableRightFyrColumnWidth={tableRightFyrColumnWidth}
              />
            )}
          </div>
          {(numCaptures > o_finProjMaxNumCaptures) &&
            <div className="smallFullMargin">
              <CEGeneralReact.CEButton
                p_type="blue"
                p_text={"Show all " + numCaptures + " Captures"}
                f_onClick={this.onclick_show_all_captures}
              />
            </div>
          }
          </div>
        </div>
      </>
    );
  }
}));

const FinProjSingleCaptureRow = inject("OpenCaptureMobx")(observer(
class FinProjSingleCaptureRow extends Component { //props: p_finProjCaptureObj, p_tableColumnFieldsArrayOfObjs, p_fyrArray, p_captureRowHeight, p_tableRightFyrColumnWidth
  onclick_open_capture = () => {
    this.props.OpenCaptureMobx.a_open_single_capture(this.props.p_finProjCaptureObj.id);
  }

  render() {
    const p_finProjCaptureObj = this.props.p_finProjCaptureObj;
    const p_tableColumnFieldsArrayOfObjs = this.props.p_tableColumnFieldsArrayOfObjs;
    const p_fyrArray = this.props.p_fyrArray;
    const p_captureRowHeight = this.props.p_captureRowHeight;
    const p_tableRightFyrColumnWidth = this.props.p_tableRightFyrColumnWidth;

    const tableColumnCaptureFieldValueArrayOfObjs = p_finProjCaptureObj.tableColumnCaptureFieldValueArrayOfObjs;

    return(
      <div
        className="displayFlexRow borderB1ddd hoverLighterBlueGradient cursorPointer"
        style={{height:p_captureRowHeight}}
        onClick={this.onclick_open_capture}>
        {p_tableColumnFieldsArrayOfObjs.map((m_tableColumnFieldObj, m_index) =>
          <FinProjSingleCaptureRowCell
            key={m_tableColumnFieldObj.captureFieldID + "_" + m_index}
            p_tableColumnFieldObj={m_tableColumnFieldObj}
            p_tableColumnCaptureFieldValueObj={tableColumnCaptureFieldValueArrayOfObjs[m_index]}
          />
        )}
        {p_finProjCaptureObj.captureMoneyValuePerFyrArray.map((m_fyrTcv, m_index) =>
          <div
            key={p_fyrArray[m_index]}
            className={"flex00a displayFlexRowVc borderL1eee " + ((m_fyrTcv > 0) ? ("") : ("bgLightGray")) + " lrPad textRight"}
            style={{flexBasis:p_tableRightFyrColumnWidth}}>
            <LibraryReact.NowrapEllipsis p_fontClass="">
              {((m_fyrTcv > 0) ? (JSFUNC.money(m_fyrTcv, 0, true)) : (""))}
            </LibraryReact.NowrapEllipsis>
          </div>
        )}
      </div>
    );
  }
}));

function FinProjSingleCaptureRowCell(props) { //props: p_tableColumnFieldObj, p_tableColumnCaptureFieldValueObj
  const p_tableColumnFieldObj = props.p_tableColumnFieldObj;
  const p_tableColumnCaptureFieldValueObj = props.p_tableColumnCaptureFieldValueObj;

  const columnDisplayName = p_tableColumnFieldObj.displayName;
  const columnWidth = p_tableColumnFieldObj.widthEm + "em";

  return(
    <div
      key={columnDisplayName}
      className={"flex00a displayFlexRowVc lrPad " + p_tableColumnCaptureFieldValueObj.cstCellAlignClass}
      style={{flexBasis:columnWidth}}
      title={p_tableColumnCaptureFieldValueObj.valueMaskPlainText}>
      <LibraryReact.MaxHeightWrap p_maxHeight="2.4em">
        {p_tableColumnCaptureFieldValueObj.valueMask}
      </LibraryReact.MaxHeightWrap>
    </div>
  );
}







//=============================================================================================================================================================================
//=============================================================================================================================================================================


export class DailySnapshot extends Component {
  render() {
    return(
      <DivexecGraphsTab />
    );
  }
}

export class TrendAnalyzer extends Component {
  render() {
    return(
      <DivexecGraphsTab />
    );
  }
}


const DivexecGraphsTab = inject("CaptureExecMobx", "DivexecMobx")(observer(
class DivexecGraphsTab extends Component { //props:
  componentDidMount() {
    if(this.props.DivexecMobx.c_graphsSelectedPageID === undefined) {
      this.props.DivexecMobx.a_graphs_initialize_selected_page_id_to_first_option();
    }
  }

  onselect_divexec_num_graphs_per_row = (i_newValue) => {
    const c_graphsSelectedPageObj = this.props.DivexecMobx.c_graphsSelectedPageObj;
    if(c_graphsSelectedPageObj !== undefined) {
      this.props.DivexecMobx.a_graphs_update_page_field(c_graphsSelectedPageObj.id, "num_graphs_per_row", i_newValue, "i");
    }
  }

  onselect_divexec_graph_height = (i_newValue) => {
    const c_graphsSelectedPageObj = this.props.DivexecMobx.c_graphsSelectedPageObj;
    if(c_graphsSelectedPageObj !== undefined) {
      this.props.DivexecMobx.a_graphs_update_page_field(c_graphsSelectedPageObj.id, "graph_height_em", i_newValue, "i");
    }
  }

  onchange_page_start_date = (i_newValue) => {
    const c_graphsSelectedPageObj = this.props.DivexecMobx.c_graphsSelectedPageObj;
    if(c_graphsSelectedPageObj !== undefined) {
      this.props.DivexecMobx.a_graphs_update_page_field(c_graphsSelectedPageObj.id, "start_date", i_newValue, "s");
    }
  }

  onchange_page_end_date = (i_newValue) => {
    const c_graphsSelectedPageObj = this.props.DivexecMobx.c_graphsSelectedPageObj;
    if(c_graphsSelectedPageObj !== undefined) {
      this.props.DivexecMobx.a_graphs_update_page_field(c_graphsSelectedPageObj.id, "end_date", i_newValue, "s");
    }
  }

  render() {
    const c_isMobileTF = this.props.CaptureExecMobx.c_isMobileTF;
    const c_tabDailySnapshotTrueTrendAnalyzerFalse = this.props.DivexecMobx.c_tabDailySnapshotTrueTrendAnalyzerFalse;
    const c_graphsSelectedTabAllPagesArrayOfObjs = this.props.DivexecMobx.c_graphsSelectedTabAllPagesArrayOfObjs;
    const c_graphsSelectedPageObj = this.props.DivexecMobx.c_graphsSelectedPageObj;
    const c_graphsSelectedPageIsReplicaOfPublicPageTF = this.props.DivexecMobx.c_graphsSelectedPageIsReplicaOfPublicPageTF;
    const c_graphsSelectedPageNumGraphsPerRow = this.props.DivexecMobx.c_graphsSelectedPageNumGraphsPerRow;
    const c_graphsSelectedPageGraphHeightEm = this.props.DivexecMobx.c_graphsSelectedPageGraphHeightEm;
    const c_graphsSelectedPageGraphsDataArrayOfObjs = this.props.DivexecMobx.c_graphsSelectedPageGraphsDataArrayOfObjs;

    const numPages = c_graphsSelectedTabAllPagesArrayOfObjs.length;
    const tabErrorMessage = ((numPages === 0) ? ("To get started, push the '[+] Create New Graphs Page' button to create your first page of graphs") : (undefined));

    var selectedPageStartDateRelative = JSFUNC.blank_date();
    var selectedPageEndDateRelative = JSFUNC.blank_date();

    const pageNumGraphs = c_graphsSelectedPageGraphsDataArrayOfObjs.length;
    var graphsComponentsArray = [];
    if(c_graphsSelectedPageObj !== undefined) {
      selectedPageStartDateRelative = c_graphsSelectedPageObj.start_date;
      selectedPageEndDateRelative = c_graphsSelectedPageObj.end_date;
      var selectedPageStartDateFixed = JSFUNC.convert_relative_ymd_date_to_fixed_date_ymd(selectedPageStartDateRelative);
      var selectedPageEndDateFixed = JSFUNC.convert_relative_ymd_date_to_fixed_date_ymd(selectedPageEndDateRelative);

      for(let g = 0; g < pageNumGraphs; g++) {
        graphsComponentsArray.push(
          <DivexecGraph
            p_graphDataObj={c_graphsSelectedPageGraphsDataArrayOfObjs[g]}
            p_startDate={selectedPageStartDateFixed}
            p_endDate={selectedPageEndDateFixed}
            p_canEditDeleteReorderTF={(!c_graphsSelectedPageIsReplicaOfPublicPageTF)}
            p_canClickSegmentsTF={true}
            p_isOnlyItemTF={(pageNumGraphs === 1)}
            p_isLastItemTF={(g === (pageNumGraphs - 1))}
            p_graphHeightEm={c_graphsSelectedPageGraphHeightEm}
            p_selectedPageID={c_graphsSelectedPageObj.id}
          />
        );
      }

      if(!c_graphsSelectedPageIsReplicaOfPublicPageTF) {
        graphsComponentsArray.push(
          <DivexecAddNewGraph />
        );
      }
    }

    return(
      <>
        <div className="flex00a displayFlexRow tbMicroPad borderB1bbb bgLightestGray">
          <LibraryReact.DivFont p_class="flex00a displayFlexColumnHcVc textCenter" p_styleObj={{flexBasis:"5em"}} p_fontClass="font12 fontBold fontItalic fontTextLightester">
            {"Graph Pages:"}
          </LibraryReact.DivFont>
          <div className="flex11a displayFlexRowVc flexWrap lrPad">
            {c_graphsSelectedTabAllPagesArrayOfObjs.map((m_pageObj, m_index) =>
              <GraphPageButton
                key={m_pageObj.id}
                p_pageObj={m_pageObj}
                p_sortNumber={(m_index + 1)}
                p_isOnlyItemTF={(numPages === 1)}
                p_isLastItemTF={(m_index === (numPages - 1))}
              />
            )}
            <CreateNewGraphPageButton />
          </div>
          <div className="flex00a displayFlexColumnHcVc borderL1ddd" style={{flexBasis:"10em"}}>
            <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="fontBold fontItalic fontTextLight">
              {"# Graphs Per Row:"}
            </LibraryReact.DivFont>
            {(c_isMobileTF || c_graphsSelectedPageIsReplicaOfPublicPageTF) ? (
              <div>
                <LibraryReact.DivFont p_fontClass="fontItalic fontTextLight">
                  {c_graphsSelectedPageNumGraphsPerRow}
                </LibraryReact.DivFont>
              </div>
            ) : (
              <div style={{width:"5em"}}>
                {(c_graphsSelectedPageObj !== undefined) &&
                  <CEGeneralReact.GenericInputOrSelectFromInputType
                    p_fieldTypeObj={this.props.DivexecMobx.c_graphsSelectNumGraphsPerRowFieldTypeObj}
                    p_valueRaw={c_graphsSelectedPageNumGraphsPerRow}
                    f_onChangeOrOnSelect={this.onselect_divexec_num_graphs_per_row}
                  />
                }
              </div>
            )}
          </div>
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"8em"}}>
            <LibraryReact.DivFont p_class="microBottomPad" p_fontClass="fontBold fontItalic fontTextLight">
              {"Graph Height:"}
            </LibraryReact.DivFont>
            {(c_graphsSelectedPageIsReplicaOfPublicPageTF) ? (
              <LibraryReact.DivFont p_fontClass="fontItalic fontTextLight">
                {c_graphsSelectedPageGraphHeightEm}
              </LibraryReact.DivFont>
            ) : (
              <div style={{width:"5em"}}>
                {(c_graphsSelectedPageObj !== undefined) &&
                  <CEGeneralReact.GenericInputOrSelectFromInputType
                    p_fieldTypeObj={this.props.DivexecMobx.c_graphsSelectGraphHeightsFieldTypeObj}
                    p_valueRaw={c_graphsSelectedPageGraphHeightEm}
                    f_onChangeOrOnSelect={this.onselect_divexec_graph_height}
                  />
                }
              </div>
            )}
          </div>
        </div>
        {((c_graphsSelectedPageObj !== undefined) && (!c_tabDailySnapshotTrueTrendAnalyzerFalse)) &&
          <DivexecStartEndDateEditorRow
            p_startDate={selectedPageStartDateRelative}
            p_endDate={selectedPageEndDateRelative}
            p_canEditTF={(!c_graphsSelectedPageIsReplicaOfPublicPageTF)}
            f_onChangeStartDate={this.onchange_page_start_date}
            f_onChangeEndDate={this.onchange_page_end_date}
          />
        }
        {(tabErrorMessage === undefined) ? (
          <div className="flex11a displayFlexColumn yScroll yScrollBottomPad">
            <LibraryReact.TileComponents
              p_componentsArray={graphsComponentsArray}
              p_numTilesPerRow={c_graphsSelectedPageNumGraphsPerRow}
              p_tileMarginClass="medFullMargin"
              p_tileClass="displayFlexColumn overflowHidden border bevelBorderColors boxShadowGreenDarkGreenHover"
              p_tileStyleObj={{height:c_graphsSelectedPageGraphHeightEm + "em"}}
            />
          </div>
        ) : (
          <CEGeneralReact.EmptyScreenGray>
            <LibraryReact.DivFont p_fontClass="font16 fontTextLighter">
              {tabErrorMessage}
            </LibraryReact.DivFont>
          </CEGeneralReact.EmptyScreenGray>
        )}
        <EditGraphFloatingBox />
      </>
    );
  }
}));


const GraphPageButton = inject("DivexecMobx", "DatabaseMobx", "UserMobx")(observer(
class GraphPageButton extends Component { //props: p_pageObj, p_sortNumber, p_isOnlyItemTF, p_isLastItemTF
  constructor(props) {
    super(props);
    this.state = {
      s_editingPageTF: false
    }
  }

  onclick_page_button = () => {
    this.props.DivexecMobx.a_graphs_set_selected_page_id(this.props.p_pageObj.id);
  }

  onselect_edit_page = () => {
    this.setState({s_editingPageTF:true});
  }

  onclick_close_editing_page = () => {
    this.setState({s_editingPageTF:false});
  }

  onchange_page_name = (i_changedGraphName) => {
    this.props.DivexecMobx.a_graphs_update_page_field(this.props.p_pageObj.id, "name", i_changedGraphName, "s");
  }

  onswitch_page_is_public = () => {
    const newValue01 = ((this.props.p_pageObj.public_01 === 1) ? (0) : (1));
    this.props.DivexecMobx.a_graphs_update_page_field(this.props.p_pageObj.id, "public_01", newValue01, "i");
  }

  onsave_copy_page_with_new_name = (i_newCopiedPageName) => {
    this.props.DivexecMobx.a_graphs_copy_page(this.props.p_pageObj, i_newCopiedPageName);
  }

  ondelete_graph_page = () => {
    this.props.DivexecMobx.a_graphs_delete_page_and_graphs_from_page_id(this.props.p_pageObj.id);
  }

  ondrop_foreign_graph_onto_page_button = (i_foreignUniqueString, i_foreignDraggedItemID, i_droppedOnItemID) => {
    if(i_foreignUniqueString === "divexecGraphs") { //a uniqueString of divexecGraphs means a graph is being dragged by the resort handle and was dropped onto this page button
      //figure out if the dropped on page is a replica, if so, don't let this movement happen as replica pages do not have real graphs on them
      const isReplicaOfPublicPageTF = (this.props.p_pageObj.replica_of_page_id > 0);
      if(!isReplicaOfPublicPageTF) {
        const draggedGraphID = i_foreignDraggedItemID;
        this.props.DivexecMobx.a_graphs_move_graph_to_end_of_different_page_resort_original_page(draggedGraphID, this.props.p_pageObj);
      }
      else {
        alert("Cannot move Graphs onto replica Pages");
      }
    }
  }

  render() {
    const s_editingPageTF = this.state.s_editingPageTF;

    const p_pageObj = this.props.p_pageObj;
    const p_sortNumber = this.props.p_sortNumber;
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;

    const c_graphsSelectedTabPagesTblName = this.props.DivexecMobx.c_graphsSelectedTabPagesTblName;
    const c_graphsSelectedPageID = this.props.DivexecMobx.c_graphsSelectedPageID;
    const o_userID = this.props.UserMobx.o_userID;
    const c_userCanCreatePublicItemsTF = this.props.UserMobx.c_userCanCreatePublicItemsTF;

    const isSelectedTF = (p_pageObj.id === c_graphsSelectedPageID);
    const isReplicaOfPublicPageTF = (p_pageObj.replica_of_page_id > 0);
    const userCanEditTF = (!isReplicaOfPublicPageTF);

    return(
      <>
        <CEGeneralReact.CEDragToResortItemWithinDbTbl
          p_canResortTF={true}
          p_uniqueString="divexecGraphPageButtons"
          p_itemID={p_pageObj.id}
          p_itemSort={p_sortNumber}
          p_itemSortColumnWidth="2em"
          p_itemSortNumberFontClass={undefined}
          p_isOnlyItemTF={p_isOnlyItemTF}
          p_isLastItemTF={p_isLastItemTF}
          p_outerPadClass="tbMicroPad lrPad"
          p_itemClass={"border bevelBorderColors borderRadius05 " + ((isSelectedTF) ? ("bgGreenGradient") : ("bgLightGrayGradient hoverLightGreenGradient fontTextLight"))}
          p_itemStyleObj={{width:"14em", height:"3.3em"}}
          p_lastItemExtraDropZoneHeight={undefined}
          p_dragEntireItemTrueOnlySortNumberFalse={true}
          p_tblName={c_graphsSelectedTabPagesTblName}
          p_tblSortFieldDbName="sort"
          p_filterFieldNamesArray={["user_id"]}
          p_filterValuesArray={[o_userID]}
          f_onDropForeignItem={this.ondrop_foreign_graph_onto_page_button}>
          <div
            className={"flex11a displayFlexRowVc lrMedPad textCenter " + ((isSelectedTF) ? ("fontWhite") : ("cursorPointer"))}
            title={p_pageObj.name}
            onClick={this.onclick_page_button}>
            <LibraryReact.MaxHeightWrap p_maxHeight="2.3em" p_fontClass="fontBold">
              {p_pageObj.name}
            </LibraryReact.MaxHeightWrap>
          </div>
          {(isReplicaOfPublicPageTF) &&
            <div className="flex00a displayFlexColumnHcVc">
              <DivexecGraphsPagesReplicaIcon
                p_title={"This is a replica of a Public Page created by " + this.props.DatabaseMobx.user_name_mask_plaintext_from_user_id(p_pageObj.created_by_user_id)}
              />
            </div>
          }
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"1.5em"}}>
            <CEGeneralReact.VerticalDotsMenu
              p_menuItemsArrayOfObjs={[
                {
                  displayName: "Edit Page",
                  functionOnClickMenuItem: this.onselect_edit_page
                },
                {
                  displayName: "Copy Page (with graphs)",
                  confirmType: "inputText",
                  confirmTitle: "Copy Page (with graphs)",
                  confirmTextInitialValue: "Copy of " + p_pageObj.name,
                  confirmButton1Name: "Create Copy of This Page",
                  confirmTextMustBeChangedForSaveTFU: false,
                  confirmMessage: "An exact copy of this Page '" + p_pageObj.name + "' will be created next to this Page. If the Page being copied is a replica of someone else's Public Page, you will be able to edit the new private copy.\n\nNew Page Name:",
                  functionOnClickConfirmButton: this.onsave_copy_page_with_new_name
                },
                {
                  displayName: "Delete",
                  confirmType: "confirmDelete",
                  confirmMessage: "Are you sure you want to delete Graphs Page '" + p_pageObj.name + "' and all graphs on that page?",
                  functionOnClickConfirmButton: this.ondelete_graph_page
                }
              ]}
            />
          </div>
        </CEGeneralReact.CEDragToResortItemWithinDbTbl>
        {(s_editingPageTF) &&
          <CEGeneralReact.FloatingBoxWithSaveCancel
            p_trblFlag="smallVertical"
            p_title={"Editing Graph Page '" + p_pageObj.name + "'"}
            f_onClickSave={this.onclick_close_editing_page}>
            <div className="flex11a medFullPad yScroll">
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="divexecPageName"
                p_fieldDisplayName="Page Name"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
                p_valueRaw={p_pageObj.name}
                p_valueIsEditableTFU={userCanEditTF}
                p_containerClass="medBottomMargin"
                p_fieldClass="fontBlue"
                p_fieldWidth="9em"
                f_onSaveChanged={this.onchange_page_name}
              />
              {(isReplicaOfPublicPageTF) &&
                <LibraryReact.DivFont p_fontClass="fontItalic fontTextLighter">
                  {"This is a replica of a Public Page created by " + this.props.DatabaseMobx.user_name_mask_plaintext_from_user_id(p_pageObj.created_by_user_id)}
                </LibraryReact.DivFont>
              }
              {(!isReplicaOfPublicPageTF && c_userCanCreatePublicItemsTF) &&
                <div className="displayFlexRowVc">
                  <div className="flex00a" style={{flexBasis:"9em"}}>
                    <LibraryReact.DivFont p_fontClass="fontBlue">
                      {"Page is Public?"}
                    </LibraryReact.DivFont>
                  </div>
                  <div className="flex11a">
                    <CEGeneralReact.SwitchWithTextAndConfirmBox
                      p_isOnTF={(p_pageObj.public_01 === 1)}
                      p_sizeEm={3}
                      p_onText="Public to everyone"
                      p_offText="Private to me"
                      p_title="Public page can be added to other users' graph tabs while not allowing them to edit it"
                      f_onSwitch={this.onswitch_page_is_public}
                    />
                  </div>
                </div>
              }
            </div>
          </CEGeneralReact.FloatingBoxWithSaveCancel>
        }
      </>
    );
  }
}));


const CreateNewGraphPageButton = inject("DivexecMobx")(observer(
class CreateNewGraphPageButton extends Component { //props:
  constructor(props) {
    super(props);
    this.state = {
      s_creatingNewPageTF: false,
      s_addingPublicPageTF: false
    }
  }

  onclick_create_new_graphs_page_button = () => {
    this.setState({s_creatingNewPageTF:true});
  }

  onclick_confirm_create_new_page = (i_newPageName) => {
    this.props.DivexecMobx.a_graphs_create_new_page(i_newPageName);
    this.onclick_cancel_create_new_page();
  }

  onclick_cancel_create_new_page = () => {
    this.setState({s_creatingNewPageTF:false});
  }

  onclick_add_public_page_button = () => {
    this.setState({s_addingPublicPageTF:true});
  }

  onclick_cancel_add_public_page = () => {
    this.setState({s_addingPublicPageTF:false});
  }

  onclick_public_system_tab = (i_selectedPublicSystemTabDbName) => {
    this.props.DivexecMobx.a_graphs_set_creating_page_or_graph_selected_public_system_tab_db_name(i_selectedPublicSystemTabDbName);
  }

  render() {
    const s_creatingNewPageTF = this.state.s_creatingNewPageTF;
    const s_addingPublicPageTF = this.state.s_addingPublicPageTF;

    const o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName = this.props.DivexecMobx.o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName;
    const c_tabDailySnapshotTrueTrendAnalyzerFalse = this.props.DivexecMobx.c_tabDailySnapshotTrueTrendAnalyzerFalse;
    const c_graphsSelectedTabName = this.props.DivexecMobx.c_graphsSelectedTabName;
    const c_graphsSelectedTabAllPublicPagesPerUserCreatorArrayOfObjs = this.props.DivexecMobx.c_graphsSelectedTabAllPublicPagesPerUserCreatorArrayOfObjs;

    var selectedTabAllPublicOrSystemPagesPerUserCreatorArrayOfObjs = [];
    var systemPublicLabel = "";
    if(o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName === "public") {
      selectedTabAllPublicOrSystemPagesPerUserCreatorArrayOfObjs = c_graphsSelectedTabAllPublicPagesPerUserCreatorArrayOfObjs;
      systemPublicLabel = "Public";
    }
    else if(o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName === "system") {
      var systemPagesArrayOfObjs = [];
      if(c_tabDailySnapshotTrueTrendAnalyzerFalse) {
        systemPagesArrayOfObjs = [
          {id:"dsP1", name:"Company Analysis - Active Captures Only"},
          {id:"dsP2", name:"IDIQs - Active Captures Only"}
        ];
      }
      else {
        systemPagesArrayOfObjs = [
          {id:"taP1", name:"Company Trends"}
        ];
      }
      selectedTabAllPublicOrSystemPagesPerUserCreatorArrayOfObjs = [{
        id: -100,
        userNameMaskPlainText: "[System Page]",
        userNameSort: 1,
        userPagesArrayOfObjs: systemPagesArrayOfObjs
      }];
      systemPublicLabel = "System";
    }

    return(
      <>
        <div className="flex00a displayFlexColumnVc tbMicroMargin lrMargin border1ddd borderRadius05 bgLightGrayGradient" style={{flexBasis:"15em", height:"3.3em"}}>
          <AddNewPageButton p_buttonText="[+] Create New Page" f_onClick={this.onclick_create_new_graphs_page_button} />
          <AddNewPageButton p_buttonText="[o] Add Public Page" f_onClick={this.onclick_add_public_page_button} />
        </div>
        {(s_creatingNewPageTF) &&
          <CEGeneralReact.ConfirmBox
            p_type="inputText"
            p_title={"Create New " + c_graphsSelectedTabName + " Graphs Page Button"}
            p_button1Name="Create New Page"
            p_button2Name="Cancel"
            p_textMustBeFilledOutTF={true}
            f_onClickConfirm={this.onclick_confirm_create_new_page}
            f_onClickCancel={this.onclick_cancel_create_new_page}>
            {"Enter a Name for the New " + c_graphsSelectedTabName + " Graphs Page"}
          </CEGeneralReact.ConfirmBox>
        }
        {(s_addingPublicPageTF) &&
          <CEGeneralReact.FloatingBoxWithSaveCancel
            p_trblFlag="smallVertical"
            p_title="Add a Public/System Page to your Graphs tab"
            f_onClickCancel={this.onclick_cancel_add_public_page}>
            <div className="flex00a displayFlexColumnHcVc borderB1bbb bgLightestGray" style={{flexBasis:"3em"}}>
              <CEGeneralReact.TabsList
                p_tabDbNamesArray={["public", "system"]}
                p_tabDisplayNamesArray={["Public Pages", "System Pages"]}
                p_selectedTabDbName={o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName}
                p_tabHeight="2em"
                p_textMaxHeight="1.8em"
                p_tabWidth="10em"
                p_unselectedFontClass=""
                p_unselectedBgClass="bgLightGrayGradient fontBold fontTextLight"
                p_selectedBgClass="bgGreenGradient fontBold fontWhite"
                f_onSelect={this.onclick_public_system_tab}
              />
            </div>
            {(selectedTabAllPublicOrSystemPagesPerUserCreatorArrayOfObjs.length === 0) ? (
              <CEGeneralReact.EmptyScreenGray>
                {"No one has created any " + systemPublicLabel + " Pages yet"}
              </CEGeneralReact.EmptyScreenGray>
            ) : (
              <div className="flex11a yScroll bgLighterGray medFullPad">
                {selectedTabAllPublicOrSystemPagesPerUserCreatorArrayOfObjs.map((m_publicPagesPerUserCreatorObj, m_index) =>
                  <>
                    <LibraryReact.DivFont p_class={((m_index > 0) ? ("hugeTopMargin borderT1bbb medTopPad") : (""))} p_fontClass="font13 fontBold fontTextLight">
                      {"Created by " + m_publicPagesPerUserCreatorObj.userNameMaskPlainText}
                    </LibraryReact.DivFont>
                    {m_publicPagesPerUserCreatorObj.userPagesArrayOfObjs.map((m_pageObj) =>
                      <AddNewPageSelectPublicPageSingleItem
                        p_pageObj={m_pageObj}
                        f_onClick={this.onclick_cancel_add_public_page}
                      />
                    )}
                  </>
                )}
              </div>
            )}
          </CEGeneralReact.FloatingBoxWithSaveCancel>
        }
      </>
    );
  }
}));

function AddNewPageButton(props) { //props: p_buttonText, f_onClick
  const p_buttonText = props.p_buttonText;
  const f_onClick = props.f_onClick;

  return(
    <div
      className="flex11a displayFlexColumnHcVc lrMargin lrMedPad border1ddd borderRadius05 bgLighterGreenGradient hoverLightestGrayGradient textCenter overflowHidden cursorPointer"
      style={{flexBasis:"100em"}}
      onClick={f_onClick}>
      <LibraryReact.DivFont p_fontClass="font11 fontBold fontBlueLighter">
        {p_buttonText}
      </LibraryReact.DivFont>
    </div>
  );
}


const AddNewPageSelectPublicPageSingleItem = inject("DivexecMobx")(observer(
class AddNewPageSelectPublicPageSingleItem extends Component { //props: p_pageObj, f_onClick
  onclick_public_page_item = () => {
    const p_pageObj = this.props.p_pageObj;
    const f_onClick = this.props.f_onClick;

    this.props.DivexecMobx.a_graphs_add_public_page_as_replica_or_system_page_as_new_page(p_pageObj.id, p_pageObj.name); //pageIDs are positive rowIDs for public pages, and strings like "dsP1" and "taP1" for system

    if(JSFUNC.is_function(f_onClick)) {
      f_onClick();
    }
  }

  render() {
    const p_pageObj = this.props.p_pageObj;
    const f_onClick = this.props.f_onClick;

    const c_graphsSelectedTabUserAllAddedPageIDsArray = this.props.DivexecMobx.c_graphsSelectedTabUserAllAddedPageIDsArray;

    const publicPageAlreadyAddedToUserPageTF = JSFUNC.in_array(p_pageObj.id, c_graphsSelectedTabUserAllAddedPageIDsArray);

    return(
      <div
        className="displayFlexColumnVc smallFullMargin lrMedPad border bevelBorderColors borderRadius10 bgLightGrayGradient hoverLightGreenGradient cursorPointer"
        style={{height:"4em", marginLeft:"2em"}}
        title={p_pageObj.name}
        onClick={this.onclick_public_page_item}>
        <div className="microBottomMargin textRight">
          <LibraryReact.NowrapEllipsis p_fontClass={((publicPageAlreadyAddedToUserPageTF) ? ("fontItalic fontTextLight") : ("fontBlue"))}>
            {((publicPageAlreadyAddedToUserPageTF) ? ("Already added to Graph Pages") : ("Not Yet Added"))}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="">
          <LibraryReact.NowrapEllipsis p_fontClass="font12 fontBold fontTextLighter">
            {p_pageObj.name}
          </LibraryReact.NowrapEllipsis>
        </div>
      </div>
    );
  }
}));


const DivexecGraph = inject("CapturesMobx", "DivexecMobx", "DatabaseMobx", "UserMobx")(observer(
class DivexecGraph extends Component { //props: p_graphDataObj, p_startDate, p_endDate, p_canEditDeleteReorderTF, p_canClickSegmentsTF, p_isOnlyItemTF, p_isLastItemTF, p_graphHeightEm, p_selectedPageID
  onclick_edit_graph = () => {
    this.props.DivexecMobx.a_graphs_set_editing_graph_id(this.props.p_graphDataObj.graphObj.id);
  }

  onclick_circle_graph_segment = (i_categoryCaptureIDsArray, i_categoryLabel) => {
    const categoryCapturesFloatingBoxTitle = "Captures in category '" + i_categoryLabel + "'";
    this.onclick_graph_segment_open_search_results_captures(i_categoryCaptureIDsArray, categoryCapturesFloatingBoxTitle);
  }

  onclick_time_graph_segment = (i_categoryCaptureIDsArray, i_categoryLineDataObj, i_binObj) => {
    const p_graphDataObj = this.props.p_graphDataObj;

    var categoryAndBinDateRangeTitle = "Captures from category '" + i_categoryLineDataObj.label + "'";
    var leftDate = JSFUNC.blank_date();
    var rightDate = JSFUNC.blank_date();
    if(i_binObj !== undefined) { //segment from a single bin within a single category
      leftDate = i_binObj.leftDate;
      rightDate = i_binObj.rightDate;
    }
    const leftDateMask = this.props.DatabaseMobx.get_company_date_format_from_Ymd_date(leftDate);
    const rightDateMask = this.props.DatabaseMobx.get_company_date_format_from_Ymd_date(rightDate);
    categoryAndBinDateRangeTitle += " (" + p_graphDataObj.dateFieldName + " " + leftDateMask + " - " + rightDateMask + ")";  
    
    this.onclick_graph_segment_open_search_results_captures(i_categoryCaptureIDsArray, categoryAndBinDateRangeTitle);
  }

  onclick_graph_segment_open_search_results_captures = (i_captureIDsArray, i_floatingBoxTitle) => {
    const p_graphDataObj = this.props.p_graphDataObj;
    const floatingBoxTitle = i_floatingBoxTitle + " for graph '" + p_graphDataObj.graphObj.graph_title + "'";
    this.props.CapturesMobx.a_set_view_specified_captures_in_floating_box_search_fields_capture_summary_table_capture_ids_array_and_floating_box_title(i_captureIDsArray, floatingBoxTitle);
  }

  onsave_copy_graph_with_new_name = (i_newCopiedGraphTitle) => {
    this.props.DivexecMobx.a_graphs_copy_graph(this.props.p_graphDataObj, i_newCopiedGraphTitle);
  }

  ondelete_graph = () => {
    this.props.DivexecMobx.a_graphs_delete_graph(this.props.p_graphDataObj);
  }

  render() {
    const p_graphDataObj = this.props.p_graphDataObj;
    const p_startDate = this.props.p_startDate;
    const p_endDate = this.props.p_endDate;
    const p_canEditDeleteReorderTF = JSFUNC.prop_value(this.props.p_canEditDeleteReorderTF, true);
    const p_canClickSegmentsTF = JSFUNC.prop_value(this.props.p_canClickSegmentsTF, true);
    const p_isOnlyItemTF = this.props.p_isOnlyItemTF;
    const p_isLastItemTF = this.props.p_isLastItemTF;
    const p_graphHeightEm = JSFUNC.prop_value(this.props.p_graphHeightEm, 28);
    const p_selectedPageID = this.props.p_selectedPageID;

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const graphObj = p_graphDataObj.graphObj;
    const tabDailySnapshotTrueTrendAnalyzerFalse = p_graphDataObj.circleGraphTrueTimeGraphFalse;
    const isReplicaOfPublicGraphTF = (graphObj.replica_of_graph_id > 0);

    const graphTitleHeightEm = 1.9;
    const graphFooterHeightEm = ((tabDailySnapshotTrueTrendAnalyzerFalse) ? (1.6 * graphTitleHeightEm) : (2.2 * graphTitleHeightEm));
    const graphTbMarginEm = 0.6;
    const adjustedGraphHeightEm = (p_graphHeightEm - (graphTbMarginEm * 2) - graphTitleHeightEm - graphFooterHeightEm);
    const adjustedGraphHeightPx = (adjustedGraphHeightEm * c_userFontSizePx);

    return(
      <div className="flex11a displayFlexColumn">
        <CEGeneralReact.CEDragToResortItemWithinDbTbl
          p_canResortTF={p_canEditDeleteReorderTF}
          p_uniqueString="divexecGraphs"
          p_itemID={graphObj.id}
          p_itemSort={graphObj.sort}
          p_itemSortColumnWidth="2.2em"
          p_itemSortNumberFontClass={undefined}
          p_isOnlyItemTF={(p_isOnlyItemTF && false)} //make this always false so that it can always be grabbed to drag the graph onto a page button (even when there's only 1 graph)
          p_isLastItemTF={p_isLastItemTF}
          p_outerPadClass={undefined}
          p_itemClass="flex00a displayFlexRow borderB1ddd"
          p_itemStyleObj={{height:graphTitleHeightEm + "em"}}
          p_lastItemExtraDropZoneHeight={undefined}
          p_dragEntireItemTrueOnlySortNumberFalse={true}
          p_tblName={this.props.DivexecMobx.c_graphsSelectedTabGraphsTblName}
          p_tblSortFieldDbName="sort"
          p_filterFieldNamesArray={["page_id"]}
          p_filterValuesArray={[p_selectedPageID]}>
          <div className="flex11a displayFlexRowVc textCenter borderR1ddd">
            <LibraryReact.NowrapEllipsis p_fontClass="font12 fontBold fontTextLighter">
              {graphObj.graph_title}
            </LibraryReact.NowrapEllipsis>
          </div>
          {(isReplicaOfPublicGraphTF) &&
            <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"1.7em"}}>
              <DivexecGraphsPagesReplicaIcon
                p_title={"This is a replica of a Public Graph created by " + this.props.DatabaseMobx.user_name_mask_plaintext_from_user_id(graphObj.created_by_user_id)}
              />
            </div>
          }
          <CEGeneralReact.EditSaveCancelIcon
            p_iconType={((p_canEditDeleteReorderTF) ? ("edit") : ("blank"))}
            p_title="Edit the properties, filters, categories, and style of this graph"
            f_onClick={this.onclick_edit_graph}
          />
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"1.5em"}}>
            {(p_canEditDeleteReorderTF) &&
              <CEGeneralReact.VerticalDotsMenu
                p_menuItemsArrayOfObjs={[
                  {
                    displayName: "Copy Graph",
                    confirmType: "inputText",
                    confirmTitle: "Copy Graph",
                    confirmTextInitialValue: "Copy of " + graphObj.graph_title,
                    confirmButton1Name: "Create Copy of This Graph",
                    confirmTextMustBeChangedForSaveTFU: false,
                    confirmMessage: "An exact copy of this Graph '" + graphObj.graph_title + "' will be created next to this Graph on this Page. If this graph is someone else's public graph, you will be able to edit the new private copy.\n\nNew Graph Title:",
                    functionOnClickConfirmButton: this.onsave_copy_graph_with_new_name
                  },
                  {
                    displayName: "Delete",
                    confirmType: "confirmDelete",
                    confirmMessage: "Are you sure you want to delete Graph '" + graphObj.graph_title + "' from this page?",
                    functionOnClickConfirmButton: this.ondelete_graph
                  }
                ]}
              />
            }
          </div>
        </CEGeneralReact.CEDragToResortItemWithinDbTbl>
        <div className="flex11a displayFlexColumnVc lrPad">
          <SnapshotGraphOrTrendGraphFromGraphObj
            p_graphDataObj={p_graphDataObj}
            p_startDate={p_startDate}
            p_endDate={p_endDate}
            p_heightPx={adjustedGraphHeightPx}
            p_fontSizePx={Math.round(c_userFontSizePx * 1.1)}
            f_onClickSegment={((p_canClickSegmentsTF) ? ((p_graphDataObj.circleGraphTrueTimeGraphFalse) ? (this.onclick_circle_graph_segment) : (this.onclick_time_graph_segment)) : (undefined))}
          />
        </div>
        <div className="flex00a displayFlexColumnVc borderT1ddd" style={{flexBasis:graphFooterHeightEm + "em"}}>
          {(!tabDailySnapshotTrueTrendAnalyzerFalse) &&
            <div className="microBottomMargin" title={"Date Field: " + p_graphDataObj.dateFieldName}>
              <LibraryReact.NowrapEllipsis p_fontClass="">
                {"Date Field: "}<span className="fontBold fontTextLight">{p_graphDataObj.dateFieldName}</span>
              </LibraryReact.NowrapEllipsis>
            </div>
          }
          <div title={"Capture Filter: " + p_graphDataObj.filterPresetName}>
            <LibraryReact.NowrapEllipsis p_fontClass="">
              {"Capture Filter: "}<span className="fontBold fontTextLight">{p_graphDataObj.filterPresetName}</span>
            </LibraryReact.NowrapEllipsis>
          </div>
          <div title={"Count Field: " + p_graphDataObj.countValueNumCapturesOrMoneyFieldName}>
            <LibraryReact.NowrapEllipsis p_fontClass="">
              {"Count Field: "}<span className="fontBold fontTextLight">{p_graphDataObj.countValueNumCapturesOrMoneyFieldName}</span>
            </LibraryReact.NowrapEllipsis>
          </div>
        </div>
      </div>
    );
  }
}));

const SnapshotGraphOrTrendGraphFromGraphObj = inject("CaptureExecMobx", "DivexecMobx", "DatabaseMobx", "UserMobx")(observer(
class SnapshotGraphOrTrendGraphFromGraphObj extends Component { //props: p_graphDataObj, p_startDate, p_endDate, p_heightPx, p_fontSizePx, f_onClickSegment
  render() {
    const p_graphDataObj = this.props.p_graphDataObj;
    const p_startDate = this.props.p_startDate;
    const p_endDate = this.props.p_endDate;
    const heightPx = this.props.p_heightPx;
    const fontSizePx = this.props.p_fontSizePx;

    const c_currentMainContentLeftEdgeDueToLeftNavEm = this.props.CaptureExecMobx.c_currentMainContentLeftEdgeDueToLeftNavEm;
    const c_currentMainContentAndOpenCaptureRightEdgeDueToRightAndHelpPanelsEm = this.props.CaptureExecMobx.c_currentMainContentAndOpenCaptureRightEdgeDueToRightAndHelpPanelsEm;
    const c_graphsSelectedPageNumGraphsPerRow = this.props.DivexecMobx.c_graphsSelectedPageNumGraphsPerRow;
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const c_companyFyrMonthsAndQuartersInfoObj = this.props.DatabaseMobx.c_companyFyrMonthsAndQuartersInfoObj;

    const graphObj = p_graphDataObj.graphObj;

    if(p_graphDataObj.errorMessage !== undefined) {
      return(
        <div className="flex11a displayFlexColumnHcVc">
          <LibraryReact.DivFont p_class="textCenter" p_fontClass="fontItalic fontTextLighter">
            {p_graphDataObj.errorMessage}
          </LibraryReact.DivFont>
        </div>
      );
    }

    const yAxisLogTF = (graphObj.y_axis_log_01 === 1);
    const legendTF = (graphObj.legend_01 === 1);
    const legendHideZeroCategoriesTF = (graphObj.legend_hide_zero_categories_01 === 1);

    //daily snapshot circle/bar graph
    if(p_graphDataObj.circleGraphTrueTimeGraphFalse) {
      const titlesTF = true;
      const legendTitle = "Categories Field: '" + p_graphDataObj.categoriesFieldName + "'";
      const maxNumDecimals = 1;
      if(JSFUNC.in_array(graphObj.graph_type_p0_vb1_hb2_f3, [1,2,3])) { //1/2/3 bar graph
        const horizontalTF = ((graphObj.graph_type_p0_vb1_hb2_f3 === 2) || (graphObj.graph_type_p0_vb1_hb2_f3 === 3));
        const mirroredTF = (graphObj.graph_type_p0_vb1_hb2_f3 === 3);
        return(
          <LibraryReact.BarGraph
            p_categoriesArrayOfObjs={p_graphDataObj.categoriesArrayOfObjs}
            p_yLogScaleTF={yAxisLogTF}
            p_horizontalTF={horizontalTF}
            p_mirroredTF={mirroredTF}
            p_valueFormat={p_graphDataObj.valueFormatString}
            p_heightPx={heightPx}
            p_titlesTF={titlesTF}
            p_legendTF={legendTF}
            p_legendTitle={legendTitle}
            p_legendTotalValueLabel={p_graphDataObj.totalNumCapturesOrMoneyFieldValueLabel}
            p_legendTotalClickReturnValue={p_graphDataObj.totalCaptureIDsArray}
            p_legendHideZeroCategoriesTF={legendHideZeroCategoriesTF}
            p_fontSizePx={fontSizePx}
            p_maxNumDecimals={maxNumDecimals}
            f_onClickSegment={this.props.f_onClickSegment}
          />
        );
      }

      //0 circle graph
      return(
        <LibraryReact.CircleGraph
          p_categoriesArrayOfObjs={p_graphDataObj.categoriesArrayOfObjs}
          p_heightPx={heightPx}
          p_titlesTF={titlesTF}
          p_legendTF={legendTF}
          p_legendTitle={legendTitle}
          p_legendTotalValueLabel={p_graphDataObj.totalNumCapturesOrMoneyFieldValueLabel}
          p_legendTotalClickReturnValue={p_graphDataObj.totalCaptureIDsArray}
          p_legendHideZeroCategoriesTF={legendHideZeroCategoriesTF}
          p_fontSizePx={fontSizePx}
          p_vacantLabel="--Vacant--"
          p_vacantColor="333"
          p_maxNumDecimals={maxNumDecimals}
          p_innerCircleSize0to1={undefined}
          p_innerCircleColor="ddd"
          p_innerCircleTotalLabelTF={false}
          f_onClickSegment={this.props.f_onClickSegment}
        />
      );
    }

    //trend analyzer line graph
    var timeGraphType = "line"; //(line0_bar1 === 0) is "line"
    if(graphObj.line0_bar1 === 1) { timeGraphType = "lineCumulative"; }
    else if(graphObj.line0_bar1 === 2) { timeGraphType = "bar"; }
    else if(graphObj.line0_bar1 === 3) { timeGraphType = "barPercentOf100"; }

    var trendGraphEstimatedWidthPx = 300;
    if(JSFUNC.is_number_not_nan_gt_0(window.innerWidth) && JSFUNC.is_number_not_nan_gt_0(c_graphsSelectedPageNumGraphsPerRow) && JSFUNC.is_number_not_nan_gt_0(c_userFontSizePx)) {
      const openPanelsTotalWidthPx = ((c_currentMainContentLeftEdgeDueToLeftNavEm + c_currentMainContentAndOpenCaptureRightEdgeDueToRightAndHelpPanelsEm) * c_userFontSizePx);
      trendGraphEstimatedWidthPx = Math.round(((window.innerWidth - openPanelsTotalWidthPx) * 0.9) / c_graphsSelectedPageNumGraphsPerRow);
    }

    return(
      <LibraryReact.TimeGraph
        p_categoriesArrayOfObjs={p_graphDataObj.categoriesArrayOfObjs}
        p_timeGraphType={timeGraphType}
        p_startDate={p_startDate}
        p_endDate={p_endDate}
        p_timeBins={graphObj.time_bins}
        p_fyrStartMonth0to11={c_companyFyrMonthsAndQuartersInfoObj.companyFyrStartMonthIndex0to11}
        p_yLogScaleTF={yAxisLogTF}
        p_valueFormat={p_graphDataObj.valueFormatString}
        p_heightPx={heightPx}
        p_estimatedWidthPx={trendGraphEstimatedWidthPx}
        p_yAxisWidthEm={undefined}
        p_fontSizePx={fontSizePx}
        p_legendTF={legendTF}
        p_legendHideZeroCategoriesTF={legendHideZeroCategoriesTF}
        f_onClickSegment={this.props.f_onClickSegment}
      />
    );
  }
}));





const DivexecAddNewGraph = inject("DivexecMobx")(observer(
class DivexecAddNewGraph extends Component { //props:
  constructor(props) {
    super(props);
    this.state = {
      s_selectPublicGraphFloatingBoxIsOpenTF: false
    };
  }

  onclick_create_new_graph = () => {
    this.props.DivexecMobx.a_graphs_create_new_graph();
  }

  onclick_add_public_graph_open_floating_box = () => {
    this.setState({s_selectPublicGraphFloatingBoxIsOpenTF:true});
  }

  onclick_close_public_graph_floating_box = () => {
    this.setState({s_selectPublicGraphFloatingBoxIsOpenTF:false});
  }

  onclick_public_system_tab = (i_selectedPublicSystemTabDbName) => {
    this.props.DivexecMobx.a_graphs_set_creating_page_or_graph_selected_public_system_tab_db_name(i_selectedPublicSystemTabDbName);
  }

  render() {
    const s_selectPublicGraphFloatingBoxIsOpenTF = this.state.s_selectPublicGraphFloatingBoxIsOpenTF;

    const o_graphsCreatingNewGraphTF = this.props.DivexecMobx.o_graphsCreatingNewGraphTF; //cannot click to create a 2nd graph while a 1st one is being created in the database (edit opens after successful insertion)
    const o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName = this.props.DivexecMobx.o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName;
    const c_tabDailySnapshotTrueTrendAnalyzerFalse = this.props.DivexecMobx.c_tabDailySnapshotTrueTrendAnalyzerFalse;

    const graphTypeString = ((c_tabDailySnapshotTrueTrendAnalyzerFalse) ? ("Snapshot") : ("Trend")) + " Graph";

    if(o_graphsCreatingNewGraphTF) {
      return(
        <div className="flex11a displayFlexColumnHcVc bgLighterGray">
          <LibraryReact.DivFont p_class="textCenter" p_fontClass="font12 fontItalic fontBlueLighter">
            {"Creating New " + graphTypeString + "..."}
          </LibraryReact.DivFont>
        </div>
      );
    }

    return(
      <>
        <div className="flex11a displayFlexColumn bgLighterGray">
          <AddNewGraphAddNewButton
            p_buttonText={"[+] Create a New " + graphTypeString}
            p_hoverText="Create a new custom graph from scratch on this Page"
            f_onclick={this.onclick_create_new_graph}
          />
          <div className="flex00a borderT1bbb" />
          <AddNewGraphAddNewButton
            p_buttonText={"[o] Add a Public/System " + graphTypeString}
            p_hoverText="Select from a list of already built graphs that others have made Public. This will place a 'replica' of that graph which cannot be edited on this Page"
            f_onclick={this.onclick_add_public_graph_open_floating_box}
          />
        </div>
        {(s_selectPublicGraphFloatingBoxIsOpenTF) &&
          <CEGeneralReact.FloatingBoxWithSaveCancel
            p_trblFlag="divexecSelectPublicGraph"
            p_title={"Select a Public " + graphTypeString + " to put on this Page"}
            f_onClickCancel={this.onclick_close_public_graph_floating_box}>
            <div className="flex00a displayFlexColumnHcVc borderB1bbb bgLightestGray" style={{flexBasis:"3em"}}>
              <CEGeneralReact.TabsList
                p_tabDbNamesArray={["public", "system"]}
                p_tabDisplayNamesArray={["Public Graphs", "System Graphs"]}
                p_selectedTabDbName={o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName}
                p_tabHeight="2em"
                p_textMaxHeight="1.8em"
                p_tabWidth="10em"
                p_unselectedFontClass=""
                p_unselectedBgClass="bgLightGrayGradient fontBold fontTextLight"
                p_selectedBgClass="bgGreenGradient fontBold fontWhite"
                f_onSelect={this.onclick_public_system_tab}
              />
            </div>
            <AddNewGraphSelectPublicSystemGraphContent f_onClickClose={this.onclick_close_public_graph_floating_box} />
          </CEGeneralReact.FloatingBoxWithSaveCancel>
        }
      </>
    );
  }
}));

function AddNewGraphAddNewButton(props) { //props: p_buttonText, p_hoverText, f_onclick
  const p_buttonText = props.p_buttonText;
  const p_hoverText = props.p_hoverText;
  const f_onclick = props.f_onclick;

  return(
    <div className="flex11a displayFlexColumn medFullPad" style={{flexBasis:"100em"}}>
      <div
        className="flex11a displayFlexColumnHcVc tbPad lrMedPad border bevelBorderColors bgLighterGreenGradient hoverLightestGrayGradient cursorPointer overflowHidden textCenter"
        title={p_hoverText}
        onClick={f_onclick}>
        <LibraryReact.DivFont p_class="textCenter" p_fontClass="font15 fontItalic fontBlueLighter">
          {p_buttonText}
        </LibraryReact.DivFont>
      </div>
    </div>
  );
}

const AddNewGraphSelectPublicSystemGraphContent = inject("DivexecMobx")(observer(
class AddNewGraphSelectPublicSystemGraphContent extends Component { //props: f_onClickClose
  onclick_select_public_or_system_graph_to_add = (i_selectedPublicOrSystemGraphDataObj) => {
    const f_onClickClose = this.props.f_onClickClose;
    
    const o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName = this.props.DivexecMobx.o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName;

    this.props.DivexecMobx.a_graphs_add_public_graph_as_replica_or_system_graph_as_new(o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName, i_selectedPublicOrSystemGraphDataObj);
 
    if(JSFUNC.is_function(f_onClickClose)) {
      f_onClickClose();
    }
  }

  render() {
    const f_onClickClose = this.props.f_onClickClose;
    
    const o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName = this.props.DivexecMobx.o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName;
    const c_tabDailySnapshotTrueTrendAnalyzerFalse = this.props.DivexecMobx.c_tabDailySnapshotTrueTrendAnalyzerFalse;
    const c_graphsSelectedTabAllPublicGraphsDataPerUserCreatorArrayOfObjs = this.props.DivexecMobx.c_graphsSelectedTabAllPublicGraphsDataPerUserCreatorArrayOfObjs;
    const c_graphsSelectedTabAllSystemGraphsDataPerUserCreatorArrayOfObjs = this.props.DivexecMobx.c_graphsSelectedTabAllSystemGraphsDataPerUserCreatorArrayOfObjs;

    const graphTypeString = ((c_tabDailySnapshotTrueTrendAnalyzerFalse) ? ("Snapshot") : ("Trend")) + " Graph";

    var publicOrSystemGraphsDataPerUserCreatorArrayOfObjs = [];
    var publicSystemLabel = "";
    if(o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName === "public") {
      publicOrSystemGraphsDataPerUserCreatorArrayOfObjs = c_graphsSelectedTabAllPublicGraphsDataPerUserCreatorArrayOfObjs;
      publicSystemLabel = "Public";
    }
    else if(o_graphsCreatingPageOrGraphSelectedPublicSystemTabDbName === "system") {
      publicOrSystemGraphsDataPerUserCreatorArrayOfObjs = c_graphsSelectedTabAllSystemGraphsDataPerUserCreatorArrayOfObjs;
      publicSystemLabel = "System";
    }

    if(publicOrSystemGraphsDataPerUserCreatorArrayOfObjs.length === 0) {
      return(
        <CEGeneralReact.EmptyScreenGray>
          {"No one has created any " + publicSystemLabel + " " + graphTypeString + "s yet"}
        </CEGeneralReact.EmptyScreenGray>
      );
    }

    return(
      <div className="flex11a yScroll bgLighterGray medFullPad">
        {publicOrSystemGraphsDataPerUserCreatorArrayOfObjs.map((m_publicOrSystemGraphDataPerUserCreatorObj, m_index) =>
          <>
            <LibraryReact.DivFont p_class={((m_index > 0) ? ("hugeTopMargin borderT1bbb medTopPad") : (""))} p_fontClass="font13 fontBold fontTextLight">
              {"Created by " + m_publicOrSystemGraphDataPerUserCreatorObj.userNameMaskPlainText}
            </LibraryReact.DivFont>
            {m_publicOrSystemGraphDataPerUserCreatorObj.userGraphsDataArrayOfObjs.map((m_graphDataObj) =>
              <AddNewGraphSelectPublicOrSystemGraphSingleItem
                key={m_graphDataObj.id}
                p_graphDataObj={m_graphDataObj}
                f_onClick={this.onclick_select_public_or_system_graph_to_add}
              />
            )}
          </>
        )}
      </div>
    );
  }
}));

const AddNewGraphSelectPublicOrSystemGraphSingleItem = inject("DivexecMobx", "UserMobx")(observer(
class AddNewGraphSelectPublicOrSystemGraphSingleItem extends Component { //props: p_graphDataObj, f_onClick
  onclick_public_graph_item = () => {
    if(JSFUNC.is_function(this.props.f_onClick)) {
      this.props.f_onClick(this.props.p_graphDataObj);
    }
  }

  render() {
    const p_graphDataObj = this.props.p_graphDataObj;

    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;

    const c_graphsSelectedTabUserAllAddedGraphIDsObjOfArrays = this.props.DivexecMobx.c_graphsSelectedTabUserAllAddedGraphIDsObjOfArrays;
    const c_graphsSelectedPageObj = this.props.DivexecMobx.c_graphsSelectedPageObj;

    const graphObj = p_graphDataObj.graphObj;
    const rowHeightEm = 15;
    const graphHeightPx = Math.round(rowHeightEm * c_userFontSizePx * 0.9);

    const pageNamesCommaWherePublicGraphAlreadyAdded = JSFUNC.get_first_array2_value_or_undefined_where_array1_matches_input(graphObj.id, c_graphsSelectedTabUserAllAddedGraphIDsObjOfArrays.graphIDsArray, c_graphsSelectedTabUserAllAddedGraphIDsObjOfArrays.pageNamesCommaArray);
    const publicGraphAlreadyAddedToAnyUserPageTF = (pageNamesCommaWherePublicGraphAlreadyAdded !== undefined);
    const publicGraphAlreadyAddedMessage = ((publicGraphAlreadyAddedToAnyUserPageTF) ? ("Already added to " + pageNamesCommaWherePublicGraphAlreadyAdded) : ("Not Yet Added"));
    
    return(
      <div
        className="displayFlexRow tbMargin border bevelBorderColors bgWhite hoverLighterBlueGradient smallFullPad cursorPointer"
        style={{height:rowHeightEm + "em", marginLeft:"1em"}}
        onClick={this.onclick_public_graph_item}>
        <div className="flex11a displayFlexColumn lrMedPad borderR1ddd" style={{flexBasis:"100em"}}>
          <div className="flex11a displayFlexColumnVc">
            <LibraryReact.DivFont p_fontClass="font12 fontTextLight">
              {graphObj.graph_title}
            </LibraryReact.DivFont>
          </div>
          <div className="flex00a" title={publicGraphAlreadyAddedMessage}>
            <LibraryReact.NowrapEllipsis p_fontClass={((publicGraphAlreadyAddedToAnyUserPageTF) ? ("fontItalic fontTextLight") : ("fontItalic fontBlue"))}>
              {"[" + publicGraphAlreadyAddedMessage + "]"}
            </LibraryReact.NowrapEllipsis>
          </div>
        </div>
        <div className="flex11a displayFlexRowVc lrMedMargin overflowHidden" style={{flexBasis:"150em"}}>
          <SnapshotGraphOrTrendGraphFromGraphObj
            p_graphDataObj={p_graphDataObj}
            p_startDate={JSFUNC.convert_relative_ymd_date_to_fixed_date_ymd(c_graphsSelectedPageObj.start_date)}
            p_endDate={JSFUNC.convert_relative_ymd_date_to_fixed_date_ymd(c_graphsSelectedPageObj.end_date)}
            p_heightPx={graphHeightPx}
            p_fontSizePx={c_userFontSizePx}
            f_onClickSegment={undefined}
          />
        </div>
      </div>
    );
  }
}));






const EditGraphFloatingBox = inject("CaptureExecMobx", "DivexecMobx", "DatabaseMobx", "UserMobx")(observer(
class EditGraphFloatingBox extends Component { //props:
  constructor(props) {
    super(props);
    this.state = {
      s_customColorsEditorIsExpandedTF: true
    }
  }

  onsave_graph_title = (i_newValue) => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, "graph_title", i_newValue, "s");
  }

  onswitch_graph_is_public = () => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    const c_graphsEditingGraphDataObj = this.props.DivexecMobx.c_graphsEditingGraphDataObj;
    const newValue01 = ((c_graphsEditingGraphDataObj.graphObj.public_01 === 1) ? (0) : (1));
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, "public_01", newValue01, "i");
  }

  onsave_filter_preset = (i_newValue) => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, "filter_preset_id", i_newValue, "i");
  }

  onsave_date_field = (i_newValue) => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, "date_field_id", i_newValue, "i");
  }

  onclick_use_categories_tab = (i_newValue01) => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;

    var updatedCategoriesCustomColorsColonCommaList = "";
    if(i_newValue01 === 1) { //changing from single data series to categories - full reset with no custom colors (categories_field_id is set to -1, so no options to fetch)
      updatedCategoriesCustomColorsColonCommaList = "";
    }
    else { //changing from categories to single data series - set single color as black to initialize
      updatedCategoriesCustomColorsColonCommaList = "000000";
    }
    
    const fieldNamesArray = ["use_categories_field_01", "categories_field_id", "all_categories_01", "categories_option_ids_comma", "categories_include_not_set_01", "categories_custom_colors_colon_comma_list"];
    const valuesArray = [i_newValue01, -1, 1, "", 1, updatedCategoriesCustomColorsColonCommaList];
    const idsbArray = ["i", "i", "i", "s", "i", "s"];
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, fieldNamesArray, valuesArray, idsbArray);
  }

  onsave_categories_field = (i_newValue) => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    const c_graphsEditingGraphDataObj = this.props.DivexecMobx.c_graphsEditingGraphDataObj;
    
    var updatedCategoriesCustomColorsColonCommaList = "";
    if(c_graphsEditingGraphDataObj.graphObj.categories_custom_colors_01 === 1) { //if custom colors is on
      updatedCategoriesCustomColorsColonCommaList = this.initialize_categories_custom_colors_colon_comma_list(i_newValue, false, "", false, undefined);
    }

    var fieldDbNamesArray = ["categories_field_id", "categories_option_ids_comma", "categories_custom_colors_colon_comma_list"];
    var valuesArray = [i_newValue, "", updatedCategoriesCustomColorsColonCommaList];
    var idsbArray = ["i", "s", "s"];
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, fieldDbNamesArray, valuesArray, idsbArray);
  }

  onswitch_use_all_categories = () => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    const c_graphsEditingGraphDataObj = this.props.DivexecMobx.c_graphsEditingGraphDataObj;

    const newValue01 = ((c_graphsEditingGraphDataObj.graphObj.all_categories_01 === 1) ? (0) : (1));
    var fieldDbNamesArray = ["all_categories_01"];
    var valuesArray = [newValue01];
    var idsbArray = ["i"];
    if(c_graphsEditingGraphDataObj.graphObj.categories_custom_colors_01 === 1) { //if custom colors is on
      const updatedCategoriesCustomColorsColonCommaList = this.initialize_categories_custom_colors_colon_comma_list(false, newValue01, false, false, false);
      fieldDbNamesArray.push("categories_custom_colors_colon_comma_list");
      valuesArray.push(updatedCategoriesCustomColorsColonCommaList);
      idsbArray.push("s");
    }
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, fieldDbNamesArray, valuesArray, idsbArray);
  }

  onsave_categories_options = (i_newValue) => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    const c_graphsEditingGraphDataObj = this.props.DivexecMobx.c_graphsEditingGraphDataObj;

    var fieldDbNamesArray = ["categories_option_ids_comma"];
    var valuesArray = [i_newValue];
    var idsbArray = ["s"];
    if(c_graphsEditingGraphDataObj.graphObj.categories_custom_colors_01 === 1) { //if custom colors is on
      const updatedCategoriesCustomColorsColonCommaList = this.initialize_categories_custom_colors_colon_comma_list(false, false, i_newValue, false, false);
      fieldDbNamesArray.push("categories_custom_colors_colon_comma_list");
      valuesArray.push(updatedCategoriesCustomColorsColonCommaList);
      idsbArray.push("s");
    }
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, fieldDbNamesArray, valuesArray, idsbArray);
  }

  onswitch_categories_include_not_set = (i_newValue01) => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    const c_graphsEditingGraphDataObj = this.props.DivexecMobx.c_graphsEditingGraphDataObj;
    
    var fieldDbNamesArray = ["categories_include_not_set_01"];
    var valuesArray = [i_newValue01];
    var idsbArray = ["i"];
    if(c_graphsEditingGraphDataObj.graphObj.categories_custom_colors_01 === 1) { //if custom colors is on
      const updatedCategoriesCustomColorsColonCommaList = this.initialize_categories_custom_colors_colon_comma_list(false, false, false, i_newValue01, false);
      fieldDbNamesArray.push("categories_custom_colors_colon_comma_list");
      valuesArray.push(updatedCategoriesCustomColorsColonCommaList);
      idsbArray.push("s");
    }
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, fieldDbNamesArray, valuesArray, idsbArray);
  }

  onswitch_categories_custom_colors = (i_newValue01) => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;

    this.setState({s_customColorsEditorIsExpandedTF:true});
    
    var fieldDbNamesArray = ["categories_custom_colors_01"];
    var valuesArray = [i_newValue01];
    var idsbArray = ["i"];
    if(i_newValue01 === 1) { //if in 'Multiple Data Series' and if switching custom colors on, recalculate list
      const updatedCategoriesCustomColorsColonCommaList = this.initialize_categories_custom_colors_colon_comma_list(false, false, false, false, false);
      fieldDbNamesArray.push("categories_custom_colors_colon_comma_list");
      valuesArray.push(updatedCategoriesCustomColorsColonCommaList);
      idsbArray.push("s");
    }
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, fieldDbNamesArray, valuesArray, idsbArray);
  }

  onsave_categories_custom_colors_trend_analyzer_single_data_series_single_color = (i_newValue) => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, "categories_custom_colors_colon_comma_list", i_newValue, "s");
  }

  onclick_reset_custom_colors_to_ce_standard_unique_colors = () => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    const updatedCategoriesCustomColorsColonCommaList = this.initialize_categories_custom_colors_colon_comma_list(false, false, false, false, undefined);
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, "categories_custom_colors_colon_comma_list", updatedCategoriesCustomColorsColonCommaList, "s");
  }

  onclick_expand_collapse_custom_colors_editor = () => {
    const s_customColorsEditorIsExpandedTF = this.state.s_customColorsEditorIsExpandedTF;
    this.setState({s_customColorsEditorIsExpandedTF:!s_customColorsEditorIsExpandedTF});
  }

  onswitch_legend = (i_newValue01) => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, "legend_01", i_newValue01, "i");
  }
  
  onswitch_legend_hide_zero_categories = (i_newValue01) => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, "legend_hide_zero_categories_01", i_newValue01, "i");
  }

  onclick_time_bins_button = (i_newValue) => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, "time_bins", i_newValue, "s");
  }

  onclick_num_captures_or_capture_money_field_button = (i_newValue) => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, "num_captures_m2_or_money_field_id", i_newValue, "i");
  }
  
  onswitch_ignore_shared_percent_calcs = (i_newValue01) => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, "ignore_shared_percent_calcs_01", i_newValue01, "i");
  }

  onclick_y_axis_linear_log_button = (i_newValue01) => {
    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, "y_axis_log_01", i_newValue01, "i");
  }

  onclick_close_editing_graph = () => {
    this.props.DivexecMobx.a_graphs_set_editing_graph_id(undefined);
  }

  initialize_categories_custom_colors_colon_comma_list = (i_categoriesCaptureFieldID, i_allCategories01, i_categoriesOptionsIDsComma, i_categoriesIncludeNotSet01, i_previousCategoriesCustomColorsColonCommaListOrUndefined=undefined) => {
    const c_graphsEditingGraphDataObj = this.props.DivexecMobx.c_graphsEditingGraphDataObj;

    const graphObj = c_graphsEditingGraphDataObj.graphObj;

    //inputs set to 'false' is a flag to load their previous value from the currently edited graphObj
    var categoriesCaptureFieldID = i_categoriesCaptureFieldID;
    if(i_categoriesCaptureFieldID === false) {
      categoriesCaptureFieldID = graphObj.categories_field_id;
    }

    var allCategories01 = i_allCategories01;
    if(i_allCategories01 === false) {
      allCategories01 = graphObj.all_categories_01;
    }

    var categoriesOptionsIDsComma = i_categoriesOptionsIDsComma;
    if(i_categoriesOptionsIDsComma === false) {
      categoriesOptionsIDsComma = graphObj.categories_option_ids_comma;
    }

    var categoriesIncludeNotSet01 = i_categoriesIncludeNotSet01;
    if(i_categoriesIncludeNotSet01 === false) {
      categoriesIncludeNotSet01 = graphObj.categories_include_not_set_01;
    }

    var previousCategoriesCustomColorsColonCommaListOrUndefined = i_previousCategoriesCustomColorsColonCommaListOrUndefined;
    if(i_previousCategoriesCustomColorsColonCommaListOrUndefined === false) {
      previousCategoriesCustomColorsColonCommaListOrUndefined = graphObj.categories_custom_colors_colon_comma_list;
    }

    //alert("categoriesCaptureFieldID: " + categoriesCaptureFieldID + "\nallCategories01: " + allCategories01 + "\ncategoriesOptionsIDsComma: " + categoriesOptionsIDsComma + "\ncategoriesIncludeNotSet01: " + categoriesIncludeNotSet01 + "\npreviousCategoriesCustomColorsColonCommaListOrUndefined: " + previousCategoriesCustomColorsColonCommaListOrUndefined)

    //1. determine if 'all options' or 'select options' is selected, build an array of optionIDs
    var categoryOptionIDsArray = [];
    if(allCategories01 === 1) { //1a. fetch all possible options from the categories captureFieldID (value/display already in sort order in c_tbl_captures_fields)
      const categoriesOptionsObj = DivexecMobx.graphs_get_category_capture_field_option_ids_array_and_names_array_obj_from_categories_capture_field_id(categoriesCaptureFieldID);

      if(categoriesOptionsObj.valuesAreStringsTF) {
        return("");
      }

      categoryOptionIDsArray = categoriesOptionsObj.optionValuesArray;
    }
    else { //1b. use i_categoriesOptionsIDsComma in the order they are in
      categoryOptionIDsArray = JSFUNC.convert_comma_list_to_int_array(categoriesOptionsIDsComma);
    }

    //2. if Not Set is to be included, add a fake option for it here
    if((categoriesIncludeNotSet01 === 1) && !JSFUNC.in_array(-1, categoryOptionIDsArray)) {
      categoryOptionIDsArray.push(-1);
    }

    //3. optionally apply the i_previousCategoriesCustomColorsColonCommaListOrUndefined color mappings to this new fetch of options to try and keep as many colors the same after this processing
    var previousColorsTF = false;
    var previousCategoriesCustomColorsArrayOfObjs = [];
    if(previousCategoriesCustomColorsColonCommaListOrUndefined !== undefined) {
      var previousCategoriesCustomColorsArrayOfObjs = JSFUNC.convert_colon_comma_list_to_ints_arrayOfObjs(previousCategoriesCustomColorsColonCommaListOrUndefined, "prevCategoryOptionID", "prevColor", "string");
      if(JSFUNC.is_array_not_empty(previousCategoriesCustomColorsArrayOfObjs)) {
        previousColorsTF = true;
      }
    }

    var graphCategoriesCustomColorsArrayOfObjs = [];
    var uniqueColorIndex = 0;
    for(let categoryOptionID of categoryOptionIDsArray) {
      var color = JSFUNC.unique_color(uniqueColorIndex); //if there are 0 previous colors, fill in all colors with unique_color() standard set
      if(previousColorsTF) {
        color = "000000"; //if any previous colors were created, fill in all that do not match any entries with black
        var matchingCategoryOptionIDCustomColorObjOrUndefined = JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(previousCategoriesCustomColorsArrayOfObjs, "prevCategoryOptionID", categoryOptionID);
        if(matchingCategoryOptionIDCustomColorObjOrUndefined !== undefined) {
          color = matchingCategoryOptionIDCustomColorObjOrUndefined.prevColor;
        }
      }

      graphCategoriesCustomColorsArrayOfObjs.push({
        categoryOptionID: categoryOptionID,
        color: color
      });

      uniqueColorIndex++;
    }

    return(JSFUNC.convert_arrayOfObjs_to_colon_comma_list(graphCategoriesCustomColorsArrayOfObjs, "categoryOptionID", "color"));
  }

  render() {
    const s_customColorsEditorIsExpandedTF = this.state.s_customColorsEditorIsExpandedTF;

    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_tabDailySnapshotTrueTrendAnalyzerFalse = this.props.DivexecMobx.c_tabDailySnapshotTrueTrendAnalyzerFalse;
    const c_graphsEditingGraphDataObj = this.props.DivexecMobx.c_graphsEditingGraphDataObj;
    const c_graphsSelectedPageObj = this.props.DivexecMobx.c_graphsSelectedPageObj;
    const c_graphsEditingGraphSelectMultiCategoriesOptionsFieldTypeObj = this.props.DivexecMobx.c_graphsEditingGraphSelectMultiCategoriesOptionsFieldTypeObj;
    const c_companyFyrMonthsAndQuartersInfoObj = this.props.DatabaseMobx.c_companyFyrMonthsAndQuartersInfoObj;
    const c_fieldMapOfCaptureManagers = this.props.DatabaseMobx.c_fieldMapOfCaptureManagers;
    const c_fieldMapOfDivisionOwners = this.props.DatabaseMobx.c_fieldMapOfDivisionOwners;
    const c_userFontSizePx = this.props.UserMobx.c_userFontSizePx;
    const c_userCanCreatePublicItemsTF = this.props.UserMobx.c_userCanCreatePublicItemsTF;

    if(c_graphsEditingGraphDataObj === undefined) {
      return(null);
    }

    const graphTypeIconHeightPx = (5 * c_userFontSizePx);
    const graphTypeIconEstimatedWidthPx = graphTypeIconHeightPx;
    const graphOptionsSwitchSizeEm = 2.8;
    const graphCategoriesOptionsFieldWidthEm = 11;
    const graphOptionsFieldWidthEm = 10.5;
    const graphPreviewMaxHeightEm = ((c_graphsSelectedPageObj.graph_height_em < 35) ? (c_graphsSelectedPageObj.graph_height_em) : (35)); //limit height of the preview graph in case creating one that is 80em tall, hard to see within editor
    
    const graphObj = c_graphsEditingGraphDataObj.graphObj;

    const isReplicaOfPublicGraphTF = JSFUNC.is_number_not_nan_gt_0(graphObj.replica_of_graph_id);
    const userCanEditTF = (!isReplicaOfPublicGraphTF);
    const useCategoriesFieldTF = (graphObj.use_categories_field_01 !== 0);
    const chooseSpecificCategoriesSelectedTF = (graphObj.all_categories_01 === 0);
    const customColorsTF = (graphObj.categories_custom_colors_01 === 1);

    var selectedGraphTypePieTF = false;
    var selectedGraphTypeVerticalBarTF = false;
    var selectedGraphTypeHorizontalBarTF = false;
    var selectedGraphTypeFunnelTF = false;
    if(graphObj.graph_type_p0_vb1_hb2_f3 === 0) { selectedGraphTypePieTF = true; }
    else if(graphObj.graph_type_p0_vb1_hb2_f3 === 1) { selectedGraphTypeVerticalBarTF = true; }
    else if(graphObj.graph_type_p0_vb1_hb2_f3 === 2) { selectedGraphTypeHorizontalBarTF = true; }
    else if(graphObj.graph_type_p0_vb1_hb2_f3 === 3) { selectedGraphTypeFunnelTF = true; }

    const selectedGraphTypeHasYAxisTF = (!c_tabDailySnapshotTrueTrendAnalyzerFalse || selectedGraphTypeVerticalBarTF || selectedGraphTypeHorizontalBarTF || selectedGraphTypeFunnelTF);
    const isTrendGraphSingleDataSeriesTF = (!c_tabDailySnapshotTrueTrendAnalyzerFalse && !useCategoriesFieldTF);

    //floating box title
    var editingGraphFloatingBoxTitle = "Editing Graph #" + graphObj.sort + " on Page '" + c_graphsSelectedPageObj.name + "'";
    if(JSFUNC.string_is_filled_out_tf(graphObj.graph_title)) {
      editingGraphFloatingBoxTitle += " - " + graphObj.graph_title;
    }
    else {
      editingGraphFloatingBoxTitle += " [New Unnamed Graph]";
    }

    //compute the fixed start/end date values for trend analyzer graphs
    var selectedPageStartDateFixed = undefined;
    var selectedPageEndDateFixed = undefined;
    if(!c_tabDailySnapshotTrueTrendAnalyzerFalse) {
      selectedPageStartDateFixed = JSFUNC.convert_relative_ymd_date_to_fixed_date_ymd(c_graphsSelectedPageObj.start_date);
      selectedPageEndDateFixed = JSFUNC.convert_relative_ymd_date_to_fixed_date_ymd(c_graphsSelectedPageObj.end_date);
    }

    //compute the custom colors arrayOfObjs if set
    var graphCategoriesCustomColorsArrayOfObjs = [];
    if(customColorsTF) {
      graphCategoriesCustomColorsArrayOfObjs = JSFUNC.convert_colon_comma_list_to_ints_arrayOfObjs(graphObj.categories_custom_colors_colon_comma_list, "categoryOptionID", "color", "string");
      for(let categoryCustomColorObj of graphCategoriesCustomColorsArrayOfObjs) {
        var categoryOptionName = "";
        if(categoryCustomColorObj.categoryOptionID === -1) {
          categoryOptionName = "--Not Set--";
        }
        else {
          var categoryOptionIDString = JSFUNC.num2str(categoryCustomColorObj.categoryOptionID);
          categoryOptionName = this.props.DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(categoryOptionIDString, c_graphsEditingGraphSelectMultiCategoriesOptionsFieldTypeObj);
        }
        categoryCustomColorObj.categoryOptionName = categoryOptionName;
      }
    }

    //graph title
    const graphTitleComponent = (
      <CEGeneralReact.CaptureExecFieldEditSaveCancel
        p_ceEditItemString="divexecGraph_graph_title"
        p_fieldDisplayName="Graph Title"
        p_fieldTypeObj={this.props.DatabaseMobx.c_genericTextFieldTypeObj}
        p_valueRaw={graphObj.graph_title}
        p_valueIsEditableTFU={((userCanEditTF) ? (true) : (undefined))}
        p_containerClass="tbMicroPad"
        p_fieldClass="fontBlue"
        p_fieldWidth="6em"
        p_valueClass="fontBold font11 fontTextLight"
        f_onSaveChanged={this.onsave_graph_title}
      />
    );

    //select graph type for daily snapshots
    var selectGraphTypeButtonsComponent = null;
    if(c_tabDailySnapshotTrueTrendAnalyzerFalse) {
      const dailySnapshotIconCategoriesArrayOfObjs = [
        {valueRaw:70, color:JSFUNC.unique_color(0)},
        {valueRaw:30, color:JSFUNC.unique_color(1)},
        {valueRaw:40, color:JSFUNC.unique_color(2)},
        {valueRaw:10, color:JSFUNC.unique_color(3)}
      ];
      
      selectGraphTypeButtonsComponent = (
        <div className="displayFlexRow flexWrap">
          <EditGraphFloatingBoxGraphTypeIconShell p_graphType0123={0} p_label="Pie Graph" p_selectedTF={selectedGraphTypePieTF} p_canEditTF={(!isReplicaOfPublicGraphTF)}>
            <LibraryReact.CircleGraph
              p_categoriesArrayOfObjs={dailySnapshotIconCategoriesArrayOfObjs}
              p_heightPx={graphTypeIconHeightPx}
              p_titlesTF={false}
              p_legendTF={false}
              p_vacantLabel="--Vacant--"
              p_vacantColor="333"
              p_maxNumDecimals={1}
            />
          </EditGraphFloatingBoxGraphTypeIconShell>
          <EditGraphFloatingBoxGraphTypeIconShell p_graphType0123={1} p_label="Vertical Bar" p_selectedTF={selectedGraphTypeVerticalBarTF} p_canEditTF={(!isReplicaOfPublicGraphTF)}>
            <LibraryReact.BarGraph
              p_categoriesArrayOfObjs={dailySnapshotIconCategoriesArrayOfObjs}
              p_yAxisWidthEm={2}
              p_horizontalTF={false}
              p_mirroredTF={false}
              p_heightPx={graphTypeIconHeightPx}
              p_titlesTF={false}
              p_legendTF={false}
              p_maxNumDecimals={1}
            />
          </EditGraphFloatingBoxGraphTypeIconShell>
          <EditGraphFloatingBoxGraphTypeIconShell p_graphType0123={2} p_label="Horizontal Bar" p_selectedTF={selectedGraphTypeHorizontalBarTF} p_canEditTF={(!isReplicaOfPublicGraphTF)}>
            <LibraryReact.BarGraph
              p_categoriesArrayOfObjs={dailySnapshotIconCategoriesArrayOfObjs}
              p_horizontalTF={true}
              p_mirroredTF={false}
              p_heightPx={graphTypeIconHeightPx}
              p_titlesTF={false}
              p_legendTF={false}
              p_maxNumDecimals={1}
            />
          </EditGraphFloatingBoxGraphTypeIconShell>
          <EditGraphFloatingBoxGraphTypeIconShell p_graphType0123={3} p_label="Funnel" p_selectedTF={selectedGraphTypeFunnelTF} p_canEditTF={(!isReplicaOfPublicGraphTF)}>
            <LibraryReact.BarGraph
              p_categoriesArrayOfObjs={dailySnapshotIconCategoriesArrayOfObjs}
              p_horizontalTF={true}
              p_mirroredTF={true}
              p_heightPx={graphTypeIconHeightPx}
              p_titlesTF={false}
              p_legendTF={false}
              p_maxNumDecimals={1}
            />
          </EditGraphFloatingBoxGraphTypeIconShell>
        </div>
      );
    }
    else {
      const nowYearInt = JSFUNC.now_year_int();

      const trendAnalyzerIconCategoriesArrayOfObjs = [
        {
          idDateValueArrayOfObjs:[
            {id:1, date:(nowYearInt - 2) + "-06-06", value:150},
            {id:2, date:(nowYearInt - 1) + "-06-06", value:50},
            {id:3, date:nowYearInt + "-06-06", value:480}
          ],
          color:JSFUNC.unique_color(0),
          label:"Category One"
        },
        {
          idDateValueArrayOfObjs:[
            {id:1, date:(nowYearInt - 2) + "-06-06", value:40},
            {id:2, date:(nowYearInt - 1) + "-06-06", value:200},
            {id:3, date:nowYearInt + "-06-06", value:170}
          ],
          color:JSFUNC.unique_color(1),
          label:"Category Two"
        }
      ];

      const timeGraphStartDate = (nowYearInt - 2) + "-01-01";
      const timeGraphEndDate = nowYearInt + "-12-31";
      const timeGraphYAxisWidthEm = 3;
      const timeGraphFontSizePx = (c_userFontSizePx - 1);
      
      selectGraphTypeButtonsComponent = (
        <div className="displayFlexRow flexWrap">
          <EditGraphFloatingBoxGraphTypeIconShell p_timeGraphType0123={0} p_label="Line" p_selectedTF={(graphObj.line0_bar1 === 0)} p_canEditTF={(!isReplicaOfPublicGraphTF)}>
            <LibraryReact.TimeGraph
              p_categoriesArrayOfObjs={trendAnalyzerIconCategoriesArrayOfObjs}
              p_timeGraphType="line"
              p_startDate={timeGraphStartDate}
              p_endDate={timeGraphEndDate}
              p_timeBins="yearly"
              p_fyrStartMonth0to11={c_companyFyrMonthsAndQuartersInfoObj.companyFyrStartMonthIndex0to11}
              p_yLogScaleTF={false}
              p_valueFormat="number"
              p_heightPx={graphTypeIconHeightPx}
              p_estimatedWidthPx={graphTypeIconEstimatedWidthPx}
              p_yAxisWidthEm={timeGraphYAxisWidthEm}
              p_fontSizePx={timeGraphFontSizePx}
              p_legendTF={false}
              f_onClickSegment={undefined}
            />
          </EditGraphFloatingBoxGraphTypeIconShell>
          <EditGraphFloatingBoxGraphTypeIconShell p_timeGraphType0123={1} p_label="Line (Cumulative)" p_selectedTF={(graphObj.line0_bar1 === 1)} p_canEditTF={(!isReplicaOfPublicGraphTF)}>
            <LibraryReact.TimeGraph
              p_categoriesArrayOfObjs={trendAnalyzerIconCategoriesArrayOfObjs}
              p_timeGraphType="lineCumulative"
              p_startDate={timeGraphStartDate}
              p_endDate={timeGraphEndDate}
              p_timeBins="yearly"
              p_fyrStartMonth0to11={c_companyFyrMonthsAndQuartersInfoObj.companyFyrStartMonthIndex0to11}
              p_yLogScaleTF={false}
              p_valueFormat="number"
              p_heightPx={graphTypeIconHeightPx}
              p_estimatedWidthPx={graphTypeIconEstimatedWidthPx}
              p_yAxisWidthEm={timeGraphYAxisWidthEm}
              p_fontSizePx={timeGraphFontSizePx}
              p_legendTF={false}
              f_onClickSegment={undefined}
            />
          </EditGraphFloatingBoxGraphTypeIconShell>
          <EditGraphFloatingBoxGraphTypeIconShell p_timeGraphType0123={2} p_label="Bar" p_selectedTF={(graphObj.line0_bar1 === 2)} p_canEditTF={(!isReplicaOfPublicGraphTF)}>
            <LibraryReact.TimeGraph
              p_categoriesArrayOfObjs={trendAnalyzerIconCategoriesArrayOfObjs}
              p_timeGraphType="bar"
              p_startDate={timeGraphStartDate}
              p_endDate={timeGraphEndDate}
              p_timeBins="yearly"
              p_fyrStartMonth0to11={c_companyFyrMonthsAndQuartersInfoObj.companyFyrStartMonthIndex0to11}
              p_yLogScaleTF={false}
              p_valueFormat="number"
              p_heightPx={graphTypeIconHeightPx}
              p_estimatedWidthPx={graphTypeIconEstimatedWidthPx}
              p_yAxisWidthEm={timeGraphYAxisWidthEm}
              p_fontSizePx={timeGraphFontSizePx}
              p_legendTF={false}
              f_onClickSegment={undefined}
            />
          </EditGraphFloatingBoxGraphTypeIconShell>
          <EditGraphFloatingBoxGraphTypeIconShell p_timeGraphType0123={3} p_label="Bar (Relative %)" p_selectedTF={(graphObj.line0_bar1 === 3)} p_canEditTF={(!isReplicaOfPublicGraphTF)}>
            <LibraryReact.TimeGraph
              p_categoriesArrayOfObjs={trendAnalyzerIconCategoriesArrayOfObjs}
              p_timeGraphType="barPercentOf100"
              p_startDate={timeGraphStartDate}
              p_endDate={timeGraphEndDate}
              p_timeBins="yearly"
              p_fyrStartMonth0to11={c_companyFyrMonthsAndQuartersInfoObj.companyFyrStartMonthIndex0to11}
              p_yLogScaleTF={false}
              p_valueFormat="number"
              p_heightPx={graphTypeIconHeightPx}
              p_estimatedWidthPx={graphTypeIconEstimatedWidthPx}
              p_yAxisWidthEm={timeGraphYAxisWidthEm}
              p_fontSizePx={timeGraphFontSizePx}
              p_legendTF={false}
              f_onClickSegment={undefined}
            />
          </EditGraphFloatingBoxGraphTypeIconShell>
        </div>
      );
    }

    const captureFilterPresetComponent = (
      <div className="displayFlexRow">
        <div className="flex11a" style={{flexBasis:"100em", maxWidth:"50em"}}>
          <EditGraphFloatingBoxSectionLabel p_label="Capture Filter Applied" />
          <CEGeneralReact.CaptureExecFieldEditSaveCancel
            p_ceEditItemString="divexecGraph_filter_preset_id"
            p_fieldDisplayName="Capture Filter Preset"
            p_fieldTypeObj={this.props.DivexecMobx.c_graphsSelectFilterPresetFieldTypeObj}
            p_valueRaw={graphObj.filter_preset_id}
            p_valueIsEditableTFU={((userCanEditTF) ? (true) : (undefined))}
            p_containerClass="tbMicroPad"
            p_fieldClass="fontBlue"
            p_fieldWidth="10em"
            f_onSaveChanged={this.onsave_filter_preset}
          />
        </div>
        {(userCanEditTF) &&
          <div className="flex00a displayFlexColumnHcVc lrMedMargin">
            <CapturesReact.MasterPresetsEditorButton
              p_selectedPresetType="filter"
              p_selectedPresetID={graphObj.filter_preset_id}
            />
          </div>
        }
        <div className="flex11a" />
      </div>
    );

    var dateFieldComponent = null;
    if(!c_tabDailySnapshotTrueTrendAnalyzerFalse) { //select a date field only for trend graphs
      dateFieldComponent = (
        <>
          <EditGraphFloatingBoxHorizDividerLine />
          <EditGraphFloatingBoxSectionLabel p_label="Date Field used from each Capture" />
          <div style={{maxWidth:"50em"}}>
            <CEGeneralReact.CaptureExecFieldEditSaveCancel
              p_ceEditItemString="divexecGraph_date_field_id"
              p_fieldDisplayName="Date Field"
              p_fieldTypeObj={this.props.DatabaseMobx.c_selectCaptureDateFieldFieldTypeObj}
              p_valueRaw={graphObj.date_field_id}
              p_valueIsEditableTFU={((userCanEditTF) ? (true) : (undefined))}
              p_containerClass="tbMicroPad"
              p_fieldClass="fontBlue"
              p_fieldWidth="10em"
              f_onSaveChanged={this.onsave_date_field}
            />
          </div>
        </>
      );
    }

    const allCategorySelectsComponent = (
      <>
        <EditGraphFloatingBoxSectionLabel p_label="Selected Field for Categories" />
        {(!c_tabDailySnapshotTrueTrendAnalyzerFalse) &&
          <>
            <CEGeneralReact.TabsList
              p_tabDbNamesArray={[0, 1]}
              p_tabDisplayNamesArray={["Single Data Series", "Multiple Data Series\n(Using Category Field Below)"]}
              p_selectedTabDbName={graphObj.use_categories_field_01}
              p_tabHeight="3em"
              p_textMaxHeight="3em"
              p_tabWidth="15em"
              p_unselectedFontClass=""
              p_unselectedBgClass="bgLighterGrayGradient"
              p_selectedBgClass="bgBlueGradient fontWhite"
              p_canEditTF={userCanEditTF}
              f_onSelect={this.onclick_use_categories_tab}
            />
            <div className="smallTopMargin" />
          </>
        }
        <div className="smallTopMargin border1ddd bgLightestGray tbMicroPad lrMedPad">
          {(!isTrendGraphSingleDataSeriesTF) &&
            <>
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="divexecGraph_categories_field_id"
                p_fieldDisplayName="Capture Field used for Categories"
                p_fieldTypeObj={this.props.DivexecMobx.c_selectCategoryCaptureFieldFieldTypeObj}
                p_valueRaw={graphObj.categories_field_id}
                p_valueIsEditableTFU={((userCanEditTF) ? (true) : (undefined))}
                p_containerClass="tbMicroPad"
                p_fieldClass="fontBlue"
                p_fieldWidth="16em"
                f_onSaveChanged={this.onsave_categories_field}
              />
              <div className="tbMicroPad" style={{maxWidth:"25em", marginLeft:"2em"}}>
                <CEGeneralReact.VerticalSwitch
                  p_valueArray={[1, 0]}
                  p_displayArray={["Use All Categories", "Choose Specific Categories Below"]}
                  p_selectedValue={graphObj.all_categories_01}
                  p_rowHeightEm={1.5}
                  p_sizeMultiplier={undefined}
                  f_onSelect={((userCanEditTF) ? (this.onswitch_use_all_categories) : (undefined))}
                />
              </div>
              {(chooseSpecificCategoriesSelectedTF) &&
                <CEGeneralReact.CaptureExecFieldEditSaveCancel
                  p_ceEditItemString="divexecGraph_categories_option_ids_comma"
                  p_fieldDisplayName="Specified Categories"
                  p_fieldTypeObj={this.props.DivexecMobx.c_graphsEditingGraphSelectMultiCategoriesOptionsFieldTypeObj}
                  p_valueRaw={graphObj.categories_option_ids_comma}
                  p_valueIsEditableTFU={((userCanEditTF) ? (true) : (undefined))}
                  p_containerClass="tbMicroPad"
                  p_fieldClass="fontBlue"
                  p_fieldWidth={graphCategoriesOptionsFieldWidthEm + "em"}
                  f_onSaveChanged={this.onsave_categories_options}
                />
              }
              <EditGraphFloatingBoxSingleSwitchField
                p_fieldDisplayName="'--Not Set--' Category"
                p_valueRaw01={graphObj.categories_include_not_set_01}
                p_canEditTF={userCanEditTF}
                p_isNaTF={false}
                p_fieldWidthEm={graphCategoriesOptionsFieldWidthEm}
                p_switchOnText="[default] Include '--Not Set--' Category"
                p_switchOffText="Don't Include '--Not Set--'"
                p_switchSizeEm={graphOptionsSwitchSizeEm}
                p_hoverText="Use this switch to either include or not include '--Not Set--' as the last category, counting all Captures that have the selected Capture Field not set as any of the options"
                f_onSwitch={this.onswitch_categories_include_not_set}
              />
            </>
          }
          <EditGraphFloatingBoxSingleSwitchField
            p_fieldDisplayName="Custom Colors"
            p_valueRaw01={graphObj.categories_custom_colors_01}
            p_canEditTF={userCanEditTF}
            p_isNaTF={false}
            p_fieldWidthEm={graphCategoriesOptionsFieldWidthEm}
            p_switchOnText="Assign custom colors below"
            p_switchOffText="Standard color set"
            p_switchSizeEm={graphOptionsSwitchSizeEm}
            p_hoverText="Use this switch to assign custom colors to each of the categories (instead of the standard assigned colors)"
            f_onSwitch={this.onswitch_categories_custom_colors}
          />
          {(customColorsTF) &&
            ((isTrendGraphSingleDataSeriesTF) ? (
              <CEGeneralReact.CaptureExecFieldEditSaveCancel
                p_ceEditItemString="divexecGraph_categories_custom_colors_trend_analyzer_single_data_series_single_color"
                p_fieldDisplayName="Single Data Series Custom Color"
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericColorFieldTypeObj}
                p_valueRaw={graphObj.categories_custom_colors_colon_comma_list}
                p_valueIsEditableTFU={((userCanEditTF) ? (true) : (undefined))}
                p_containerClass="tbMicroPad"
                p_fieldClass="fontBlue"
                p_fieldWidth="15em"
                f_onSaveChanged={this.onsave_categories_custom_colors_trend_analyzer_single_data_series_single_color}
              />
            ) : (
              <div className="smallFullMargin border1ddd bgLighterGray smallFullPad">
                <div className="displayFlexRow smallBottomMargin">
                  <div className="flex00a" style={{flexBasis:"5em"}} />
                  <div className="flex11a displayFlexColumnHcVc">
                    <LibraryReact.DivFont p_class="textCenter" p_fontClass="fontBold fontTextLighter">
                      {"Custom Colors"}
                    </LibraryReact.DivFont>
                  </div>
                  <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"4em"}}>
                    <CEGeneralReact.ButtonWithConfirmBox
                      p_buttonType="hyperlink"
                      p_buttonText="reset"
                      p_buttonFontClass="font09 fontItalic fontUnderline fontDarkBlue"
                      p_tabIndex={undefined}
                      p_title={"Sets all colors below to the standard " + c_productStylingObj.productName + " color set"}
                      p_confirmType="confirm"
                      p_confirmMessage={"Are you sure you want to reset your custom color assignments to the standard " + c_productStylingObj.productName + " color set?"}
                      p_button1Name={undefined}
                      p_textMustBeFilledOutTF={undefined}
                      f_onClickConfirm={this.onclick_reset_custom_colors_to_ce_standard_unique_colors}
                    />
                  </div>
                  <div
                    className="flex00a displayFlexRowVc cursorPointer"
                    style={{flexBasis:"5em", marginTop:"0.1em"}}
                    onClick={this.onclick_expand_collapse_custom_colors_editor}>
                    <div className="flex00a" style={{flexBasis:"2.5em"}}>
                      <LibraryReact.DivFont p_fontClass="fontItalic fontTextLighter">
                        {((s_customColorsEditorIsExpandedTF) ? ("Hide") : ("Show"))}
                      </LibraryReact.DivFont>
                    </div>
                    <div className="flex00a">
                      <CEGeneralReact.ButtonExpandCollapse
                        p_isExpandedTF={s_customColorsEditorIsExpandedTF}
                        p_sizeEm={1.2}
                        p_bgClass={undefined}
                      />
                    </div>
                  </div>
                </div>
                {(s_customColorsEditorIsExpandedTF) &&
                  graphCategoriesCustomColorsArrayOfObjs.map((m_categoryCustomColorObj) =>
                    <EditGraphFloatingBoxSingleCategoryOptionCustomColorRow
                      p_categoryCustomColorObj={m_categoryCustomColorObj}
                      p_canEdit={userCanEditTF}
                    />
                  )
                }
              </div>
            ))
          }
        </div>
      </>
    );

    const allGraphOptionSelectsComponent = (
      <>
        <EditGraphFloatingBoxSectionLabel p_label="Graph Options" />
        <EditGraphFloatingBoxSingleSwitchField
          p_fieldDisplayName="Legend"
          p_valueRaw01={graphObj.legend_01}
          p_canEditTF={userCanEditTF}
          p_isNaTF={false}
          p_fieldWidthEm={graphOptionsFieldWidthEm}
          p_switchOnText="Include Legend"
          p_switchOffText="No Legend"
          p_switchSizeEm={graphOptionsSwitchSizeEm}
          p_hoverText="Choose whether to include a Legend for all of the Categories to the right of the graph"
          f_onSwitch={this.onswitch_legend}
        />
        <EditGraphFloatingBoxSingleSwitchField
          p_fieldDisplayName="Legend Categories"
          p_valueRaw01={graphObj.legend_hide_zero_categories_01}
          p_canEditTF={userCanEditTF}
          p_isNaTF={(graphObj.legend_01 !== 1)}
          p_fieldWidthEm={graphOptionsFieldWidthEm}
          p_switchOnText="Hide Categories with 0 Value"
          p_switchOffText="[default] Show all Categories"
          p_switchSizeEm={graphOptionsSwitchSizeEm}
          p_hoverText="If switched on, hide all Categories in the Legend that have 0 count or $0 to simplify viewing Categories with data"
          f_onSwitch={this.onswitch_legend_hide_zero_categories}
        />
        {(!c_tabDailySnapshotTrueTrendAnalyzerFalse) &&
          <>
            <div className="displayFlexRowVc">
              <div className="flex00a" style={{flexBasis:graphOptionsFieldWidthEm + "em"}}>
                <LibraryReact.DivFont p_fontClass="fontBlue">
                  {"Timeline Bin Size"}
                </LibraryReact.DivFont>
              </div>
              <div className="flex11a tbPad">
                <CEGeneralReact.TabsList
                  p_tabDbNamesArray={["yearly", "quarterly", "monthly", "weekly", "yearlyFYR", "quarterlyFYR"]}
                  p_tabDisplayNamesArray={["Yearly", "Quarterly", "Monthly", "Weekly", <EditGraphYearlyFyrButtonLabel />, <EditGraphQuarterlyFyrButtonLabel />]}
                  p_selectedTabDbName={graphObj.time_bins}
                  p_tabHeight="2.6em"
                  p_textMaxHeight="2.5em"
                  p_tabWidth="5.2em"
                  p_unselectedFontClass=""
                  p_unselectedBgClass="bgLighterGrayGradient"
                  p_selectedBgClass="bgBlueGradient fontWhite"
                  p_canEditTF={userCanEditTF}
                  p_tabSpacing="0.3em"
                  f_onSelect={this.onclick_time_bins_button}
                />
              </div>
            </div>
          </>
        }
        <div className="displayFlexRowVc">
          <div className="flex00a" style={{flexBasis:graphOptionsFieldWidthEm + "em"}}>
            <LibraryReact.DivFont p_fontClass="fontBlue">
              {"Count Field"}
            </LibraryReact.DivFont>
          </div>
          <div className="flex11a tbPad">
            <CEGeneralReact.TabsList
              p_tabDbNamesArray={[-2, -1]}
              p_tabDisplayNamesArray={["# Captures", "$ Field (select below)"]}
              p_selectedTabDbName={((graphObj.num_captures_m2_or_money_field_id === -2) ? (-2) : (-1))}
              p_tabHeight="1.6em"
              p_textMaxHeight="1.5em"
              p_tabWidth="11.5em"
              p_unselectedFontClass=""
              p_unselectedBgClass="bgLighterGrayGradient"
              p_selectedBgClass="bgBlueGradient fontWhite"
              p_canEditTF={userCanEditTF}
              p_tabSpacing="0.4em"
              f_onSelect={this.onclick_num_captures_or_capture_money_field_button}
            />
            {(graphObj.num_captures_m2_or_money_field_id !== -2) &&
              <div className="smallTopPad" style={{maxWidth:"24em"}}>
                {(userCanEditTF) ? (
                  <CEGeneralReact.GenericInputOrSelectFromInputType
                    p_fieldTypeObj={this.props.DatabaseMobx.c_selectCaptureRevenueCardMoneyFieldFieldTypeObj}
                    p_valueRaw={graphObj.num_captures_m2_or_money_field_id}
                    f_onChangeOrOnSelect={this.onclick_num_captures_or_capture_money_field_button}
                  />
                ) : (
                  <font className="fontItalic fontTextLight">
                    {this.props.DatabaseMobx.value_mask_from_value_raw_and_field_type_obj(graphObj.num_captures_m2_or_money_field_id, this.props.DatabaseMobx.c_selectCaptureRevenueCardMoneyFieldFieldTypeObj)}
                  </font>
                )}
              </div>
            }
          </div>
        </div>
        <EditGraphFloatingBoxSingleSwitchField
          p_fieldDisplayName="Shared Percent Calcs"
          p_valueRaw01={graphObj.ignore_shared_percent_calcs_01}
          p_canEditTF={userCanEditTF}
          p_isNaTF={false}
          p_fieldWidthEm={graphOptionsFieldWidthEm}
          p_switchOnText="Full #/$ count regardless of percent ownership"
          p_switchOffText="[default] Counts proportional to ownership"
          p_switchSizeEm={graphOptionsSwitchSizeEm}
          p_hoverText={"Choose if Shared Percent fields (" + c_fieldMapOfCaptureManagers.get("display_name") + ", " + c_fieldMapOfDivisionOwners.get("display_name") + ", etc) count Captures (and $) as fractional amounts owned, or as whole counts regardless of ownership percentage"}
          f_onSwitch={this.onswitch_ignore_shared_percent_calcs}
        />
        {(selectedGraphTypeHasYAxisTF) &&
          <div className="displayFlexRowVc">
            <div className="flex00a" style={{flexBasis:graphOptionsFieldWidthEm + "em"}}>
              <LibraryReact.DivFont p_fontClass="fontBlue">
                {"Y-axis"}
              </LibraryReact.DivFont>
            </div>
            <div className="flex11a tbPad">
              <CEGeneralReact.TabsList
                p_tabDbNamesArray={[0, 1]}
                p_tabDisplayNamesArray={[<EditGraphLinearButtonLabel />, <EditGraphLogarithmicButtonLabel />]}
                p_selectedTabDbName={graphObj.y_axis_log_01}
                p_tabHeight="2.6em"
                p_textMaxHeight="2.5em"
                p_tabWidth="8em"
                p_unselectedFontClass=""
                p_unselectedBgClass="bgLighterGrayGradient"
                p_selectedBgClass="bgBlueGradient fontWhite"
                p_canEditTF={userCanEditTF}
                f_onSelect={this.onclick_y_axis_linear_log_button}
              />
            </div>
          </div>
        }
      </>
    );

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="divexecGraphsEdit"
        p_title={editingGraphFloatingBoxTitle}
        f_onClickSave={this.onclick_close_editing_graph}>
        <div className="flex11a yScroll medFullPad">
          {(isReplicaOfPublicGraphTF) &&
            <div className="medBottomMargin displayFlexColumnHcVc">
              <div className="border1ddd border bevelBorderColorBlue borderRadius05 bgLightestBlue tbPad lrMedPad textCenter">
                <font className="fontItalic fontBlue">
                  {"This is a replica of a Public Graph created by " + this.props.DatabaseMobx.user_name_mask_plaintext_from_user_id(graphObj.created_by_user_id) + " and cannot be edited"}
                </font>
              </div>
            </div>
          }
          <div className="displayFlexRow">
            <div className="flex11a displayFlexColumnVc" style={{flexBasis:"150em"}}>
              {graphTitleComponent}
            </div>
            {(c_userCanCreatePublicItemsTF) &&
              <>
                <div className="borderR1ddd lrMargin" />
                  <div className="flex11a displayFlexColumnVc" style={{flexBasis:"100em"}}>
                    <div className="displayFlexRowVc">
                      <div className="flex00a" style={{flexBasis:"9em"}}>
                        <font className="fontBlue">
                          {"Graph is Public?"}
                        </font>
                      </div>
                      <div className="flex11a">
                        <CEGeneralReact.SwitchWithTextAndConfirmBox
                          p_isOnTF={(graphObj.public_01 === 1)}
                          p_sizeEm={3}
                          p_onText="Public to everyone"
                          p_offText="Private to me"
                          p_title="Public graphs can be added to other users' pages while not allowing them to edit it"
                          f_onSwitch={((isReplicaOfPublicGraphTF) ? (undefined) : (this.onswitch_graph_is_public))}
                        />
                      </div>
                    </div>
                  </div>
              </>
            }
          </div>
          <EditGraphFloatingBoxHorizDividerLine />
          <EditGraphFloatingBoxSectionLabel p_label={((c_tabDailySnapshotTrueTrendAnalyzerFalse) ? ("Graph Type") : ("Time Graph Type"))} />
          {selectGraphTypeButtonsComponent}
          <EditGraphFloatingBoxHorizDividerLine />
          {captureFilterPresetComponent}
          {dateFieldComponent}
          <EditGraphFloatingBoxHorizDividerLine />
          {(c_isMobileOrTabletTF) ? (
            <>
              {allCategorySelectsComponent}
              <EditGraphFloatingBoxHorizDividerLine />
              {allGraphOptionSelectsComponent}
            </>
          ) : (
            <div className="displayFlexRow">
              <div className="flex11a" style={{flexBasis:"100em"}}>
                {allCategorySelectsComponent}
              </div>
              <div className="flex00a borderR1ddd lrMedMargin" />
              <div className="flex11a" style={{flexBasis:"100em"}}>
                {allGraphOptionSelectsComponent}
              </div>
            </div>
          )}
          <EditGraphFloatingBoxHorizDividerLine />
          <div className="displayFlexColumn overflowHidden border bevelBorderColors boxShadowGreenDarkGreenHover" style={{height:graphPreviewMaxHeightEm + "em", margin:"2em 20%"}}>
            <DivexecGraph
              p_graphDataObj={c_graphsEditingGraphDataObj}
              p_startDate={selectedPageStartDateFixed}
              p_endDate={selectedPageEndDateFixed}
              p_canEditDeleteReorderTF={false}
              p_canClickSegmentsTF={false}
              p_isOnlyItemTF={true}
              p_isLastItemTF={true}
              p_graphHeightEm={graphPreviewMaxHeightEm}
              p_selectedPageID={c_graphsSelectedPageObj.id}
            />
          </div>
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));

function EditGraphQuarterlyFyrButtonLabel(props) {  return(<>{"Quarterly"}<span className="font09">{"\n(FYR)"}</span></>); }
function EditGraphYearlyFyrButtonLabel(props) {  return(<>{"Yearly"}<span className="font09">{"\n(FYR)"}</span></>); }
function EditGraphLinearButtonLabel(props) {  return(<>{"Linear"}<span className="font09">{"\n0,20,40,60,80"}</span></>); }
function EditGraphLogarithmicButtonLabel(props) { return(<>{"Logarithmic"}<span className="font09">{"\n1,10,100,1k,10k"}</span></>); }



const EditGraphFloatingBoxGraphTypeIconShell = inject("DivexecMobx")(observer(
class EditGraphFloatingBoxGraphTypeIconShell extends Component { //props: p_graphType0123, p_timeGraphType0123, p_label, p_selectedTF, p_canEditTF, children
  onclick_graph_type_icon = () => {
    const p_graphType0123 = this.props.p_graphType0123;
    const p_timeGraphType0123 = this.props.p_timeGraphType0123;

    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;

    var fieldDbName = "graph_type_p0_vb1_hb2_f3";
    var selectedValue0123 = p_graphType0123;
    if(p_timeGraphType0123 !== undefined) {
      fieldDbName = "line0_bar1";
      selectedValue0123 = p_timeGraphType0123;
    }
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, fieldDbName, selectedValue0123, "i");
  }

  render() {
    const p_graphType0123 = this.props.p_graphType0123;
    const p_timeGraphType0123 = this.props.p_timeGraphType0123;
    const p_label = this.props.p_label;
    const p_selectedTF = this.props.p_selectedTF;
    const p_canEditTF = this.props.p_canEditTF;

    const canClickTF = (p_canEditTF && !p_selectedTF);

    return(
      <div
        className={"flex00a displayFlexColumn tbMargin lrMedMargin border bevelBorderColors borderRadius10 " + ((p_selectedTF) ? ("bgLightBlueGradient") : ("bgLighterGrayGradient")) + " " + ((canClickTF) ? ("hoverLighterBlueGradient cursorPointer") : (""))}
        style={{flexBasis:"12em", height:"8.5em"}}
        onClick={((canClickTF) ? (this.onclick_graph_type_icon) : (undefined))}>
        <div className="flex00a textCenter tbMicroPad borderB1bbb">
          <font className="font12 fontBold fontTextLighter">
            {p_label}
          </font>
        </div>
        <div className={"flex11a displayFlexColumnHcVc lrMedPad " + ((p_selectedTF) ? ("") : (""))}>
          {this.props.children}
        </div>
      </div>
    );
  }
}));


function EditGraphFloatingBoxHorizDividerLine(props) { //props: 
  return(
    <div className="borderT1ddd tbMargin" />
  );
}

function EditGraphFloatingBoxSectionLabel(props) { //props: p_label
  return(
    <div className="microBottomMargin">
      <font className="font12 fontItalic fontTextLighter">
        {props.p_label}
      </font>
    </div>
  );
}


class EditGraphFloatingBoxSingleSwitchField extends Component { //props: p_fieldDisplayName, p_valueRaw01, p_canEditTF, p_isNaTF, p_fieldWidthEm, p_switchOnText, p_switchOffText, p_switchSizeEm, p_hoverText, f_onSwitch
  onswitch_graph_switch_field = () => {
    const p_valueRaw01 = this.props.p_valueRaw01;
    
    if(JSFUNC.is_function(this.props.f_onSwitch)) {
      const newValue01 = ((p_valueRaw01 === 1) ? (0) : (1));
      this.props.f_onSwitch(newValue01);
    }
  }

  render() {
    const p_fieldDisplayName = this.props.p_fieldDisplayName;
    const p_valueRaw01 = this.props.p_valueRaw01;
    const p_canEditTF = this.props.p_canEditTF;
    const p_isNaTF = JSFUNC.prop_value(this.props.p_isNaTF, false);
    const p_fieldWidthEm = this.props.p_fieldWidthEm;
    const p_switchOnText = this.props.p_switchOnText;
    const p_switchOffText = this.props.p_switchOffText;
    const p_switchSizeEm = this.props.p_switchSizeEm;
    const p_hoverText = this.props.p_hoverText;

    return(
      <div
        className="displayFlexRowVc tbMicroPad"
        title={p_hoverText}>
        <div className="flex00a" style={{flexBasis:p_fieldWidthEm + "em"}}>
          <font className="fontBlue">
            {p_fieldDisplayName}
          </font>
        </div>
        <div className="flex11a">
          <font className="font09">
            {(p_isNaTF) ? (
              <font className="fontItalic fontTextLighter">
                {"N/A"}
              </font>
            ) : (
              <CEGeneralReact.SwitchWithTextAndConfirmBox
                p_isOnTF={(p_valueRaw01 === 1)}
                p_onText={p_switchOnText}
                p_offText={p_switchOffText}
                p_sizeEm={p_switchSizeEm}
                f_onSwitch={((p_canEditTF) ? (this.onswitch_graph_switch_field) : (undefined))}
              />
            )}
          </font>
        </div>
      </div>
    );
  }
}


const EditGraphFloatingBoxSingleCategoryOptionCustomColorRow = inject("DivexecMobx", "DatabaseMobx")(observer(
class EditGraphFloatingBoxSingleCategoryOptionCustomColorRow extends Component { //props: p_categoryCustomColorObj, p_canEdit
  onsave_category_custom_color = (i_newValue) => {
    const p_categoryCustomColorObj = this.props.p_categoryCustomColorObj;

    const o_graphsEditingGraphID = this.props.DivexecMobx.o_graphsEditingGraphID;
    const c_graphsEditingGraphDataObj = this.props.DivexecMobx.c_graphsEditingGraphDataObj;

    const updatedCategoriesCustomColorsColonCommaList = JSFUNC.update_or_insert_value_into_colon_comma_list(c_graphsEditingGraphDataObj.graphObj.categories_custom_colors_colon_comma_list, p_categoryCustomColorObj.categoryOptionID, i_newValue, "string");
    this.props.DivexecMobx.a_graphs_update_graph_field(o_graphsEditingGraphID, "categories_custom_colors_colon_comma_list", updatedCategoriesCustomColorsColonCommaList, "s");
  }

  render() {
    const p_categoryCustomColorObj = this.props.p_categoryCustomColorObj;
    const p_canEdit = this.props.p_canEdit;

    const categoryOptionID = p_categoryCustomColorObj.categoryOptionID;
    const categoryOptionName = p_categoryCustomColorObj.categoryOptionName;
    const color = p_categoryCustomColorObj.color;

    return(
      <CEGeneralReact.CaptureExecFieldEditSaveCancel
        p_ceEditItemString={"divexecGraph_custom_color" + categoryOptionID}
        p_fieldDisplayName={categoryOptionName}
        p_fieldTypeObj={this.props.DatabaseMobx.c_genericColorFieldTypeObj}
        p_valueRaw={color}
        p_valueIsEditableTFU={((p_canEdit) ? (true) : (undefined))}
        p_containerClass="microBottomPad"
        p_fieldClass="fontTextLight"
        p_fieldWidth="15em"
        p_fieldNowrapTF={true}
        p_fieldHoverText={categoryOptionName}
        p_fieldDashedUnderlineTF={false}
        f_onSaveChanged={this.onsave_category_custom_color}
      />
    );
  }
}));




function DivexecGraphsPagesReplicaIcon(props) { //props: p_title
  return(
    <div
      className="displayFlexColumnHcVc border1ddd bgBlueGradient"
      style={{height:"1.3em", width:"1.3em"}}
      title={props.p_title}>
      <font className="font08 fontWhite">
        {"R"}
      </font>
    </div>
  );
}





//=============================================================================================================================================================================
//=============================================================================================================================================================================
//Hot Bits
export const HotBits = inject("DivexecMobx", "UserMobx")(observer(
class HotBits extends Component {
  componentDidMount() {
    const o_hotBitsSelectedCaptureFieldIDOrUndefned = this.props.DivexecMobx.o_hotBitsSelectedCaptureFieldIDOrUndefned;
    const c_hotBitsObj = this.props.DivexecMobx.c_hotBitsObj;

    //if a Hot BITs selected capture date field is not picked yet, pick the first one
    if(o_hotBitsSelectedCaptureFieldIDOrUndefned === undefined) {
      if(JSFUNC.is_array_not_empty(c_hotBitsObj.hotBitsCaptureFieldsArrayOfObjs)) {
        this.props.DivexecMobx.a_hot_bits_set_selected_capture_field_id(c_hotBitsObj.hotBitsCaptureFieldsArrayOfObjs[0].id);
      }
    }
  }

  onchange_hotbits_fixed_calendar = (i_newValue) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_hotbits_fixed0_calendar1", i_newValue, "i");
  }

  render() {
    const o_hotBitsSelectedCaptureFieldIDOrUndefned = this.props.DivexecMobx.o_hotBitsSelectedCaptureFieldIDOrUndefned;
    const c_hotBitsObj = this.props.DivexecMobx.c_hotBitsObj;
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;

    const dateCategoriesArrayOfObjs = c_hotBitsObj.dateCategoriesArrayOfObjs;
    const hotBitsCaptureFieldsArrayOfObjs = c_hotBitsObj.hotBitsCaptureFieldsArrayOfObjs;

    return(
      <>
        <div className="displayFlexRow borderB1bbb bgLighterGreen tbMicroPad" style={{minHeight:"3.3em"}}>
          <div className="flex11a displayFlexColumnVc lrMedPad" style={{flexBasis:"100em"}}>
            <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="font13 fontBold fontItalic fontUnderline fontDarkGreen">
              {"Hot BITs"}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_fontClass="font11 fontBold">
              {"Cards of Recent System-Wide Activity"}
            </LibraryReact.DivFont>
          </div>
          <div className="flex00a displayFlexColumnVc" style={{flexBasis:"4em"}}>
            <LibraryReact.DivFont p_fontClass="fontBold fontItalic fontTextLight">
              {"Date Options"}
            </LibraryReact.DivFont>
          </div>
          <div className="flex00a displayFlexColumnVc smallRightMargin lrPad" style={{flexBasis:"9em"}}>
            <CEGeneralReact.VerticalSwitch
              p_valueArray={[0, 1]}
              p_displayArray={["Fixed", "Calendar"]}
              p_selectedValue={c_combinedUserObj.divexec_hotbits_fixed0_calendar1}
              p_rowHeightEm={1.3}
              p_sizeMultiplier={0.8}
              f_onSelect={this.onchange_hotbits_fixed_calendar}
            />
          </div>
          <div className="flex11a displayFlexColumnVc lrMedPad" style={{flexBasis:"200em"}}>
            <DivexecSelectFilterDivisions />
          </div>
        </div>
        <div className="flex00a displayFlexRow borderB1bbb bgLighterGreen">
          {hotBitsCaptureFieldsArrayOfObjs.map((m_hotBitsCaptureFieldObj) =>
            <HotBitsSingleCaptureFieldCard
              key={m_hotBitsCaptureFieldObj.id}
              p_dateCategoriesArrayOfObjs={dateCategoriesArrayOfObjs}
              p_hotBitsCaptureFieldObj={m_hotBitsCaptureFieldObj}
              p_captureFieldIsSelectedTF={(m_hotBitsCaptureFieldObj.id === o_hotBitsSelectedCaptureFieldIDOrUndefned)}
            />
          )}
        </div>
        <div className="flex11a xyScroll yScrollBottomPad bgLighterGray">
          {hotBitsCaptureFieldsArrayOfObjs.map((m_hotBitsCaptureFieldObj) =>
            (o_hotBitsSelectedCaptureFieldIDOrUndefned === m_hotBitsCaptureFieldObj.id) &&
            <HotBitsSelectedFieldListOfCaptures
              key={m_hotBitsCaptureFieldObj.id}
              p_dateCategoriesArrayOfObjs={dateCategoriesArrayOfObjs}
              p_hotBitsCaptureFieldObj={m_hotBitsCaptureFieldObj}
            />
          )}
        </div>
      </>
    );
  }
}));

const HotBitsSingleCaptureFieldCard = inject("DivexecMobx")(observer(
class HotBitsSingleCaptureFieldCard extends Component { //props: p_dateCategoriesArrayOfObjs, p_hotBitsCaptureFieldObj, p_captureFieldIsSelectedTF
  onclick_hot_bits_capture_field_card = () => {
    this.props.DivexecMobx.a_hot_bits_set_selected_capture_field_id(this.props.p_hotBitsCaptureFieldObj.id);
  }

  render() {
    const p_dateCategoriesArrayOfObjs = this.props.p_dateCategoriesArrayOfObjs;
    const p_hotBitsCaptureFieldObj = this.props.p_hotBitsCaptureFieldObj;
    const p_captureFieldIsSelectedTF = this.props.p_captureFieldIsSelectedTF;

    return(
      <div
        className={"flex11a medFullMargin border bevelBorderColors " + ((p_captureFieldIsSelectedTF) ? ("bgDarkGreenGradient") : ("bgLightGray hoverLightGreenGradient cursorPointer"))}
        style={{flexBasis:"100em"}}
        onClick={((p_captureFieldIsSelectedTF) ? (undefined) : (this.onclick_hot_bits_capture_field_card))}>
        <div className="smallFullPad textCenter">
          <LibraryReact.NowrapEllipsis p_fontClass={"font11 fontBold " + ((p_captureFieldIsSelectedTF) ? ("fontWhite") : ("fontTextLight"))}>
            {p_hotBitsCaptureFieldObj.label}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="lrMargin borderT1ddd" />
        <div className="tbPad lrMedPad">
          {p_dateCategoriesArrayOfObjs.map((m_dateCategoryObj, m_index) =>
            <HotBitsFieldCardCaptureCountTextLine
              key={m_dateCategoryObj.name}
              p_fieldIsSelectedTF={p_captureFieldIsSelectedTF}
              p_numCaptures={p_hotBitsCaptureFieldObj.capturesPerDateArrayOfObjs[m_index].numCaptures}
              p_todayWeekMonthYearLabel={m_dateCategoryObj.name}
            />
          )}
        </div>
      </div>
    );
  }
}));

function HotBitsFieldCardCaptureCountTextLine(props) { //props: p_fieldIsSelectedTF, p_numCaptures, p_todayWeekMonthYearLabel
  const p_fieldIsSelectedTF = props.p_fieldIsSelectedTF;
  const p_numCaptures = props.p_numCaptures;
  const p_todayWeekMonthYearLabel = props.p_todayWeekMonthYearLabel;

  var fontClass = ((p_fieldIsSelectedTF) ? ("fontAlmostWhite") : (""));
  if(p_numCaptures === 0) {
    fontClass = ((p_fieldIsSelectedTF) ? ("fontLightRed") : ("fontDarkerRed"));
  }

  return(
    <div className="">
      <LibraryReact.NowrapEllipsis p_fontClass={fontClass}>
        {p_numCaptures + " " + JSFUNC.plural(p_numCaptures, "capture", "captures") + " " + p_todayWeekMonthYearLabel}
      </LibraryReact.NowrapEllipsis>
    </div>
  );
}

const HotBitsSelectedFieldListOfCaptures = inject("OpenCaptureMobx")(observer(
class HotBitsSelectedFieldListOfCaptures extends Component { //props: p_hotBitsCaptureFieldObj
  onclick_capture_open_capture = (i_captureID) => {
    this.props.OpenCaptureMobx.a_open_single_capture(i_captureID);
  }

  render() {
    const p_dateCategoriesArrayOfObjs = this.props.p_dateCategoriesArrayOfObjs;
    const p_hotBitsCaptureFieldObj = this.props.p_hotBitsCaptureFieldObj;

    return(
      p_dateCategoriesArrayOfObjs.map((m_dateCategoryObj, m_index) =>
        <>
          {(m_index > 0) &&
            <div className="hugeTopMargin" />
          }
          <HotBitsListOfCapturesSectionHeader
            p_numCaptures={p_hotBitsCaptureFieldObj.capturesPerDateArrayOfObjs[m_index].numCaptures}
            p_label={p_hotBitsCaptureFieldObj.actionLabel + " " + m_dateCategoryObj.actionName}
            p_subLabel={"Captures with '" + p_hotBitsCaptureFieldObj.displayName + "'" + m_dateCategoryObj.capturesSectionHeaderSubLabelBetweenDates}
          />
          {(p_hotBitsCaptureFieldObj.capturesPerDateArrayOfObjs[m_index].atLeast1CaptureTF) &&
            <CapturesReact.SearchFieldsCaptureSummaryTable
              p_filteredCstMaskedCaptureValuesArrayOfObjs={p_hotBitsCaptureFieldObj.capturesPerDateArrayOfObjs[m_index].hotBitsSearchFieldsCstTableObj.searchFieldsFilteredCstMaskedCaptureValuesArrayOfObjs}
              p_cstSumRowColumnsArrayOfObjsOrUndefined={p_hotBitsCaptureFieldObj.capturesPerDateArrayOfObjs[m_index].hotBitsSearchFieldsCstTableObj.searchFieldsCstSumRowColumnsArrayOfObjsOrUndefined}
              p_expandedCstColumnsArrayOfObjs={p_hotBitsCaptureFieldObj.capturesPerDateArrayOfObjs[m_index].hotBitsSearchFieldsCstTableObj.searchFieldsExpandedCstColumnsArrayOfObjs}
              p_initialSortFieldID={p_hotBitsCaptureFieldObj.capturesPerDateArrayOfObjs[m_index].hotBitsSearchFieldsCstTableObj.sortFieldIDOrUndefined}
              p_initialSortIsAscTF={p_hotBitsCaptureFieldObj.capturesPerDateArrayOfObjs[m_index].hotBitsSearchFieldsCstTableObj.sortIsAscTFOrUndefined}
              p_maxNumCapturesShown={25}
              f_onClickCapture={this.onclick_capture_open_capture}
            />
          }
        </>
      )
    );
  }
}));

function HotBitsListOfCapturesSectionHeader(props) { //props: p_numCaptures, p_label, p_subLabel
  const p_numCaptures = props.p_numCaptures;
  const p_label = props.p_label;
  const p_subLabel = props.p_subLabel;

  return(
    <div className="displayFlexRowVc lrMedPad bgLighterBlueGradient" style={{height:"3.3em", borderTop:"solid 1px #aaa", borderBottom:"solid 1px #aaa"}}>
      <div className="flex00a textCenter" style={{flexBasis:"4em"}}>
        <LibraryReact.DivFont p_styleObj={{flexBasis:"4em"}} p_fontClass={"font14 fontBold fontItalic " + ((p_numCaptures === 0) ? ("fontTextLight") : ("fontDarkBlue"))}>
          {p_numCaptures}
        </LibraryReact.DivFont>
      </div>
      <div className="flex00a" style={{flexBasis:"23em"}}>
        <LibraryReact.DivFont p_fontClass="font11 fontBold fontItalic fontTextLight">
          {p_label}
        </LibraryReact.DivFont>
      </div>
      <div className="flex11a">
        <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLight">
          {p_subLabel}
        </LibraryReact.NowrapEllipsis>
      </div>
    </div>
  );
}






//=============================================================================================================================================================================
//=============================================================================================================================================================================
//Critical Thresholds
export const CriticalThresholds = inject("CapturesMobx", "DivexecMobx", "DatabaseMobx", "UserMobx")(observer(
class CriticalThresholds extends Component {
  componentDidMount() {
    if(this.props.DivexecMobx.o_criticalThresholdsSelectedFilterCaptureTypeIDOrUndefned === undefined) {
      this.props.DivexecMobx.a_critical_thresholds_set_selected_filter_capture_type_id(this.props.DatabaseMobx.c_firstCaptureTypeIDOrUndefined);
    }
  }

  onclick_critical_thresholds_filter_capture_type_button = (i_selectedCaptureTypeID) => {
    this.props.DivexecMobx.a_critical_thresholds_set_selected_filter_capture_type_id(i_selectedCaptureTypeID);
  }

  onclick_critical_thresholds_graph_button = (i_selectedGraphString) => {
    this.props.DivexecMobx.a_critical_thresholds_set_selected_graph_string(i_selectedGraphString);
  }

  onclick_critical_thresholds_scatter_dot = (i_clickedCaptureID) => {
    const captureIDsArray = [i_clickedCaptureID];
    const floatingBoxTitle = "Critical Thresholds - Selected Capture '" + this.props.DatabaseMobx.capture_name_plaintext_from_capture_id(i_clickedCaptureID) + "'";
    this.props.CapturesMobx.a_set_view_specified_captures_in_floating_box_search_fields_capture_summary_table_capture_ids_array_and_floating_box_title(captureIDsArray, floatingBoxTitle);
  }

  render() {
    const criticalThresholdsSelectedFilterCaptureTypeID = this.props.DivexecMobx.o_criticalThresholdsSelectedFilterCaptureTypeIDOrUndefned;
    const criticalThresholdsSelectedGraphString = this.props.DivexecMobx.o_criticalThresholdsSelectedGraphString;
    const c_captureTypeIDsArray = this.props.DatabaseMobx.c_captureTypeIDsArray;
    const c_captureTypeNamesArray = this.props.DatabaseMobx.c_captureTypeNamesArray;
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;

    const userCritThreshMoneyFieldID = c_combinedUserObj.divexec_critthresh_money_field_id;

    const cpgtDbName = "criticalProgressThreshold";
    const cpgtDisplayName = "Critical Progress % Threshold for Wins/Losses";
    const cpgtDisplayNameShort = "$ vs % Progress";
    const cpwtDbName = "criticalPwinThreshold";
    const cpwtDisplayName = "Critical PWin % Threshold for Wins/Losses";
    const cpwtDisplayNameShort = "$ vs % PWin";
    const pwvpgDbName = "pwinVsProgress";
    const pwvpgDisplayName = "PWin vs Progress for Wins/Losses";
    const pwvpgDisplayNameShort = "PWin vs Progress";

    const tabDbNamesArray = [cpgtDbName, cpwtDbName, pwvpgDbName];
    const tabDisplayNamesArray = [cpgtDisplayName, cpwtDisplayName, pwvpgDisplayName];
    const tabDisplayNamesShortArray = [cpgtDisplayNameShort, cpwtDisplayNameShort, pwvpgDisplayNameShort];

    var moneyFieldDisplayName = "--No Capture Money Field Selected--";
    if(userCritThreshMoneyFieldID > 0) {
      const critthreshMoneyExpandedFieldMap = this.props.DatabaseMobx.fetch_expanded_capture_field_map_from_field_id(userCritThreshMoneyFieldID);
      moneyFieldDisplayName = critthreshMoneyExpandedFieldMap.get("display_name");
    }

    var graphComponent = null;
    if(criticalThresholdsSelectedGraphString === cpgtDbName) {
      graphComponent = (
        <LibraryReact.ScatterPlot
          p_dataObjOrDataArrayOfObjs={this.props.DivexecMobx.c_criticalProgressThresholdScatterPlotDataArrayOfObjs}
          p_xMin={0}
          p_xMax={100}
          p_xValueFormat="percent"
          p_xLabel={this.props.DatabaseMobx.c_fieldMapOfShapingTotalProgress.get("display_name")}
          p_yMin={0}
          p_yMax={undefined}
          p_yValueFormat="moneyShort"
          p_yLabel={moneyFieldDisplayName}
          p_yLogScaleTF={true}
          p_zSizePercentOfHeight={2}
          p_zMin={undefined}
          p_zMax={undefined}
          p_dataAverageVerticalLinesTF={true}
          p_title={cpgtDisplayName}
          p_heightPx={700}
          p_fontSizePx={12}
          f_onClickDot={this.onclick_critical_thresholds_scatter_dot}
        />
      );
    }
    else if(criticalThresholdsSelectedGraphString === cpwtDbName) {
      graphComponent = (
        <LibraryReact.ScatterPlot
          p_dataObjOrDataArrayOfObjs={this.props.DivexecMobx.c_criticalPwinThresholdScatterPlotDataArrayOfObjs}
          p_xMin={0}
          p_xMax={100}
          p_xValueFormat="percent"
          p_xLabel={this.props.DatabaseMobx.c_fieldMapOfPwin.get("display_name")}
          p_yMin={0}
          p_yMax={undefined}
          p_yValueFormat="moneyShort"
          p_yLabel={moneyFieldDisplayName}
          p_yLogScaleTF={true}
          p_zSizePercentOfHeight={2}
          p_zMin={undefined}
          p_zMax={undefined}
          p_dataAverageVerticalLinesTF={true}
          p_title={cpwtDisplayName}
          p_heightPx={700}
          p_fontSizePx={12}
          f_onClickDot={this.onclick_critical_thresholds_scatter_dot}
        />
      );
    }
    else if(criticalThresholdsSelectedGraphString === pwvpgDbName) {
      graphComponent = (
        <LibraryReact.ScatterPlot
          p_dataObjOrDataArrayOfObjs={this.props.DivexecMobx.c_pwinVsProgressScatterPlotDataArrayOfObjs}
          p_xMin={0}
          p_xMax={100}
          p_xValueFormat="percent"
          p_xLabel={this.props.DatabaseMobx.c_fieldMapOfShapingTotalProgress.get("display_name")}
          p_yMin={0}
          p_yMax={100}
          p_yValueFormat="percent"
          p_yLabel={this.props.DatabaseMobx.c_fieldMapOfPwin.get("display_name")}
          p_yLogScaleTF={false}
          p_zSizePercentOfHeight={2}
          p_zMin={undefined}
          p_zMax={undefined}
          p_dataAverageVerticalLinesTF={true}
          p_title={pwvpgDisplayName}
          p_heightPx={700}
          p_fontSizePx={12}
          f_onClickDot={this.onclick_critical_thresholds_scatter_dot}
        />
      );
    }

    return(
      <>
        <div className="flex00a displayFlexRow borderB1ddd" style={{flexBasis:"6em"}}>
          <div className="flex00a displayFlexRowVc lrMedPad">
            <LibraryReact.DivFont p_fontClass="font11 fontBold fontItalic fontTextLighter">
              {this.props.DatabaseMobx.c_fieldMapOfCaptureType.get("display_name")}
            </LibraryReact.DivFont>
          </div>
          <div className="flex11a displayFlexColumnVc">
            <CEGeneralReact.TabsList
              p_tabDbNamesArray={c_captureTypeIDsArray}
              p_tabDisplayNamesArray={c_captureTypeNamesArray}
              p_selectedTabDbName={criticalThresholdsSelectedFilterCaptureTypeID}
              p_tabHeight="2.7em"
              p_textMaxHeight="2.4em"
              p_tabWidth="10em"
              p_unselectedFontClass="fontBold"
              p_unselectedBgClass="bgLighterGrayGradient hoverLighterBlueGradient fontTextLight"
              p_selectedBgClass="bgOrangeGradient"
              f_onSelect={this.onclick_critical_thresholds_filter_capture_type_button}
            />
          </div>
          <div className="flex00a displayFlexColumnVc lrPad borderL1ddd">
            <DivexecEditUserMoneyField p_userFieldDbName="divexec_critthresh_money_field_id" />
          </div>
        </div>
        <div className="flex00a displayFlexRow" style={{flexBasis:"6em"}}>
          <div className="flex11a displayFlexRowVc borderR1ddd" style={{flexBasis:"100em"}}>
            <div className="flex00a lrMedPad">
              <LibraryReact.DivFont p_fontClass="font11 fontBold fontItalic fontTextLighter">
                {"Graph"}
              </LibraryReact.DivFont>
            </div>
            <div className="flex11a">
              <CEGeneralReact.TabsList
                p_tabDbNamesArray={tabDbNamesArray}
                p_tabDisplayNamesArray={tabDisplayNamesShortArray}
                p_selectedTabDbName={criticalThresholdsSelectedGraphString}
                p_tabHeight="2.7em"
                p_textMaxHeight="2.4em"
                p_tabWidth="6.5em"
                p_unselectedFontClass="fontBold"
                p_unselectedBgClass="bgLighterGrayGradient hoverLighterBlueGradient fontTextLight"
                p_selectedBgClass="bgGoldGradient"
                f_onSelect={this.onclick_critical_thresholds_graph_button}
              />
            </div>
          </div>
          <div className="flex11a displayFlexColumnVc lrMedPad" style={{flexBasis:"100em"}}>
            <DivexecSelectFilterDivisions />
          </div>
        </div>
        <div className="flex11a yScroll yScrollBottomPad medFullPad borderT1ddd">
          {graphComponent}
        </div>
      </>
    );
  }
}));






//=============================================================================================================================================================================
//=============================================================================================================================================================================
//Stage Flow
export const StageFlow = inject("DivexecMobx", "DatabaseMobx")(observer(
class StageFlow extends Component {
  componentDidMount() {
    this.props.DivexecMobx.a_stage_flow_load_thin_log_stages();

    if(this.props.DivexecMobx.o_stageFlowSelectedFilterCaptureTypeIDOrUndefined === undefined) {
      this.props.DivexecMobx.a_stage_flow_set_selected_filter_capture_type_id(this.props.DatabaseMobx.c_firstCaptureTypeIDOrUndefined);
    }
  }

  onclick_filter_capture_type_button = (i_selectedCaptureTypeID) => {
    this.props.DivexecMobx.a_stage_flow_set_selected_filter_capture_type_id(i_selectedCaptureTypeID);
  }

  onclick_filter_stage_type_button = (i_selectedStageTypeString) => {
    this.props.DivexecMobx.a_stage_flow_set_selected_filter_stage_type_string(i_selectedStageTypeString);
  }

  render() {
    const o_stageFlowSelectedFilterCaptureTypeIDOrUndefined = this.props.DivexecMobx.o_stageFlowSelectedFilterCaptureTypeIDOrUndefined;
    const o_stageFlowSelectedFilterStageTypeString = this.props.DivexecMobx.o_stageFlowSelectedFilterStageTypeString;
    const c_stageFlowDataPerStageArrayOfObjs = this.props.DivexecMobx.c_stageFlowDataPerStageArrayOfObjs;
    const c_captureTypeIDsArray = this.props.DatabaseMobx.c_captureTypeIDsArray;
    const c_captureTypeNamesArray = this.props.DatabaseMobx.c_captureTypeNamesArray;
    const c_fieldMapOfCaptureType = this.props.DatabaseMobx.c_fieldMapOfCaptureType;

    return(
      <>
        <div className="flex00a displayFlexRow borderB1ddd" style={{flexBasis:"11em"}}>
          <div className="flex11a displayFlexColumn borderR1bbb" style={{flexBasis:"700em"}}>
            <div className="flex11a displayFlexRowVc borderB1ddd" style={{flexBasis:"100em"}}>
              <div className="flex00a lrMedPad">
                <LibraryReact.DivFont p_fontClass="font11 fontBold fontItalic fontTextLighter">
                  {c_fieldMapOfCaptureType.get("display_name")}
                </LibraryReact.DivFont>
              </div>
              <div className="flex11a">
                <CEGeneralReact.TabsList
                  p_tabDbNamesArray={c_captureTypeIDsArray}
                  p_tabDisplayNamesArray={c_captureTypeNamesArray}
                  p_selectedTabDbName={o_stageFlowSelectedFilterCaptureTypeIDOrUndefined}
                  p_tabHeight="2.7em"
                  p_textMaxHeight="2.4em"
                  p_tabWidth="10em"
                  p_unselectedFontClass="fontBold"
                  p_unselectedBgClass="bgLighterGrayGradient hoverLighterBlueGradient fontTextLight"
                  p_selectedBgClass="bgOrangeGradient"
                  f_onSelect={this.onclick_filter_capture_type_button}
                />
              </div>
            </div>
            <div className="flex11a displayFlexRow" style={{flexBasis:"100em"}}>
              <div className="flex11a displayFlexRowVc borderR1ddd" style={{flexBasis:"100em"}}>
                <div className="flex00a lrMedPad">
                  <LibraryReact.DivFont p_fontClass="font11 fontBold fontItalic fontTextLighter">
                    {this.props.DatabaseMobx.c_fieldMapOfStage.get("display_name")}
                  </LibraryReact.DivFont>
                </div>
                <div className="flex11a">
                  <CEGeneralReact.TabsList
                    p_tabDbNamesArray={["closed", "active", "all"]}
                    p_tabDisplayNamesArray={["Closed", "Active", "All"]}
                    p_selectedTabDbName={o_stageFlowSelectedFilterStageTypeString}
                    p_tabHeight="1.8em"
                    p_textMaxHeight="1.8em"
                    p_tabWidth="6em"
                    p_unselectedFontClass="fontBold"
                    p_unselectedBgClass="bgLighterGrayGradient hoverLighterBlueGradient fontTextLight"
                    p_selectedBgClass="bgLightGreenGradient"
                    p_tabSpacing="0.4em"
                    f_onSelect={this.onclick_filter_stage_type_button}
                  />
                </div>
              </div>
              <div className="flex11a displayFlexColumnVc lrMedPad" style={{flexBasis:"100em"}}>
                <DivexecSelectFilterDivisions />
              </div>
            </div>
          </div>
          <div className="flex11a yScroll lrPad microTopPad medBottomPad" style={{flexBasis:"100em"}}>
            {(JSFUNC.is_array(c_stageFlowDataPerStageArrayOfObjs)) &&
              <>
                <div className="microBottomPad">
                  <LibraryReact.NowrapEllipsis p_fontClass="font11 fontItalic fontTextLighter">
                    {"All Closed Stages:"}
                  </LibraryReact.NowrapEllipsis>
                </div>
                {c_stageFlowDataPerStageArrayOfObjs.map((m_stageFlowStageObj) =>
                  (m_stageFlowStageObj.stageObj.id === -99) &&
                  (m_stageFlowStageObj.countsForClosedStagesArrayOfObjs.map((m_stageFlowClosedStageObj) =>
                    <div
                      className="displayFlexRow microBottomPad"
                      title={m_stageFlowClosedStageObj.stageObj.name}>
                      <div className="flex00a lrMargin border1bbb" style={{flexBasis:"2em", background:"#" + m_stageFlowClosedStageObj.stageObj.color}} />
                      <div className="flex11a displayFlexRowVc">
                        <LibraryReact.NowrapEllipsis p_fontClass="">
                          {m_stageFlowClosedStageObj.stageObj.name}
                        </LibraryReact.NowrapEllipsis>
                      </div>
                    </div>
                  ))
                )}
              </>
            }
          </div>
        </div>
        <div className="flex11a displayFlexColumn medFullMargin border1bbb">
          <StageFlowGraph />
        </div>
      </>
    );
  }
}));

const StageFlowGraph = inject("DivexecMobx", "DatabaseMobx")(observer(
class StageFlowGraph extends Component {
  render() {
    const c_stageFlowDataPerStageArrayOfObjs = this.props.DivexecMobx.c_stageFlowDataPerStageArrayOfObjs;

    //c_stageFlowDataPerStageArrayOfObjs error messages and loading data message
    if(!JSFUNC.is_array(c_stageFlowDataPerStageArrayOfObjs)) {
      return(
        <CEGeneralReact.EmptyScreenGray>
          {(c_stageFlowDataPerStageArrayOfObjs === undefined) ? (
            <>
              <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="font11">
                {"Loading Stage Flow Historical Data"}
              </LibraryReact.DivFont>
              <CEGeneralReact.LoadingAnimation />
            </>
          ) : (
            <LibraryReact.DivFont p_fontClass="font11">
              {c_stageFlowDataPerStageArrayOfObjs}
            </LibraryReact.DivFont>
          )}
        </CEGeneralReact.EmptyScreenGray>
      );
    }

    return(
      <div className="flex11a displayFlexRow borderT1bbb">
        {c_stageFlowDataPerStageArrayOfObjs.map((m_stageFlowStageObj) =>
          <StageFlowGraphSingleStage
            key={m_stageFlowStageObj.stageObj.id}
            p_stageFlowStageObj={m_stageFlowStageObj}
          />
        )}
      </div>
    );
  }
}));

function StageFlowGraphSingleStage(props) { //props: p_stageFlowStageObj
  const stageFlowStageObj = props.p_stageFlowStageObj;

  const stageObj = stageFlowStageObj.stageObj;

  return(
    <div className="flex11a displayFlexColumn" style={{flexBasis:"100em", borderRight:"solid 1px #aaa"}}>
      <div className="flex00a borderB1bbb" style={{flexBasis:"1em", background:"#" + stageFlowStageObj.stageObj.color}} />
      <div className="flex00a displayFlexRowHcVc borderB1bbb textCenter" style={{flexBasis:"4em"}}>
        <LibraryReact.MaxHeightWrap p_maxHeight="3.8em" p_fontClass={"font12 fontBold fontTextLighter " + ((stageObj.id === -99) ? ("fontItalic") : (""))}>
          {((stageObj.id === -99) ? ("All Closed Stages") : (stageObj.name))}
        </LibraryReact.MaxHeightWrap>
      </div>
      <div className="flex11a displayFlexColumn">
        {(stageFlowStageObj.graphTransitedPerc > 0) &&
          <StageFlowGraphSingleSvgRect
            p_widthPercent={100}
            p_heightPercent={stageFlowStageObj.graphTransitedPerc}
            p_color={stageFlowStageObj.graphTransitedColor}
            p_title={stageFlowStageObj.graphTransitedTitle}
            p_numCaptures={undefined}
            p_captureIDsArray={undefined}
            p_borderTF={true}
          />
        }
        {stageFlowStageObj.countsForClosedStagesArrayOfObjs.map((m_stageFlowClosedStageObj) =>
          (m_stageFlowClosedStageObj.graphClosedPerc > 0) &&
          <StageFlowGraphSingleSvgRect
            p_widthPercent={((stageFlowStageObj.stageObj.id === -99) ? (100) : (50))}
            p_heightPercent={m_stageFlowClosedStageObj.graphClosedPerc}
            p_color={m_stageFlowClosedStageObj.graphClosedColor}
            p_title={m_stageFlowClosedStageObj.graphClosedTitle}
            p_numCaptures={m_stageFlowClosedStageObj.transitedFromPrevStageCounts}
            p_captureIDsArray={m_stageFlowClosedStageObj.transitedFromPrevStageCaptureIDsArray}
            p_borderTF={true}
          />
        )}
        {(stageFlowStageObj.graphActivePerc > 0) &&
          <StageFlowGraphSingleSvgRect
            p_widthPercent={10}
            p_heightPercent={stageFlowStageObj.graphActivePerc}
            p_color={stageFlowStageObj.graphActiveColor}
            p_title={stageFlowStageObj.graphActiveTitle}
            p_numCaptures={stageFlowStageObj.currentlyActiveInPrevStageCounts}
            p_captureIDsArray={stageFlowStageObj.currentlyActiveInPrevStageCaptureIDsArray}
            p_borderTF={true}
          />
        }
        {(stageFlowStageObj.remainingSpacePerc > 0) &&
          <StageFlowGraphSingleSvgRect
            p_widthPercent={100}
            p_heightPercent={stageFlowStageObj.remainingSpacePerc}
            p_color="fff"
            p_borderTF={false}
          />
        }
      </div>
    </div>
  );
}


const StageFlowGraphSingleSvgRect = inject("CapturesMobx", "DivexecMobx")(observer(
class StageFlowGraphSingleSvgRect extends Component { //props: p_yPercent, p_widthPercent, p_heightPercent, p_color, p_title, p_numCaptures, p_captureIDsArray, p_borderTF
  onclick_stage_flow_rect = () => {
    const captureIDsArray = this.props.p_captureIDsArray;
    const floatingBoxTitle = this.props.p_title;
    this.props.CapturesMobx.a_set_view_specified_captures_in_floating_box_search_fields_capture_summary_table_capture_ids_array_and_floating_box_title(captureIDsArray, floatingBoxTitle);
  }

  render() {
    const widthPercent = this.props.p_widthPercent;
    const heightPercent = this.props.p_heightPercent;
    const color = this.props.p_color;
    const title = this.props.p_title;
    const numCaptures = this.props.p_numCaptures;
    const captureIDsArray = this.props.p_captureIDsArray;
    const borderTF = this.props.p_borderTF;

    const rectFlexBasisEm = (10 * heightPercent);
    const hasOnClickTF = JSFUNC.is_array(captureIDsArray);

    const rectZIndex = undefined; //((borderTF) ? ("2") : ("1"))
    const numCapturesBoxZIndex = 0;

    const singleRectComponent = (
      <div
        className="flex11a displayFlexColumn"
        style={{zIndex:rectZIndex, flexBasis:rectFlexBasisEm + "em", background:"#" + color, cursor:((hasOnClickTF) ? ("pointer") : (undefined))}}
        title={title}
        onClick={((hasOnClickTF) ? (this.onclick_stage_flow_rect) : (undefined))}>
        <div className={"flex11a displayFlexColumnHcVc " + ((borderTF) ? ("border1bbb") : (""))}>
          {(numCaptures !== undefined) &&
            <div className="displayFlexColumnHcVc bgLighterGrayGradient" style={{position:"relative", zIndex:numCapturesBoxZIndex, height:"1.5em", width:"2.5em", border:"solid 1px #999"}}>
              <LibraryReact.DivFont p_class="textCenter">
                {numCaptures}
              </LibraryReact.DivFont>
            </div>
          }
        </div>
      </div>
    );

    if(widthPercent === 100) {
      return(singleRectComponent);
    }

    var internalFlexBasisEm = 100; //50%
    if(widthPercent === 10) {
      internalFlexBasisEm = 15;
    }

    return(
      <div className="flex11a displayFlexRow">
        <div className="flex11a displayFlexColumn" style={{flexBasis:internalFlexBasisEm + "em"}}>
          {singleRectComponent}
        </div>
        <div className="flex11a" style={{flexBasis:"100em"}} />
      </div>
    );
  }
}));





//=============================================================================================================================================================================
//=============================================================================================================================================================================


export const ExcelReportWriter = inject("DivexecMobx")(observer(
class ExcelReportWriter extends Component { //props:
  render() {
    const excelReportTemplatesWithinFoldersObj = this.props.DivexecMobx.c_excelReportTemplatesWithinFoldersObj;
    const numTemplates = excelReportTemplatesWithinFoldersObj.numTemplates;
    const foldersArrayOfObjs = excelReportTemplatesWithinFoldersObj.foldersArrayOfObjs;
    return(
      <div className="flex11a displayFlexColumn">
        <LibraryReact.DivFont p_class="flex00a smallFullMargin textCenter" p_fontClass="font11 fontBold fontTextLight">
          {"Click the 'Generate' button next to an Excel Report Template below to download a copy populated with the latest data across all captures in the system"}
        </LibraryReact.DivFont>
        {(numTemplates === 0) ? (
          <CEGeneralReact.EmptyScreenGray>
            {"Your CaptureExec Admin has not created any Excel Report Templates yet"}
          </CEGeneralReact.EmptyScreenGray>
        ) : (
          <div className="flex11a yScroll yScrollBottomPad">
            {foldersArrayOfObjs.map((m_folderObj, m_folderIndex) =>
              (m_folderObj.numFiles > 0) &&
              <div key={m_folderObj.id} className="" style={{marginBottom:"4em"}}>
                <LibraryReact.DivFont p_class="medFullPad" p_styleObj={{background:"#f6f0ff", borderTop:"solid 1px #ccc", borderBottom:"solid 1px #758"}} p_fontClass="font12 fontBold fontItalic fontTextLighter">
                  {m_folderObj.folderPathString}
                </LibraryReact.DivFont>
                {m_folderObj.filesArrayOfObjs.map((m_templateObj, m_fileIndex) =>
                  <ExcelReportTemplateItem key={m_templateObj.id} p_templateObj={m_templateObj} p_tabIndex={(m_fileIndex + 2)} />
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}));

class ExcelReportTemplateItem extends Component { //props: p_templateObj, p_tabIndex
  render() {
    const templateObj = this.props.p_templateObj;
    const tabIndex = this.props.p_tabIndex;
    return(
      <div className="displayFlexRow tbPad hoverLighterBlueGradient" style={{height:"4.5em", borderBottom:"solid 1px #ccc"}}>
        <div className="flex00a displayFlexRowVc lrMedPad borderR1ddd">
          <CEComplexReact.GenerateAndDownloadExcelReportButtonProcess
            p_excelReportTemplateID={templateObj.id}
            p_buttonText="Generate/Download Template"
            p_buttonTitle={"Generates an excel .xml file across all captures in the system using filters specified in the template file (" + templateObj.display_name + ").  The resulting file will be offered for download automatically."}
            p_tabIndex={tabIndex}
            p_canClickButtonTF={true}
          />
        </div>
        <div className="flex11a displayFlexRowVc lrMedPad borderR1ddd" style={{flexBasis:"100em"}}>
          <LibraryReact.MaxHeightWrap p_maxHeight="4em" p_fontClass="font13 fontBold fontBlueLighter">
            {templateObj.display_name}
          </LibraryReact.MaxHeightWrap>
        </div>
        <div className="flex11a displayFlexRowVc lrMedPad" style={{flexBasis:"100em"}}>
          <LibraryReact.MaxHeightWrap p_maxHeight="4em" p_fontClass="font11 fontItalic fontTextLighter">
            {templateObj.notes}
          </LibraryReact.MaxHeightWrap>
        </div>
      </div>
    );
  }
}







//=============================================================================================================================================================================
//=============================================================================================================================================================================
//Other functions
const DivexecEditUserMoneyField = inject("DivexecMobx", "DatabaseMobx", "UserMobx")(observer(
class DivexecEditUserMoneyField extends Component { //props: p_userFieldDbName, p_valuesToNotIncludeArray
  componentDidMount() {
    const userFieldDbName = this.props.p_userFieldDbName;
    const valuesToNotIncludeArray = this.props.p_valuesToNotIncludeArray;

    //if the user has an option selected that is not available in their pull down list of fields for their goals, assign them the first available one
    if(JSFUNC.is_array(valuesToNotIncludeArray) && (valuesToNotIncludeArray.length > 0)) {
      const performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined = this.props.DivexecMobx.c_performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined;
      if(performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined !== undefined) { //if a field is selected
        if(JSFUNC.in_array(performanceUserSelectedMoneyExpandedCaptureFieldMapOrUndefined.get("id"), valuesToNotIncludeArray)) { //if the selected field is one of the fields to not include
          const selectCaptureRevenueCardMoneyFieldFieldTypeObj = this.props.DatabaseMobx.c_selectCaptureRevenueCardMoneyFieldFieldTypeObj;
          if(selectCaptureRevenueCardMoneyFieldFieldTypeObj.selectWithSearchDataObj !== undefined) {
            if(JSFUNC.is_array(selectCaptureRevenueCardMoneyFieldFieldTypeObj.selectWithSearchDataObj.valueArray)) {
              for(let revenueCardMoneyFieldID of selectCaptureRevenueCardMoneyFieldFieldTypeObj.selectWithSearchDataObj.valueArray) {
                if(!JSFUNC.in_array(revenueCardMoneyFieldID, valuesToNotIncludeArray)) { //if this money field is  one of the valid ones listed as a choice for the user to select
                  this.props.UserMobx.a_update_logged_in_user_field(userFieldDbName, revenueCardMoneyFieldID, "i");
                  break;
                }
              }
            }
          }
        }
      }
    }
  }

  onselect_finproj_money_field = (i_newValue) => {
    const userFieldDbName = this.props.p_userFieldDbName;
    this.props.UserMobx.a_update_logged_in_user_field(userFieldDbName, i_newValue, "i");
  }

  render() {
    const userFieldDbName = this.props.p_userFieldDbName;
    const valuesToNotIncludeArray = this.props.p_valuesToNotIncludeArray;

    const moneyFieldID = this.props.UserMobx.c_combinedUserObj[userFieldDbName];

    return(
      <div style={{width:"25em"}}>
        <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="fontItalic fontTextLight">
          {"Select Capture $ Value Field to use"}
        </LibraryReact.DivFont>
        <CEGeneralReact.CaptureExecFieldEditSaveCancel
          p_ceEditItemString={"divexecUserMoneyField_" + userFieldDbName}
          p_fieldTypeObj={this.props.DatabaseMobx.c_selectCaptureRevenueCardMoneyFieldFieldTypeObj}
          p_valueRaw={moneyFieldID}
          p_valueIsEditableTFU="true"
          p_valuesToNotIncludeArray={valuesToNotIncludeArray}
          f_onSaveChanged={this.onselect_finproj_money_field}
        />
      </div>
    );
  }
}));




const DivexecSelectFilterDivisions = inject("DatabaseMobx", "UserMobx")(observer(
class DivexecSelectFilterDivisions extends Component {
  onchange_filter_divisions = (i_selectedDivisionIDsComma) => {
    this.props.UserMobx.a_update_logged_in_user_field("divexec_filter_division_ids_comma", i_selectedDivisionIDsComma, "s");
  }

  render() {
    const c_combinedUserObj = this.props.UserMobx.c_combinedUserObj;

    const divexecFilterDivisionsIsFilledOutTF = JSFUNC.selectmulti_is_filled_out_tf(c_combinedUserObj.divexec_filter_division_ids_comma);

    return(
      <>
        <CEGeneralReact.CaptureExecFieldEditSaveCancel
          p_ceEditItemString="divexecHotBitsManualFilterDivisions"
          p_fieldDisplayName={this.props.DatabaseMobx.c_fieldMapOfDivisionOwners.get("display_name")}
          p_fieldTypeObj={this.props.DatabaseMobx.c_selectMultiDivisionsFieldTypeObj}
          p_valueRaw={c_combinedUserObj.divexec_filter_division_ids_comma}
          p_valueIsEditableTFU={true}
          p_containerClass="tbMicroPad"
          p_fieldClass="font11 fontBold fontItalic fontTextLighter"
          p_fieldWidth="10em"
          p_valueClass=""
          p_valueMaxHeight="4.4em"
          f_onSaveChanged={this.onchange_filter_divisions}
        />
        {(!divexecFilterDivisionsIsFilledOutTF) &&
          <CEGeneralReact.ErrorText p_text="No Divisions selected, select Division(s) here to view data" />
        }
      </>
    );
  }
}));

//=================================================================================================================================================================================================
//Gate Review Approvals
//=================================================================================================================================================================================================
export const GateReviewApprovals = inject("DivexecMobx", "DatabaseMobx")(observer(
class GateReviewApprovals extends Component {
  componentDidMount() {
    this.props.DivexecMobx.a_gate_review_approvals_load_log_stages();
  }

  onclick_refresh_gate_review_approvals = () => {
    this.props.DivexecMobx.a_gate_review_approvals_load_log_stages();
  }

  render() {
    const o_gateReviewApprovalsLogStagesArrayOfObjs = this.props.DivexecMobx.o_gateReviewApprovalsLogStagesArrayOfObjs;
    const o_gateReviewApprovalsIsLoadingTF = this.props.DivexecMobx.o_gateReviewApprovalsIsLoadingTF;
    const o_gateReviewApprovalsActionPendingObjOrUndefined = this.props.DivexecMobx.o_gateReviewApprovalsActionPendingObjOrUndefined;
    const c_gateReviewApprovalsPendingRequestsArrayOfObjs = this.props.DivexecMobx.c_gateReviewApprovalsPendingRequestsArrayOfObjs;

    const numPendingRequests = c_gateReviewApprovalsPendingRequestsArrayOfObjs.length;

    return(
      <>
        <div className="displayFlexRow borderB1bbb bgLighterGreen tbMicroPad" style={{minHeight:"3.3em"}}>
          <div className="flex11a displayFlexColumnVc lrMedPad" style={{flexBasis:"100em"}}>
            <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="font13 fontBold fontItalic fontUnderline fontDarkGreen">
              {"Gate Review Approvals"}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_fontClass="font11 fontBold">
              {"Gate Review Requests Awaiting Your Approval"}
            </LibraryReact.DivFont>
          </div>
          <div className="flex00a displayFlexColumnVc lrMedPad" style={{flexBasis:"10em"}}>
            <CEGeneralReact.CEButton
              p_type="gray"
              p_text="Refresh"
              p_title="Reload the list of Gate Review requests awaiting your approval"
              f_onClick={this.onclick_refresh_gate_review_approvals}
            />
          </div>
        </div>
        <div className="flex11a yScroll yScrollBottomPad medFullPad bgLighterGray">
          {(o_gateReviewApprovalsIsLoadingTF && (o_gateReviewApprovalsLogStagesArrayOfObjs === undefined)) ? (
            <CEGeneralReact.EmptyScreenGrayWithLoadingAnimation>
              {"Loading Gate Review requests..."}
            </CEGeneralReact.EmptyScreenGrayWithLoadingAnimation>
          ) : (
            (numPendingRequests === 0) ? (
              <CEGeneralReact.EmptyScreenGray>
                {"There are no Gate Review requests awaiting your approval"}
              </CEGeneralReact.EmptyScreenGray>
            ) : (
              c_gateReviewApprovalsPendingRequestsArrayOfObjs.map((m_pendingRequestObj) =>
                <GateReviewApprovalsSingleRequestRow
                  key={m_pendingRequestObj.logID}
                  p_pendingRequestObj={m_pendingRequestObj}
                />
              )
            )
          )}
        </div>
        {(o_gateReviewApprovalsActionPendingObjOrUndefined !== undefined) &&
          <GateReviewApprovalsActionFloatingBox
            p_actionPendingObj={o_gateReviewApprovalsActionPendingObjOrUndefined}
          />
        }
      </>
    );
  }
}));


const GateReviewApprovalsSingleRequestRow = inject("DivexecMobx", "OpenCaptureMobx", "DatabaseMobx")(observer(
class GateReviewApprovalsSingleRequestRow extends Component { //props: p_pendingRequestObj
  onclick_open_capture_to_advance_stage_card = () => {
    const p_pendingRequestObj = this.props.p_pendingRequestObj;

    const functionOnSuccess = (i_parseResponse) => {
      this.props.OpenCaptureMobx.a_launch_card_full(this.props.DatabaseMobx.k_cardIDAdvanceStage);
    }
    this.props.OpenCaptureMobx.a_open_single_capture(p_pendingRequestObj.captureID, functionOnSuccess);
  }

  onclick_approve = () => {
    this.props.DivexecMobx.a_gate_review_approvals_set_action_pending_obj({pendingRequestObj:this.props.p_pendingRequestObj, action2App3Rej:2});
  }

  onclick_reject = () => {
    this.props.DivexecMobx.a_gate_review_approvals_set_action_pending_obj({pendingRequestObj:this.props.p_pendingRequestObj, action2App3Rej:3});
  }

  render() {
    const p_pendingRequestObj = this.props.p_pendingRequestObj;

    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;

    const stageFieldDisplayName = c_fieldMapOfStage.get("display_name");

    return(
      <div className="displayFlexRow smallBottomMargin border1bbb borderRadius05 overflowHidden bgWhite">
        <div
          className="flex00a displayFlexColumnHcVc bgRedCapture hoverRedCapture cursorPointer borderR1bbb"
          style={{flexBasis:"3.5em"}}
          title={"Click to open the Capture '" + p_pendingRequestObj.captureName + "' to its Advance " + stageFieldDisplayName + " card to review this Gate Review request"}
          onClick={this.onclick_open_capture_to_advance_stage_card}>
          <CEIconsReact.SvgOpenCapture
            p_sizeEm={1.6}
            p_color="fff"
          />
        </div>
        <div className="flex11a lrMedPad tbMedPad" style={{flexBasis:"100em"}}>
          <LibraryReact.DivFont p_fontClass="font11 fontBold">
            {p_pendingRequestObj.captureName}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="microTopMargin" p_fontClass="fontItalic fontTextLight">
            {"Gate Review '" + p_pendingRequestObj.gateReviewName + "' to enter " + stageFieldDisplayName + " '" + p_pendingRequestObj.stageName + "'"}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="microTopMargin" p_fontClass="fontItalic fontTextLighter">
            {"Requested by " + p_pendingRequestObj.requestedByUserName + " on " + p_pendingRequestObj.requestedDateMaskPlainText}
          </LibraryReact.DivFont>
          {(p_pendingRequestObj.requestComment !== "") &&
            <LibraryReact.DivFont p_class="microTopMargin" p_fontClass="fontItalic">
              {"\"" + p_pendingRequestObj.requestComment + "\""}
            </LibraryReact.DivFont>
          }
        </div>
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"7em"}}>
          <CEGeneralReact.CEButton
            p_type="green"
            p_text="Approve"
            p_title={"Approve this Gate Review request, which moves this Capture into " + stageFieldDisplayName + " '" + p_pendingRequestObj.stageName + "'"}
            f_onClick={this.onclick_approve}
          />
        </div>
        <div className="flex00a" style={{flexBasis:"0.5em"}} />
        <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"7em"}}>
          <CEGeneralReact.CEButton
            p_type="red"
            p_text="Reject"
            p_title={"Reject this Gate Review request, which leaves this Capture in its current " + stageFieldDisplayName}
            f_onClick={this.onclick_reject}
          />
        </div>
        <div className="flex00a" style={{flexBasis:"0.8em"}} />
      </div>
    );
  }
}));


const GateReviewApprovalsActionFloatingBox = inject("DivexecMobx", "OpenCaptureMobx", "DatabaseMobx")(observer(
class GateReviewApprovalsActionFloatingBox extends Component { //props: p_actionPendingObj
  constructor(props) {
    super(props);
    this.state = {
      s_comment: ""
    };
  }

  onchange_comment = (i_newValue) => {
    this.setState({s_comment:i_newValue});
  }

  onclick_cancel = () => {
    this.props.DivexecMobx.a_gate_review_approvals_set_action_pending_obj(undefined);
  }

  onclick_save_gate_review_action = () => {
    const p_actionPendingObj = this.props.p_actionPendingObj;
    const s_comment = this.state.s_comment;

    const pendingRequestObj = p_actionPendingObj.pendingRequestObj;

    //an approved Gate Review automatically moves the capture into the stage the Gate Review was set on (injected here so that DivexecMobx does not have to import OpenCaptureMobx)
    const functionAdvanceCaptureIntoStageOnApproval = (i_captureID, i_stageID) => {
      this.props.OpenCaptureMobx.a_details_update_field_value(this.props.DatabaseMobx.c_fieldMapOfStage, i_stageID, i_captureID);
    }

    this.props.DivexecMobx.a_gate_review_approvals_approve_or_reject(pendingRequestObj, p_actionPendingObj.action2App3Rej, s_comment, functionAdvanceCaptureIntoStageOnApproval);
  }

  render() {
    const p_actionPendingObj = this.props.p_actionPendingObj;
    const s_comment = this.state.s_comment;

    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;

    const stageFieldDisplayName = c_fieldMapOfStage.get("display_name");
    const pendingRequestObj = p_actionPendingObj.pendingRequestObj;
    const approveTF = (p_actionPendingObj.action2App3Rej === 2);

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="smallVertical"
        p_title={((approveTF) ? ("Approve") : ("Reject")) + " Gate Review '" + pendingRequestObj.gateReviewName + "' to enter " + stageFieldDisplayName + " '" + pendingRequestObj.stageName + "'"}
        f_onClickCancel={this.onclick_cancel}>
        <div className="flex11a yScroll medFullPad">
          <LibraryReact.DivFont p_fontClass="font11 fontBold">
            {pendingRequestObj.captureName}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="smallTopMargin" p_fontClass="fontItalic fontTextLight">
            {((approveTF) ? ("Approving") : ("Rejecting")) + " this Gate Review to enter " + stageFieldDisplayName + " '" + pendingRequestObj.stageName + "'"}
          </LibraryReact.DivFont>
          <LibraryReact.DivFont p_class="smallTopMargin" p_fontClass="fontItalic fontTextLighter">
            {"Requested by " + pendingRequestObj.requestedByUserName + " on " + pendingRequestObj.requestedDateMaskPlainText}
          </LibraryReact.DivFont>
          {(pendingRequestObj.requestComment !== "") &&
            <LibraryReact.DivFont p_class="smallTopMargin" p_fontClass="fontItalic">
              {"\"" + pendingRequestObj.requestComment + "\""}
            </LibraryReact.DivFont>
          }
          {(approveTF) &&
            <LibraryReact.DivFont p_class="medTopMargin" p_fontClass="fontItalic fontTextLight">
              {"Approving automatically advances this Capture into " + stageFieldDisplayName + " '" + pendingRequestObj.stageName + "'"}
            </LibraryReact.DivFont>
          }
          <LibraryReact.DivFont p_class="medTopMargin microBottomMargin" p_fontClass="fontBold fontItalic fontTextLighter">
            {"Comment (optional)"}
          </LibraryReact.DivFont>
          <LibraryReact.Textarea
            p_value={s_comment}
            p_styleObj={{height:"8em"}}
            p_tabIndex={1}
            f_onChange={this.onchange_comment}
          />
          <div className="displayFlexRowHcVc medTopMargin">
            <div className="flex00a lrMedMargin">
              <CEGeneralReact.CEButton
                p_type={((approveTF) ? ("green") : ("red"))}
                p_text={((approveTF) ? ("Approve Gate Review") : ("Reject Gate Review"))}
                p_title={((approveTF) ? ("Approving this Gate Review automatically moves this Capture into " + stageFieldDisplayName + " '" + pendingRequestObj.stageName + "'") : ("Rejecting this Gate Review keeps this Capture blocked from moving into " + stageFieldDisplayName + " '" + pendingRequestObj.stageName + "'"))}
                p_tabIndex={2}
                f_onClick={this.onclick_save_gate_review_action}
              />
            </div>
          </div>
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));
